<template>
  <div>
    <b-container>
      <!-- back button, possibility to add other buttons in a row -->
      <b-button
        size="sm"
        style="margin-bottom: 15px"
        variant="darkblue"
        @click="$router.push('/videos')"
        title="Back to videos list"
      >
        <font-awesome-icon :icon="['fas', 'caret-left']"></font-awesome-icon>
        Videos
      </b-button>
      &nbsp;
      <b-button
        size="sm"
        v-if="$auth.getMyUser().roles.indexOf('admin') > -1"
        style="margin-bottom: 15px"
        variant="darkblue"
        @click="$router.push('/videosadmin/' + uuid)"
        title="Admin"
      >
        <font-awesome-icon :icon="['fas', 'caret-left']"></font-awesome-icon
        >&nbsp; Admin
      </b-button>

      <!-- Title -->
      <b-row
        v-if="isVideoLoaded && !modifyTitle"
        class="align-items-center justify-content-center mb-2"
      >
        <!--
        <font-awesome-layers v-if="video.type === 'live' && video.encodingStatus === 'encoding'" style="color: #ba0000; margin-right:10px">
          <font-awesome-icon transform="left-28" icon="circle-notch" spin />
          <font-awesome-icon icon="stop" transform="grow-2 left-3" />
          <font-awesome-icon icon="stop" transform="grow-2 left-14" />
          <font-awesome-icon icon="video" transform="grow-2"/>

          <font-awesome-layers-text 
                transform="shrink-7 left-8" 
                value="LIVE"
                style="color:white; font-weight:700"
          />
        </font-awesome-layers>
        <font-awesome-layers v-else-if="video.type === 'live'" style="color: #787976; margin-right:10px">
          <font-awesome-icon icon="stop" transform="grow-2 left-3" />
          <font-awesome-icon icon="stop" transform="grow-2 left-14" />
          <font-awesome-icon icon="video" transform="grow-2"/>

          <font-awesome-layers-text 
                transform="shrink-7 left-8" 
                value="LIVE"
                style="color:white; font-weight:700"
          />
        </font-awesome-layers>
        -->

        <b-badge
          v-if="video.type === 'live' && video.encodingStatus === 'encoding'"
          style="
            font-size: 11px;
            background-color: #ba0000;
            padding: 5px;
            margin-right: 10px;
          "
          title="Live stream, on air"
        >
          <div class="d-flex align-items-center">
            <font-awesome-icon
              transform="shrink-2"
              style="margin-right: 2px"
              icon="circle-notch"
              spin
            />
            LIVE&nbsp;
            <b-img
              v-if="video.liveCamera === true"
              :src="require(`@/assets/webcam_W.png`)"
              style="max-height: 10px; color: white"
              title="From camera"
            />
            <font-awesome-icon
              v-if="
                video.liveCamera !== true && video.liveType === 'quanteecRTMP'
              "
              :icon="['fab', 'affiliatetheme']"
              title="From streaming software (RTMP)"
            />
            <font-awesome-icon
              v-if="video.liveCamera !== true && video.liveType === 'custom'"
              :icon="['fas', 'stream']"
              title="Custom stream"
            />
          </div>
        </b-badge>
        <b-badge
          variant="secondary"
          v-else-if="video.type === 'live'"
          style="font-size: 11px; padding: 5px; margin-right: 10px"
          title="Live stream, stopped"
        >
          <div class="d-flex align-items-center">
            LIVE&nbsp;
            <b-img
              v-if="video.liveCamera === true"
              :src="require(`@/assets/webcam_W.png`)"
              style="max-height: 10px; color: white"
              title="From camera"
            />
            <font-awesome-icon
              v-if="
                video.liveCamera !== true && video.liveType === 'quanteecRTMP'
              "
              :icon="['fab', 'affiliatetheme']"
              title="From streaming software (RTMP)"
            />
            <font-awesome-icon
              v-if="video.liveCamera !== true && video.liveType === 'custom'"
              :icon="['fas', 'stream']"
              title="Custom stream"
            />
          </div>
        </b-badge>

        <h6 style="margin-top: 10px; display: flex; word-break: break-all">
          {{ title }}
          &nbsp;
          <b-button @click="modifyTitle = !modifyTitle" variant="emptyB">
            <font-awesome-icon :icon="['fas', 'pencil-alt']" />
          </b-button>
        </h6>
      </b-row>
      <b-row class="justify-content-center">
        <div
          v-if="isVideoLoaded && modifyTitle"
          style="width: 500px; margin: 10px"
        >
          <b-form @submit.prevent="updateTitle">
            <b-input-group prepend="Title: ">
              <b-input class="col-11" type="text" v-model="title"></b-input>
              <b-button variant="bordered" @click="updateTitle">
                <font-awesome-icon
                  class="pointerEltSB"
                  style="color: #14bf98"
                  :icon="['fas', 'check']"
                />
              </b-button>
              <b-button variant="borderedx" @click="cancelTitle">
                <font-awesome-icon
                  class="pointerEltSB"
                  style="color: red"
                  :icon="['fas', 'times']"
                />
              </b-button>
            </b-input-group>
          </b-form>
        </div>
      </b-row>
      <!-- Author -->
      <p
        class="justify-content-center"
        style="
          display: flex;
          overflow: auto;
          white-space: nowrap;
          padding-bottom: 3px;
        "
      >
        <i>{{ $ml.get("by") }} {{ video.user }}</i>
      </p>

      <!-- Video -->

      <b-row>
        <b-col lg="9" md="12" cols="12">
          <div id="video-player-container" class="resp-container">
            <iframe
              ref="mainIframe"
              v-if="iframeinit"
              id="video-player"
              class="resp-iframe"
              allowfullscreen="true"
              webkitallowfullscreen="true"
              mozallowfullscreen="true"
              frameborder="0"
              scrolling="no"
              @onerror="iframeinit = false"
              :src="iframesrc"
            />
            <div v-if="iframeinit"></div>
          </div>
        </b-col>
        <b-col lg="3" md="12" cols="12">
          <b-row>
            <b-col cols="12">
              <b-card style="background-color: #f2f2f2">
                <p class="titleSec" style="margin-bottom: 0px">
                  <font-awesome-layers style="margin-right: 2px">
                    <font-awesome-icon icon="play" transform="shrink-9" />
                    <font-awesome-icon
                      :icon="['far', 'comment-alt']"
                      transform="grow-4 down-2"
                    />
                  </font-awesome-layers>
                  &nbsp;
                  {{ $ml.get("projectsuv") }}
                </p>
                <b-card-body>
                  <b-card-text>
                    <b-table
                      v-if="projects.length > 0"
                      bordered
                      hover
                      thead-class="d-none"
                      :fields="tableProjects"
                      :items="projects"
                      fixed
                    >
                      <template #cell(name)="data">
                        <div
                          style="cursor: pointer"
                          :id="data.item.uuid"
                          @click="
                            goToProject(data.item.uuid, data.item.currentVersion)
                          "
                        >
                          <small>{{ data.item.name }}</small>
                        </div>

                        <b-popover
                          :target="data.item.uuid"
                          triggers="hover"
                          placement="top"
                          style="text-align: center"
                        >
                          <template #title>
                            <small>
                              <strong>{{ data.item.name }}</strong>
                            </small>
                          </template>
                          <small>
                            <b-row class="justify-content-center m-0 p-0">
                              <i>{{ $ml.get("by") }} {{ data.item.user }}</i>
                            </b-row>
                            <strong>{{ $ml.get("desc") }}</strong>
                            {{ data.item.description }}<br />
                            <strong>{{ $ml.get("currentv") }}</strong> v{{
                              data.item.currentVersion
                            }}<br />
                          </small>
                        </b-popover>
                      </template>
                    </b-table>
                  </b-card-text>

                  <b-card-text
                    style="margin-bottom: 30px"
                    v-if="projects.length === 0"
                  >
                    <small>{{ $ml.get("none") }}</small>
                  </b-card-text>

                  <b-row class="justify-content-center">
                    <b-button
                      size="sm"
                      @click="createProject()"
                      variant="msstreamblue"
                    >
                      <b-icon icon="plus-circle" />&nbsp;
                      {{ $ml.get("createnp") }}
                    </b-button>
                  </b-row>
                </b-card-body>
                <div style="font-size: 10px">{{ $ml.get("onlyp") }}</div>
              </b-card>
            </b-col>
          </b-row>
          <b-row class="marginaltop">
            <b-col cols="12">
              <b-card style="background-color: #f2f2f2">
                <p class="titleSec" style="margin-bottom: 0px">
                  <b-icon icon="card-image" />&nbsp;
                  &nbsp;
                  {{ $ml.get("generatethumbnailfrompicture") }}
                </p>
                <b-card-body>
                  <b-row class="justify-content-center">
                    <b-button
                      size="sm"
                      @click="getCurrentTime()"
                      variant="msstreamblue"
                    >
                      <b-icon icon="card-image" />&nbsp;
                      {{ $ml.get("createthumbnail") }}
                      &nbsp;
                      <b-spinner
                    small
                    variant="light"
                    v-if="isLoadingGenerateThumbnail"
                  ></b-spinner>
                    </b-button>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
          <!--<b-card style="margin-top:10px; background-color: #f2f2f2">
              <p class="titleSec" style="margin-bottom:0px">
                &nbsp; 
                Chat for this live

              </p>
            <b-card-body>
              <VideoChat v-bind:room-id="uuid"></VideoChat>
            </b-card-body>
          </b-card>-->
        </b-col>
      </b-row>

      <!-- Video Infos & Video parameters panels -->
      <b-row>
        <!-- Video Info panel on the left -->
        <b-col cols="12" md="6" class="mypanel">
          <!-- Panel title -->
          <h5
            style="
              text-align: center;
              color: #2a5d77;
              padding-bottom: 5px;
              margin-bottom: 15px;
              border-bottom: 1px solid #2a5d77;
            "
          >
            <b-img
              fluid
              :src="require(`@/assets/logo.svg`)"
              style="max-height: 20px"
            />
            &nbsp;
            {{ $ml.get("videoinfos") }}
          </h5>
          <!--<b-row class="justify-content-center marginalsm" v-if="(video.encodingStatus === 'stopped' || video.encodingStatus === 'error') && video.type === 'live' && video.liveCamera === true">
            <b-col cols="auto">
              <b-button variant="msstreamblue" @click="openLiveWebcam()">
                <font-awesome-icon :icon="['fas', 'video']" ></font-awesome-icon>
                Restart live from webcam
              </b-button>
            </b-col>
          </b-row>-->

          <b-row
            class="justify-content-between align-items-center"
            style="padding-right: 15px; padding-left: 15px"
          >
            <small>
              <strong style="margin-right: 0.3rem">ID:</strong> {{ video.uuid }}
            </small>
          </b-row>

          <div style="margin: 1rem 3rem; border-bottom: 1px solid white"></div>

          <b-row
            class="justify-content-between align-items-center"
            style="padding-right: 15px; padding-left: 15px"
          >
            <small style="margin: 0.3rem 0rem">
              <strong>{{ $ml.get("creationdate") }}:</strong>&nbsp;
              <font-awesome-icon :icon="['fas', 'calendar-minus']" />
              {{ createdDate }}
            </small>
            <small style="margin: 0.3rem 10px" v-if="video.type !== 'live'">
              <strong>{{ $ml.get("duration") }}:</strong>&nbsp;
              <font-awesome-icon :icon="['fas', 'clock']" />
              {{ fancyDurationFormat }}
            </small>
            <small
              style="margin: 0.3rem 10px"
              v-if="video.type === 'live' && video.keepLive"
            >
              <strong>{{ $ml.get("totalld") }}:</strong>&nbsp;
              <font-awesome-icon :icon="['fas', 'clock']" />
              {{ fancyDurationFormat }}
            </small>
            <small style="margin: 0.3rem" v-else></small>
            <small
              style="margin: 0.3rem 0rem"
              :style="
                video.lastModifyAt === video.createdAt ? 'color:#9a9fa2' : ''
              "
              :title="
                video.lastModifyAt === video.createdAt
                  ? 'Not yet modified, same as original'
                  : 'Date of last modification'
              "
            >
              <strong>{{ $ml.get("modifdate") }}:</strong>&nbsp;
              <font-awesome-layers>
                <font-awesome-icon
                  :icon="['fas', 'circle']"
                  transform="shrink-12"
                />
                <font-awesome-icon :icon="['fas', 'redo-alt']" />
              </font-awesome-layers>
              {{ lastModifyAt }}
            </small>
          </b-row>

          <div style="margin: 1rem 3rem; border-bottom: 1px solid white"></div>

          <b-row
            class="justify-content-between align-items-center"
            style="padding-right: 15px; padding-left: 15px"
          >
            <small>
              <strong style="margin-right: 0.3rem"
                >{{ $ml.get("type") }}:</strong
              >&nbsp;
              <span
                style="color: #ba0000"
                v-if="
                  video.type === 'live' &&
                  (video.encodingStatus === 'encoding' ||
                    video.encodingStatus === 'segmented')
                "
              >
                <font-awesome-icon
                  :icon="['fas', 'circle-notch']"
                  transform="shrink-4"
                  spin
                  title="Live, on air"
                />
                <font-awesome-icon
                  style="margin-right: 0.3rem"
                  :icon="['fas', 'video']"
                  title="On air"
                  transform="left-3"
                />
                {{ $ml.get("ongoingls") }}
              </span>
              <span
                style="color: #ba0000"
                v-else-if="
                  video.type === 'vod' &&
                  (video.encodingStatus === 'encoding' ||
                    video.encodingStatus === 'segmented')
                "
              >
                <font-awesome-icon
                  style="margin-right: 0.3rem"
                  v-if="video.type === 'vod'"
                  :icon="['fas', 'film']"
                  title="VOD, processing..."
                />
                {{ $ml.get("vodcp") }}
              </span>
              <span
                style="color: #2f90b0"
                v-else-if="
                  video.encodingStatus === 'encoded' && video.type === 'live'
                "
              >
                <font-awesome-icon
                  style="margin-right: 0.3rem"
                  :icon="['fas', 'video']"
                  title="Live stream"
                />
                {{ $ml.get("ls") }}

                <!--<span v-if="video.keepLive === false" style="color:red"> - Not kept as a VOD</span>-->
              </span>
              <span
                style="color: #2f90b0"
                v-else-if="
                  video.encodingStatus === 'encoded' && video.type === 'vod'
                "
              >
                <font-awesome-layers style="margin-right: 5px">
                  <font-awesome-icon
                    style="color: #2f90b0"
                    :icon="['fas', 'video']"
                    transform="shrink-5 right-6 up-6"
                    v-if="video.archive"
                    title="Archive from a Live"
                  />
                  <font-awesome-icon
                    style="color: #2f90b0"
                    :icon="['fas', 'cut']"
                    transform="shrink-5 left-7 up-6"
                    v-if="video.inAndOutOrigin"
                    title="Cut-version"
                  />
                  <font-awesome-icon
                    style="color: #2f90b0"
                    :icon="['fas', 'film']"
                    title="VOD"
                  />
                </font-awesome-layers>
                VOD
                <span v-if="video.inAndOutOrigin">
                  -
                  <a :href="'/#/player/' + video.inAndOutOrigin">
                    <b-button
                      variant="cut"
                      size="sm"
                      title="Click to go to original VOD from which the Cut has been created"
                    >
                      <font-awesome-icon icon="eye" />
                      {{ $ml.get("cutversion") }}
                    </b-button>
                  </a>
                </span>
                <span v-if="video.archive">
                  -
                  <a :href="'/#/player/' + video.archiveLive">
                    <b-button
                      variant="archive"
                      size="sm"
                      title="Click to go to original Live stream from which the Archive has been created"
                    >
                      <font-awesome-icon icon="eye" />
                      {{ $ml.get("archivefl") }}
                    </b-button>
                  </a>
                </span>
              </span>
              <span
                style="color: black"
                v-else-if="
                  video.encodingStatus === 'stopped' && video.type === 'live'
                "
              >
                <font-awesome-icon
                  style="margin-right: 0.3rem"
                  :icon="['fas', 'video']"
                  title="Live stream, stopped."
                />
                {{ $ml.get("livess") }}

                <!--<span v-if="video.keepLive === false" style="color:red"> Not kept as a VOD</span>-->
              </span>
              <span
                style="color: black"
                v-else-if="
                  video.encodingStatus === 'stopped' && video.type === 'vod'
                "
              >
                <font-awesome-icon
                  style="margin-right: 0.3rem"
                  v-if="video.type === 'vod'"
                  :icon="['fas', 'film']"
                  title="VOD, processing stopped."
                />
                {{ $ml.get("vodff") }}
              </span>
              <span
                style="color: #14bf98"
                v-else-if="
                  video.encodingStatus === 'uploading' && video.type === 'live'
                "
              >
                <font-awesome-icon
                  style="margin-right: 0.3rem"
                  :icon="['fas', 'video']"
                  title="Live stream, starting (up to 30s)..."
                />
                {{ $ml.get("livess30") }}
              </span>
              <span
                style="color: #14bf98"
                v-else-if="
                  video.encodingStatus === 'uploading' && video.type === 'vod'
                "
              >
                <font-awesome-icon
                  style="margin-right: 0.3rem"
                  v-if="video.type === 'vod'"
                  :icon="['fas', 'film']"
                  title="Video from file, uploading..."
                />
                {{ $ml.get("vodupl") }}
              </span>
              <span
                style="color: red"
                v-else-if="
                  video.encodingStatus === 'error' && video.type === 'live'
                "
              >
                <font-awesome-icon
                  style="margin-right: 0.3rem"
                  :icon="['fas', 'video']"
                  title="Live stream, error"
                />
                {{ $ml.get("liveerr") }}
              </span>
              <span
                style="color: red"
                v-else-if="
                  video.encodingStatus === 'error' && video.type === 'vod'
                "
              >
                <font-awesome-icon
                  style="margin-right: 0.3rem"
                  :icon="['fas', 'film']"
                  title="VOD, error"
                />
                {{ $ml.get("voderr") }}
              </span>
              <span style="color: orange" v-else-if="video.type === 'live'">
                <font-awesome-icon
                  style="margin-right: 0.3rem"
                  :icon="['fas', 'video']"
                  title="Live stream, processing..."
                />
                {{ $ml.get("livespro") }}
              </span>
              <span style="color: orange" v-else-if="video.type === 'vod'">
                <font-awesome-icon
                  style="margin-right: 0.3rem"
                  :icon="['fas', 'film']"
                  title="VOD, processing..."
                />
                {{ $ml.get("vodpro") }}
              </span>
            </small>

            <small style="margin-right: 10px; margin-left: 10px">
              <div
                class="d-flex align-items-center"
                v-if="video.liveCamera === true"
              >
                <b-img
                  fluid
                  :src="require(`@/assets/webcam.png`)"
                  style="max-height: 17px; margin-right: 5px"
                  title="From camera"
                />
                {{ $ml.get("fromc") }}
              </div>
              <div
                class="d-flex align-items-center"
                v-if="
                  video.liveCamera !== true && video.liveType === 'quanteecRTMP'
                "
              >
                <font-awesome-icon
                  v-if="video.liveCamera !== true"
                  :icon="['fab', 'affiliatetheme']"
                  style="margin-right: 5px"
                  title="From streaming software (RTMP)"
                />
                {{ $ml.get("fromss") }}
              </div>
              <div
                class="d-flex align-items-center"
                v-if="video.liveCamera !== true && video.liveType === 'custom'"
              >
                <font-awesome-icon
                  :icon="['fas', 'stream']"
                  style="margin-right: 5px"
                  title="Custom stream"
                />
                {{ $ml.get("customs") }}
              </div>
            </small>

            <b-form-checkbox
              style="margin-right: 10px; min-height: 0px"
              v-if="video.type === 'live'"
              size="sm"
              v-model="isKeepLive"
              switch
              @input="updateKeepLive()"
            >
              <font-awesome-layers
                style="margin: 0px 10px 0px 5px"
                v-if="isKeepLive === true"
                size="sm"
              >
                <font-awesome-icon
                  style="color: #2a5d77"
                  :icon="['fas', 'video']"
                  transform="shrink-5 right-6 up-6"
                />
                <font-awesome-icon
                  style="color: #2a5d77"
                  :icon="['fas', 'film']"
                />
                <font-awesome-icon
                  size="sm"
                  style="color: #14bf98"
                  :icon="['fas', 'check-circle']"
                  transform="shrink-4 down-4 right-13"
                />
              </font-awesome-layers>

              <font-awesome-layers
                style="margin: 0px 10px 0px 5px"
                v-if="isKeepLive === false"
                size="sm"
              >
                <font-awesome-icon
                  style="color: #2a5d77"
                  :icon="['fas', 'video']"
                  transform="shrink-5 right-6 up-6"
                />
                <font-awesome-icon
                  style="color: #2a5d77"
                  :icon="['fas', 'film']"
                />
                <font-awesome-icon
                  size="sm"
                  style="color: red"
                  :icon="['fas', 'minus-circle']"
                  transform="shrink-4 down-4 right-13"
                />
              </font-awesome-layers>

              <small>
                {{
                  isKeepLive ? $ml.get("keptasvod") : $ml.get("notkeptasvod")
                }}

                <sup
                  ><font-awesome-icon
                    style="margin-left: -4px"
                    size="sm"
                    id="popover1"
                    icon="question-circle"
                /></sup>
                <b-popover
                  size="sm"
                  target="popover1"
                  triggers="hover"
                  placement="top"
                >
                  <template #title><small>Live-to-VOD</small></template>
                  <small>
                    <span v-html="$ml.get('vodarchivestxt')"></span>
                    <br />
                    <font-awesome-icon
                      style="color: red"
                      icon="exclamation-triangle"
                    />
                    <span v-html="$ml.get('changingpara')"></span>
                  </small>
                </b-popover>
              </small>
            </b-form-checkbox>

            <b-button
              size="sm"
              variant="archiveopen"
              v-if="
                isVideoLoaded &&
                video.type === 'live' &&
                video.archivesFromLiveSize > 0
              "
              @click="showArchives = !showArchives"
              :title="
                video.archivesFromLiveSize +
                ' archive(s) created from this Live stream. Click to see the list.'
              "
            >
              <b-badge variant="info">{{ video.archivesFromLiveSize }}</b-badge>
              <font-awesome-icon
                v-if="showArchives"
                size="xs"
                style="margin-left: 3px"
                icon="chevron-up"
              />
              <font-awesome-icon
                v-else
                size="xs"
                style="margin-left: 3px"
                icon="chevron-down"
              />
            </b-button>

            <b-button
              size="sm"
              variant="cutopen"
              v-if="
                isVideoLoaded && video.type === 'vod' && !video.inAndOutOrigin
              "
              @click="showCut = !showCut"
              :title="
                video.videoInAndOutSize +
                ' cut-versions created from this video. Click to see the list.'
              "
            >
              <font-awesome-icon icon="cut" />
              <sup
                ><font-awesome-icon
                  size="sm"
                  style="margin-right: 5px"
                  id="popover2"
                  icon="question-circle"
              /></sup>

              <b-badge variant="success" v-if="video.videoInAndOutSize">{{
                video.videoInAndOutSize
              }}</b-badge>
              <b-badge variant="success" v-else>0</b-badge>
              <font-awesome-icon
                v-if="showCut"
                size="xs"
                style="margin-left: 3px"
                icon="chevron-up"
              />
              <font-awesome-icon
                v-else
                size="xs"
                style="margin-left: 3px"
                icon="chevron-down"
              />

              <b-popover
                size="sm"
                target="popover2"
                triggers="hover"
                placement="top"
              >
                <template #title
                  ><small v-text="$ml.get('cutversion')"></small
                ></template>
                <small v-html="$ml.get('createnewVODs')"></small>
              </b-popover>
            </b-button>
          </b-row>

          <div
            v-if="
              video.videoInAndOut &&
              video.type === 'vod' &&
              listInAndOut.length > 0 &&
              showCut
            "
            style="margin: 1rem 10rem; border-bottom: 1px dashed #28a745"
          ></div>

          <b-row
            v-if="
              video.videoInAndOut &&
              video.type === 'vod' &&
              listInAndOut.length > 0 &&
              showCut
            "
            class="m-2 mt-3 justify-content-center"
          >
            <small
              ><strong>
                {{ $ml.get("existingcv") }}
                <b-badge variant="success">{{ listInAndOut.length }}</b-badge>
                :</strong
              >
            </small>
          </b-row>

          <b-row
            v-if="showCut"
            v-for="(inAndOut, index) in listInAndOut"
            :key="index"
            class="justify-content-center align-items-center mb-2"
          >
            <a :href="'/#/player/' + inAndOut.uuid">
              <b-button
                variant="cut"
                size="sm"
                title="Click to open the related video page"
              >
                <font-awesome-icon icon="eye" />
                {{ $ml.get("start") }}
                {{ inAndOut.start }}s -
                {{ $ml.get("end") }}
                {{ inAndOut.end }}s&nbsp;
                <span v-if="inAndOut.type === 'precise'">
                  {{ $ml.get("accurate") }}
                </span>
                <span v-else>
                  {{ $ml.get("fast") }}
                </span>
              </b-button>
            </a>
            <b-button
              variant="quanteec"
              size="sm"
              style="margin-left: 10px"
              title="Remove cut-version"
              @click="removeOther(inAndOut.uuid)"
            >
              <font-awesome-icon icon="trash" />
            </b-button>
          </b-row>

          <b-row
            v-if="
              isVideoLoaded &&
              video.type === 'vod' &&
              !video.inAndOutOrigin &&
              showCut
            "
            class="m-2 mt-3 justify-content-center align-items-center"
          >
            <small>
              {{ $ml.get("start") }}
              <vue-timepicker
                v-model="inAndOut.start"
                format="HH:mm:ss"
                @close="verifyEndInAndOut($event, 'start')"
                class="ml-2 mr-2"
                :disabled="video.inAndOutOrigin !== undefined"
              ></vue-timepicker>
            </small>
            <small class="ml-2">
              {{ $ml.get("end") }}
              <vue-timepicker
                v-model="inAndOut.end"
                format="HH:mm:ss"
                @close="verifyEndInAndOut($event, 'end')"
                class="ml-2 mr-3"
                :disabled="video.inAndOutOrigin !== undefined"
              ></vue-timepicker>
            </small>

            <b-row class="align-items-center m-2">
              <b-button
                size="sm"
                id="popover-target-1"
                variant="invisibleN"
                @click="isFastIO = false"
                :disabled="video.inAndOutOrigin !== undefined"
              >
                <span v-if="isFastIO === false" style="color: #14bf98"
                  ><b>{{ $ml.get("accurate") }}</b></span
                >
                <span v-else>{{ $ml.get("accurate") }}</span>
              </b-button>
              <b-popover
                size="sm"
                target="popover-target-1"
                triggers="hover"
                placement="top"
              >
                <template #title
                  ><small>{{ $ml.get("cutsmode") }}</small></template
                >
                <small v-html="$ml.get('accuratemodetxt')"></small>
              </b-popover>

              <b-form-checkbox
                v-model="isFastIO"
                switch
                size="sm"
                :disabled="video.inAndOutOrigin !== undefined"
              />

              <b-button
                size="sm"
                id="popover-target-2"
                variant="invisibleN"
                @click="isFastIO = true"
                :disabled="video.inAndOutOrigin !== undefined"
              >
                <span v-if="isFastIO === true" style="color: #14bf98"
                  ><b>{{ $ml.get("fast") }}</b></span
                >
                <span v-else>{{ $ml.get("fast") }}</span>
              </b-button>
              <b-popover
                size="sm"
                target="popover-target-2"
                triggers="hover"
                placement="top"
              >
                <template #title
                  ><small>{{ $ml.get("cutsmode") }}</small></template
                >
                <small v-html="$ml.get('accuratemodetxt')"></small>
              </b-popover>
            </b-row>

            <b-button
              size="sm"
              style="margin-left: 1rem"
              v-if="isFastIO === true"
              variant="cut"
              @click="putInAndOut(false)"
              :disabled="video.inAndOutOrigin !== undefined"
            >
              <b-icon icon="plus-circle" />
            </b-button>
            <b-button
              size="sm"
              style="margin-left: 1rem"
              v-else
              variant="cut"
              @click="showModal('confirmSlowInAndOut')"
              :disabled="video.inAndOutOrigin !== undefined"
            >
              <b-icon icon="plus-circle" />
            </b-button>
          </b-row>

          <div
            v-if="
              isVideoLoaded &&
              video.type === 'live' &&
              archivesFromLiveLength > 0 &&
              showArchives
            "
            style="margin: 1rem 10rem; border-bottom: 1px dashed #17a2b8"
          ></div>

          <b-row
            v-if="
              isVideoLoaded &&
              video.type === 'live' &&
              archivesFromLiveLength > 0 &&
              showArchives
            "
            class="m-2 mt-3 justify-content-center align-items-center"
          >
            <small
              ><strong>
                {{ $ml.get("existingVODa") }}

                <b-badge variant="info">{{ archivesFromLiveLength }}</b-badge>
                :</strong
              >
            </small>
          </b-row>

          <b-row
            v-if="showArchives"
            v-for="archive in video.archivesFromLive"
            v-bind:key="archive.uuid"
            class="justify-content-center align-items-center mb-2"
          >
            <a :href="'/#/player/' + archive.uuid">
              <b-button
                variant="archive"
                size="sm"
                title="Click to open the archive page"
              >
                <font-awesome-icon
                  :icon="['fas', 'calendar-minus']"
                  title="Creation date, time"
                />
                {{ new Date(archive.createdAt).toLocaleString() }}&nbsp;
                <font-awesome-icon :icon="['fas', 'clock']" title="Duration" />
                {{ archive.duration_unit }}
              </b-button>
            </a>
            <b-button
              variant="quanteec"
              size="sm"
              style="margin-left: 10px"
              title="Remove archive"
              @click="removeOther(archive.uuid)"
            >
              <font-awesome-icon icon="trash" />
            </b-button>
          </b-row>

          <b-row
            v-if="
              isVideoLoaded &&
              video.type === 'live' &&
              isKeepLive &&
              showArchives
            "
            class="m-2 mt-3 justify-content-center align-items-center"
          >
            <b-form-checkbox
              v-model="isDownload"
              size="sm"
              switch
              @change="updateDownload()"
            />

            <font-awesome-layers
              style="margin: 0px 10px 0px 5px"
              v-if="isDownload === true"
            >
              <font-awesome-icon
                style="color: #2a5d77"
                size="sm"
                :icon="['fas', 'arrow-alt-circle-down']"
              />
              <font-awesome-icon
                style="color: #14bf98"
                size="sm"
                :icon="['fas', 'check-circle']"
                transform="shrink-3 up-5 right-9"
              />
            </font-awesome-layers>

            <font-awesome-layers style="margin: 0px 10px 0px 5px" v-else>
              <font-awesome-icon
                style="color: #2a5d77"
                size="sm"
                :icon="['fas', 'arrow-alt-circle-down']"
              />
              <font-awesome-icon
                style="color: red"
                size="sm"
                :icon="['fas', 'minus-circle']"
                transform="shrink-3 up-5 right-9"
              />
            </font-awesome-layers>
            <small>
              &nbsp;
              {{ isDownload ? $ml.get("downlallo") : $ml.get("downlnotallo") }}
            </small>
          </b-row>

          <div style="margin: 1rem 3rem; border-bottom: 1px solid white"></div>

          <b-row class="align-items-center" style="margin: 0px">
            <small style="margin-right: 0.3rem; margin-bottom: 0px"
              ><strong>{{ $ml.get("status") }}:</strong></small
            >&nbsp;
            <b-col
              cols="4"
              class="pointerEltSB"
              style="color: #ba0000; margin: 0px; padding: 5px 0px"
              title="Click to stop process"
              @click="showModal('confirmOneStopEncoding')"
              v-if="
                video.encodingStatus === 'encoding' ||
                video.encodingStatus === 'segmented'
              "
            >
              <small>
                <font-awesome-icon :icon="['fas', 'cog']" spin />
                <strong> {{ $ml.get("encoding") }} </strong>
                <font-awesome-icon :icon="['fas', 'stop-circle']" />
              </small>
            </b-col>
            <b-col
              cols="4"
              class="pointerEltSB"
              style="color: #14bf98; margin: 0px; padding: 5px 0px"
              title="Click to stop process"
              @click="showModal('confirmOneStopEncoding')"
              v-else-if="video.encodingStatus === 'uploading'"
            >
              <small>
                <font-awesome-icon :icon="['fas', 'cog']" spin />
                <strong v-if="video.type === 'vod'">
                  {{ $ml.get("uploading") }}
                </strong>
                <strong v-else> {{ $ml.get("starting") }} </strong>
                <font-awesome-icon :icon="['fas', 'stop-circle']" />
              </small>
            </b-col>
            <b-col
              cols="4"
              class="pointerEltSB"
              style="color: orange; margin: 0px; padding: 5px 0px"
              title="Click to stop process"
              @click="showModal('confirmOneStopEncoding')"
              v-else-if="video.encodingStatus === 'restart'"
            >
              <small>
                <font-awesome-icon :icon="['fas', 'cog']" spin />
                <strong> {{ $ml.get("restarting") }} </strong>
                <font-awesome-icon :icon="['fas', 'stop-circle']" />
              </small>
            </b-col>
            <b-col
              cols="4"
              :class="
                video.sourcePath.toLowerCase() === 'quanteec' ||
                video.sourcePath.toLowerCase() === 'archive'
                  ? ''
                  : 'pointerEltSB'
              "
              style="color: black; margin: 0px; padding: 5px 0px"
              :title="
                video.sourcePath.toLowerCase() === 'quanteec' ||
                video.sourcePath.toLowerCase() === 'archive'
                  ? ''
                  : 'Click to re-start live'
              "
              @click="
                if (
                  video.sourcePath.toLowerCase() !== 'quanteec' &&
                  video.sourcePath.toLowerCase() !== 'archive'
                ) {
                  videoToReencode = video;
                  showModal('confirmOneRestartEncoding');
                }
              "
              v-else-if="video.encodingStatus === 'stopped'"
            >
              <small>
                <font-awesome-icon :icon="['fas', 'cog']" />
                <strong> {{ $ml.get("stopped") }} </strong>
                <font-awesome-icon
                  v-if="
                    video.sourcePath &&
                    video.sourcePath.toLowerCase() !== 'quanteec' &&
                    video.sourcePath.toLowerCase() !== 'archive'
                  "
                  :icon="['fas', 'sync']"
                  transform="shrink-4"
                />
              </small>
            </b-col>
            <b-col
              cols="4"
              :class="
                video.sourcePath.toLowerCase() === 'quanteec' ||
                video.sourcePath.toLowerCase() === 'archive'
                  ? ''
                  : 'pointerEltSB'
              "
              style="color: #2f90b0; margin: 0px; padding: 5px 0px"
              :title="
                video.sourcePath.toLowerCase() === 'quanteec' ||
                video.sourcePath.toLowerCase() === 'archive'
                  ? ''
                  : 'Click to re-encode VOD'
              "
              @click="
                if (
                  video.sourcePath.toLowerCase() !== 'quanteec' &&
                  video.sourcePath.toLowerCase() !== 'archive'
                ) {
                  videoToReencode = video;
                  showModal('confirmOneRestartEncoding');
                }
              "
              v-else-if="video.encodingStatus === 'encoded'"
            >
              <small>
                <font-awesome-icon :icon="['fas', 'cog']" />
                <strong> {{ $ml.get("encoded") }} </strong>
                <font-awesome-icon
                  v-if="
                    video.sourcePath &&
                    video.sourcePath.toLowerCase() !== 'quanteec' &&
                    video.sourcePath.toLowerCase() !== 'archive'
                  "
                  :icon="['fas', 'sync']"
                  transform="shrink-4"
                />
              </small>
            </b-col>
            <b-col
              cols="4"
              class="pointerEltSB"
              style="color: red; margin: 0px; padding: 5px 0px"
              title="Click to re-launch process"
              @click="
                if (
                  video.sourcePath &&
                  video.sourcePath.toLowerCase() !== 'quanteec' &&
                  video.sourcePath.toLowerCase() !== 'archive'
                ) {
                  showModal('confirmOneRestartEncoding');
                }
              "
              v-else-if="video.encodingStatus === 'error'"
            >
              <small>
                <font-awesome-icon :icon="['fas', 'cog']" />
                <strong> {{ $ml.get("error") }} </strong>
                <font-awesome-icon
                  v-if="
                    video.sourcePath &&
                    video.sourcePath.toLowerCase() !== 'quanteec' &&
                    video.sourcePath.toLowerCase() !== 'archive'
                  "
                  :icon="['fas', 'sync']"
                  transform="shrink-4"
                />
              </small>
            </b-col>
            <b-col
              cols="4"
              class="pointerEltSB"
              style="color: orange; margin: 0px; padding: 5px 0px"
              title="Click to stop process"
              @click="showModal('confirmOneStopEncoding')"
              v-else
            >
              <small>
                <font-awesome-icon :icon="['fas', 'cog']" spin />
                <strong>
                  {{
                    video.encodingStatus === "waiting_for_encoding"
                      ? $ml.get("waiting")
                      : video.encodingStatus + "..."
                  }}
                </strong>
                <font-awesome-icon :icon="['fas', 'stop-circle']" />
              </small>
            </b-col>

            <!--<b-col
              cols="1"
              style="color: red; margin:0px; padding:0px; text-align:center"
              :title="`Critical error(s) ${
                !!video.errorType ? '(' + video.errorType + ')' : ''
              }`"
              v-if="video.error === true && (video.encodingStatus !== 'stopped' || video.type !== 'live')"
            >
              <small>
                <font-awesome-icon :icon="['fas', 'exclamation-triangle']" />
              </small>
            </b-col>-->

            <b-col
              style="
                color: #2a5d77;
                margin: 0px;
                padding: 5px;
                text-align: center;
              "
              title="Number of qualities"
            >
              <small>
                <span v-if="video.encoding === 'passthrough'"
                  ><strong>Passthrough</strong></span
                >
                <span
                  v-else-if="
                    !video.inputQualities ||
                    video.inputQualities === 'QuanteecOptimization'
                  "
                >
                  <b-img
                    fluid
                    no-repeat
                    :src="require(`@/assets/logo.svg`)"
                    style="max-height: 20px; margin-right: 5px"
                    title="QUANTEEC algorithm"
                  />
                </span>
                <span v-else>
                  <strong>{{ $ml.get("custom") }}</strong>
                </span>

                <span v-if="video.currentNumberOfQualities">
                  in <strong>{{ video.currentNumberOfQualities }}</strong>
                  {{
                    video.currentNumberOfQualities === 1
                      ? $ml.get("qualityaso")
                      : $ml.get("qualities")
                  }}
                </span>
              </small>
            </b-col>

            <b-col
              cols="3"
              style="
                color: #2a5d77;
                margin: 0px 10px;
                padding: 5px;
                text-align: center;
              "
            >
              <b-row
                v-for="(quality, qualityIdx) in video.qualities"
                v-bind:key="qualityIdx"
              >
                <small v-if="quality.height !== 'origin'"
                  >{{ quality.height }}p@{{ quality.bitrate }}kbps</small
                >
              </b-row>
            </b-col>

            <b-col
              cols="1"
              style="color: red; margin: 0px; padding: 0px; text-align: center"
              :title="`Critical error(s) ${
                !!video.errorType ? '(' + video.errorType + ')' : ''
              }`"
              v-if="
                video.error === true &&
                (video.encodingStatus !== 'stopped' || video.type !== 'live')
              "
            >
              <small>
                <font-awesome-icon :icon="['fas', 'exclamation-triangle']" />
              </small>
            </b-col>
          </b-row>

          <small
            v-if="
              ['encoding', 'segmented'].indexOf(video.encodingStatus) > -1 &&
              video.type === 'vod' &&
              video.encodingPercent < 100
            "
            title="Current progress of the encoding process"
          >
            <b-progress :max="100">
              <b-progress-bar
                :value="video.encodingPercent"
                animated
                variant="primary"
              >
                {{ video.encodingPercent }}%
              </b-progress-bar>
            </b-progress>
            <p
              title="Time to finish encoding process"
              style="text-align: center; margin-top: 2px; font-size: 10px"
            >
              <font-awesome-icon :icon="['fas', 'stopwatch']" />
              {{ video.encodingETA }}
            </p>
          </small>
          <small
            v-else-if="
              video.encodingStatus === 'uploading' && video.type === 'vod'
            "
            title="Current progress of the uploading process"
          >
            <b-progress style="" :max="100">
              <b-progress-bar
                style=""
                :value="video.uploadingPercent"
                animated
                variant="primary"
              >
                <small>{{ video.uploadingPercent }}%</small>
              </b-progress-bar>
            </b-progress>
            <p
              title="Time to finish uploading process"
              style="text-align: center; margin-top: 2px; font-size: 10px"
            >
              <font-awesome-icon :icon="['fas', 'stopwatch']" />
              {{ video.uploadingETA }}
            </p>
          </small>

          <div style="margin: 1rem 3rem; border-bottom: 1px solid white"></div>

          <small
            v-if="video.type === 'live' && !isUpdateSource"
            style="word-break: break-all"
          >
            <strong style="margin-right: 0.3rem">Live source: </strong>
            <span
              v-if="
                showSourcePath &&
                video.liveType !== 'quanteecRTMP' &&
                !modifySourcePath
              "
              >{{ video.sourcePath }}
            </span>
            <span
              v-if="showSourcePath && video.liveType === 'quanteecRTMP'"
              style="display: block; margin-top: 10px"
              ><strong>URL:</strong>
              {{
                video.sourcePath
                  .split("/")
                  .splice(0, video.sourcePath.split("/").length - 1)
                  .join("/")
              }}
              <b-button
                v-if="!modifySourcePath"
                id="copyUrl"
                variant="darkblue"
                style="font-size: 11px; padding: 2px 5px"
                @click="
                  copyData(
                    video.sourcePath
                      .split('/')
                      .splice(0, video.sourcePath.split('/').length - 1)
                      .join('/')
                  )
                "
                title="Copy to clipboard"
              >
                <font-awesome-icon icon="clone" />
                {{ $ml.get("copy") }}
              </b-button>
              <b-popover target="copyUrl">
                {{ $ml.get("copied") }}
              </b-popover>
            </span>
            <span
              v-if="showSourcePath && video.liveType === 'quanteecRTMP'"
              style="display: block; margin-top: 10px; margin-bottom: 10px"
              ><strong>Key:</strong> {{ video.sourcePath.split("/").pop() }}
              <b-button
                id="copyKey"
                variant="darkblue"
                style="font-size: 11px; padding: 2px 5px"
                @click="copyData(video.sourcePath.split('/').pop())"
                title="Copy to clipboard"
              >
                <font-awesome-icon icon="clone" />
                {{ $ml.get("copy") }}
              </b-button>
              <b-popover target="copyKey">
                {{ $ml.get("copied") }}
              </b-popover>
            </span>
            <span v-if="!showSourcePath && !modifySourcePath"
              >&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;
            </span>
            <b-button
              tabindex="-1"
              v-if="!showSourcePath && !modifySourcePath"
              variant="darkblue"
              @click="showSourcePath = !showSourcePath"
              style="font-size: 12px; padding: 2px 5px"
              ><font-awesome-icon :icon="['fas', 'eye']"></font-awesome-icon
            ></b-button>
            <b-button
              tabindex="-1"
              v-if="showSourcePath && !modifySourcePath"
              variant="darkblue"
              @click="showSourcePath = !showSourcePath"
              style="font-size: 12px; padding: 2px 5px"
            >
              <font-awesome-icon
                :icon="['fas', 'eye-slash']"
              ></font-awesome-icon
            ></b-button>
            &nbsp;
            <span
              class="pointerEltSB"
              v-if="video.liveType !== 'quanteecRTMP' && !modifySourcePath"
              @click="
                modifySourcePath = !modifySourcePath;
                modifiedSourcePath = video.sourcePath;
              "
            >
              <font-awesome-layers>
                <font-awesome-icon :icon="['fas', 'file-alt']" />
                <font-awesome-icon
                  :icon="['fas', 'pencil-alt']"
                  transform="shrink-4 up-10 right-6 flip-v rotate-180"
                />
              </font-awesome-layers>
            </span>
            <span v-if="modifySourcePath">
              <b-form
                style="margin: 10px 0px"
                @submit.prevent="updateSourcePath"
              >
                <b-row class="align-items-center h-100">
                  <b-col cols="9">
                    <b-form-input
                      type="text"
                      v-model="modifiedSourcePath"
                      placeholder="source path"
                      size="sm"
                    ></b-form-input>
                  </b-col>
                  <b-col cols="3" style="padding: 0px">
                    <b-button size="sm" variant="emptyBB" type="submit">
                      <font-awesome-icon
                        class="pointerEltSB"
                        style="color: #14bf98"
                        :icon="['fas', 'check']"
                      />
                    </b-button>
                    <b-button
                      size="sm"
                      variant="emptyBBx"
                      @click="
                        modifiedSourcePath = video.sourcePath;
                        modifySourcePath = false;
                      "
                    >
                      <font-awesome-icon
                        class="pointerEltSB"
                        style="color: red"
                        :icon="['fas', 'times']"
                      />
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </span>
          </small>
          <p>
            <small v-if="sourcePathHasBeenModified" style="color: #ba0000">
              {{ $ml.get("sourcePathModified") }}
            </small>
          </p>
          <div v-if="video && video.manifest">
            <div
              style="margin: 1rem 3rem; border-bottom: 1px solid white"
            ></div>

            <p style="margin-bottom: 0.5rem">
              <small><strong>M3U8:</strong></small>
            </p>
            <code
              >{{ video.manifest.m3u8 }}
              <b-button
                variant="darkblue"
                style="font-size: 12px; padding: 2px 5px"
                @click="
                  copyM3U8();
                  showAndHideModal('confirmClickManifest');
                "
                title="Copy 'M3U8' to clipboard"
              >
                <font-awesome-icon icon="clone" />
                {{ $ml.get("copy") }}
              </b-button></code
            >

            <p class="marginaltopsm" style="margin-bottom: 0.5rem">
              <small><strong>MPD:</strong></small>
            </p>
            <code
              >{{ video.manifest.mpd }}
              <b-button
                variant="darkblue"
                style="font-size: 12px; padding: 2px 5px"
                @click="
                  copyMPD();
                  showAndHideModal('confirmClickManifest');
                "
                title="Copy 'MPD' to clipboard"
              >
                <font-awesome-icon icon="clone" />
                {{ $ml.get("copy") }}
              </b-button>
            </code>
          </div>

          <div
            v-if="video.type === 'live' && video.liveType === 'quanteecRTMP'"
            style="margin: 1rem 3rem; border-bottom: 1px solid white"
          ></div>

          <div
            v-if="video.type === 'live' && video.liveType === 'quanteecRTMP'"
          >
            <b-row>
              <b-col cols="auto">
                <small v-if="liveStats.connected"
                  ><strong
                    ><font-awesome-icon
                      style="color: green"
                      :icon="['fas', 'circle']"
                    />
                    {{ $ml.get("sourcec") }}</strong
                  ></small
                >
                <small v-if="!liveStats.connected"
                  ><strong
                    ><font-awesome-icon
                      style="color: red"
                      :icon="['fas', 'circle']"
                    />
                    {{ $ml.get("sourcedis") }}</strong
                  ></small
                >
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="auto">
                <small
                  ><strong>{{ $ml.get("time") }}</strong>
                  {{ liveStats._time }}</small
                >
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="auto">
                <small
                  ><strong>{{ $ml.get("videobr") }}</strong>
                  {{ liveStats.bw_video }} kbps</small
                >
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="auto">
                <small
                  ><strong>{{ $ml.get("audiobr") }}</strong>
                  {{ liveStats.bw_audio }} kbps</small
                >
              </b-col>
            </b-row>
          </div>

          <div
            v-if="video.type === 'live'"
            style="margin: 1rem 3rem; border-bottom: 1px solid white"
          ></div>
          <div v-if="video.type === 'live'">
            <b-row class="justify-content-around">
              <b-col cols="auto">
                <b-button
                  size="sm"
                  variant="msstreamblue"
                  @click="showModal('modifyExternalStreams')"
                  >{{ $ml.get("modifyes") }}
                  <b-spinner
                    small
                    variant="light"
                    v-if="isLoadingModifyExternalStreams"
                  ></b-spinner
                ></b-button>
              </b-col>
              <!--<b-col cols="auto">
                <b-row class="align-items-center">
                  <b-form-checkbox
                    v-model="autoStartExternal"
                    switch
                    size="sm"
                    @change="onAutoStart"
                  />
                  <small>
                    Auto start external streams when Quanteec encoding starts
                  </small>
                </b-row>
              </b-col>-->
            </b-row>
            <b-row class="justify-content-around marginaltopsm">
              <b-button variant="green" size="sm" @click="startExternalStreams"
                >{{ $ml.get("startstr") }}
                <b-spinner
                  small
                  variant="light"
                  v-if="isLoadingStartExternalStreams"
                ></b-spinner
              ></b-button>
              <b-button
                variant="mswarning"
                size="sm"
                @click="stopExternalStreams"
                >{{ $ml.get("stopstr") }}
                <b-spinner
                  small
                  variant="light"
                  v-if="isLoadingStopExternalStreams"
                ></b-spinner
              ></b-button>
            </b-row>
            <b-row class="marginaltopsm">
              <b-col cols="auto">
                <small v-if="video.externalStreamsStatus"
                  ><strong>{{ $ml.get("extstrstat") }}</strong
                  >&nbsp;<font-awesome-icon
                    v-if="video.externalStreamsStatus === 'Connected'"
                    style="color: green"
                    :icon="['fas', 'circle']"
                  />
                  <font-awesome-icon
                    v-if="video.externalStreamsStatus === 'Disconnected'"
                    style="color: red"
                    :icon="['fas', 'circle']"
                  />
                  {{ video.externalStreamsStatus }} -
                  {{ video.externalStreamsReason }}</small
                >
                <small v-else
                  ><strong>{{ $ml.get("extstrstat") }}</strong
                  >&nbsp;<font-awesome-icon
                    style="color: red"
                    :icon="['fas', 'circle']"
                  />
                  {{ $ml.get("disnevstart") }}</small
                >
              </b-col>
            </b-row>
            <div
              v-if="
                video.type === 'live' &&
                externalStreams &&
                Object.keys(externalStreams).length > 0
              "
            >
              <b-row class="m-2">
                <b-col cols="auto">
                  <small
                    ><strong>{{ $ml.get("liveperlivestat") }}</strong></small
                  >
                </b-col>
              </b-row>

              <b-row
                class="align-items-center justify-content-center mb-2"
                v-if="externalStreams.youtube"
              >
                <b-col style="text-align: right" cols="auto">
                  <font-awesome-icon
                    size="lg"
                    class="quanteecyoutubevalide"
                    :icon="['fab', 'youtube']"
                  />
                  <sub
                    ><b-badge style="color: white; background-color: #ff0000">{{
                      externalStreams.youtube.length
                    }}</b-badge></sub
                  >&nbsp;
                </b-col>
                <b-col style="text-align: left">
                  <b-row
                    class="align-items-center m-1"
                    v-for="(yt, index) in externalStreams.youtube"
                    v-bind:key="index"
                  >
                    <small v-if="yt._showKey"
                      ><strong>Key:</strong> {{ yt.key }}</small
                    >
                    <small v-if="!yt._showKey"
                      ><strong>Key:</strong>
                      &#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;</small
                    >
                    &nbsp;
                    <b-button
                      tabindex="-1"
                      v-if="!yt._showKey"
                      variant="darkblue"
                      @click="
                        yt._showKey = !yt._showKey;
                        externalStreams.youtube =
                          externalStreams.youtube.splice(0);
                      "
                      style="font-size: 12px; padding: 2px 5px"
                      ><font-awesome-icon
                        :icon="['fas', 'eye']"
                      ></font-awesome-icon
                    ></b-button>
                    <b-button
                      tabindex="-1"
                      v-if="yt._showKey"
                      variant="darkblue"
                      @click="
                        yt._showKey = !yt._showKey;
                        externalStreams.youtube =
                          externalStreams.youtube.splice(0);
                      "
                      style="font-size: 12px; padding: 2px 5px"
                    >
                      <font-awesome-icon
                        :icon="['fas', 'eye-slash']"
                      ></font-awesome-icon
                    ></b-button>
                    &nbsp;

                    <small v-if="yt.status === 'connected'"
                      ><font-awesome-icon
                        style="color: green"
                        :icon="['fas', 'circle']"
                      />
                      {{ $ml.get("connected") }}</small
                    >
                    <small v-else
                      ><font-awesome-icon
                        style="color: red"
                        :icon="['fas', 'circle']"
                      />
                      {{ $ml.get("disconnected") }}</small
                    >
                  </b-row>
                </b-col>
              </b-row>

              <b-row
                class="align-items-center justify-content-center mb-2"
                v-if="externalStreams.facebook"
              >
                <b-col style="text-align: right" cols="auto">
                  <font-awesome-icon
                    size="lg"
                    class="quanteecfacebookvalide"
                    :icon="['fab', 'facebook']"
                  />
                  <sub
                    ><b-badge style="color: white; background-color: #4267b2">{{
                      externalStreams.facebook.length
                    }}</b-badge></sub
                  >&nbsp;
                </b-col>
                <b-col style="text-align: left">
                  <b-row
                    class="align-items-center m-1"
                    v-for="(yt, index) in externalStreams.facebook"
                    v-bind:key="index"
                  >
                    <small v-if="yt._showKey"
                      ><strong>Key:</strong> {{ yt.key }}</small
                    >
                    <small v-if="!yt._showKey"
                      ><strong>Key:</strong>
                      &#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;</small
                    >
                    &nbsp;
                    <b-button
                      tabindex="-1"
                      v-if="!yt._showKey"
                      variant="darkblue"
                      @click="
                        yt._showKey = !yt._showKey;
                        externalStreams.facebook =
                          externalStreams.facebook.splice(0);
                      "
                      style="font-size: 12px; padding: 2px 5px"
                      ><font-awesome-icon
                        :icon="['fas', 'eye']"
                      ></font-awesome-icon
                    ></b-button>
                    <b-button
                      tabindex="-1"
                      v-if="yt._showKey"
                      variant="darkblue"
                      @click="
                        yt._showKey = !yt._showKey;
                        externalStreams.facebook =
                          externalStreams.facebook.splice(0);
                      "
                      style="font-size: 12px; padding: 2px 5px"
                    >
                      <font-awesome-icon
                        :icon="['fas', 'eye-slash']"
                      ></font-awesome-icon
                    ></b-button>
                    &nbsp;

                    <small v-if="yt.status === 'connected'"
                      ><font-awesome-icon
                        style="color: green"
                        :icon="['fas', 'circle']"
                      />
                      {{ $ml.get("connected") }}</small
                    >
                    <small v-else
                      ><font-awesome-icon
                        style="color: red"
                        :icon="['fas', 'circle']"
                      />
                      {{ $ml.get("disconnected") }}</small
                    >
                  </b-row>
                </b-col>
              </b-row>

              <b-row
                class="align-items-center justify-content-center mb-2"
                v-if="externalStreams.twitch"
              >
                <b-col style="text-align: right" cols="auto">
                  <font-awesome-icon
                    size="lg"
                    class="quanteectwitchvalide"
                    :icon="['fab', 'twitch']"
                  />
                  <sub
                    ><b-badge style="color: white; background-color: #9146ff">{{
                      externalStreams.twitch.length
                    }}</b-badge></sub
                  >&nbsp;
                </b-col>
                <b-col style="text-align: left">
                  <b-row
                    class="align-items-center m-1"
                    v-for="(yt, index) in externalStreams.twitch"
                    v-bind:key="index"
                  >
                    <small v-if="yt._showKey"
                      ><strong>Key:</strong> {{ yt.key }}</small
                    >
                    <small v-if="!yt._showKey"
                      ><strong>Key:</strong>
                      &#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;</small
                    >
                    &nbsp;
                    <b-button
                      tabindex="-1"
                      v-if="!yt._showKey"
                      variant="darkblue"
                      @click="
                        yt._showKey = !yt._showKey;
                        externalStreams.twitch =
                          externalStreams.twitch.splice(0);
                      "
                      style="font-size: 12px; padding: 2px 5px"
                      ><font-awesome-icon
                        :icon="['fas', 'eye']"
                      ></font-awesome-icon
                    ></b-button>
                    <b-button
                      tabindex="-1"
                      v-if="yt._showKey"
                      variant="darkblue"
                      @click="
                        yt._showKey = !yt._showKey;
                        externalStreams.twitch =
                          externalStreams.twitch.splice(0);
                      "
                      style="font-size: 12px; padding: 2px 5px"
                    >
                      <font-awesome-icon
                        :icon="['fas', 'eye-slash']"
                      ></font-awesome-icon
                    ></b-button>
                    &nbsp;

                    <small v-if="yt.status === 'connected'"
                      ><font-awesome-icon
                        style="color: green"
                        :icon="['fas', 'circle']"
                      />
                      {{ $ml.get("connected") }}</small
                    >
                    <small v-else
                      ><font-awesome-icon
                        style="color: red"
                        :icon="['fas', 'circle']"
                      />
                      {{ $ml.get("disconnected") }}</small
                    >
                  </b-row>
                </b-col>
              </b-row>

              <b-row
                class="align-items-center justify-content-center"
                v-if="externalStreams.other"
              >
                <b-col style="text-align: right" cols="auto">
                  <font-awesome-icon
                    size="lg"
                    class="quanteecothervalide"
                    :icon="['fas', 'video']"
                  />
                  <sub
                    ><b-badge
                      style="color: white; background-color: rgb(20, 191, 152)"
                      >{{ externalStreams.other.length }}</b-badge
                    ></sub
                  >&nbsp;
                </b-col>
                <b-col style="text-align: left">
                  <div
                    class="align-items-center m-1"
                    v-for="(yt, index) in externalStreams.other"
                    v-bind:key="index"
                  >
                    <b-row class="align-items-center m-1">
                      <small><strong>Url:</strong> {{ yt.url }}</small>
                    </b-row>
                    <b-row class="align-items-center m-1">
                      <small v-if="yt._showKey"
                        ><strong>Key:</strong> {{ yt.key }}</small
                      >
                      <small v-if="!yt._showKey"
                        ><strong>Key:</strong>
                        &#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;</small
                      >
                      &nbsp;
                      <b-button
                        tabindex="-1"
                        v-if="!yt._showKey"
                        variant="darkblue"
                        @click="
                          yt._showKey = !yt._showKey;
                          externalStreams.other =
                            externalStreams.other.splice(0);
                        "
                        style="font-size: 12px; padding: 2px 5px"
                        ><font-awesome-icon
                          :icon="['fas', 'eye']"
                        ></font-awesome-icon
                      ></b-button>
                      <b-button
                        tabindex="-1"
                        v-if="yt._showKey"
                        variant="darkblue"
                        @click="
                          yt._showKey = !yt._showKey;
                          externalStreams.other =
                            externalStreams.other.splice(0);
                        "
                        style="font-size: 12px; padding: 2px 5px"
                      >
                        <font-awesome-icon
                          :icon="['fas', 'eye-slash']"
                        ></font-awesome-icon
                      ></b-button>
                      &nbsp;

                      <small v-if="yt.status === 'connected'"
                        ><font-awesome-icon
                          style="color: green"
                          :icon="['fas', 'circle']"
                        />
                        {{ $ml.get("connected") }}</small
                      >
                      <small v-else
                        ><font-awesome-icon
                          style="color: red"
                          :icon="['fas', 'circle']"
                        />
                        {{ $ml.get("disconnected") }}</small
                      >
                    </b-row>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>

          <div
            v-if="video.type === 'live' && !isUpdateSource"
            style="margin: 1rem 3rem; border-bottom: 1px solid white"
          ></div>

          <small>
            <strong style="margin-right: 0.3rem"
              >{{ $ml.get("tags") }}:
            </strong>
            <font-awesome-icon :icon="['fas', 'tags']" />
            <b-form-tags
              style="margin: 10px 0px"
              element-id="tags"
              v-model="tags"
              @input="updateTags"
              placeholder="Tag + Enter"
            ></b-form-tags>
          </small>

          <div style="margin: 1rem 3rem; border-bottom: 1px solid white"></div>

          <small
            class="pointerEltSB"
            title="Click to update video description"
            @click="modifyDescription = !modifyDescription"
            :style="modifyDescription ? { color: '#14BF98' } : {}"
          >
            <strong style="margin-right: 0.3rem">{{ $ml.get("desc") }} </strong>
            <font-awesome-layers>
              <font-awesome-icon :icon="['fas', 'file-alt']" />
              <font-awesome-icon
                :icon="['fas', 'pencil-alt']"
                transform="shrink-4 up-10 right-6 flip-v rotate-180"
              />
            </font-awesome-layers>
          </small>
          <small style="margin: 5px;overflow-wrap: break-word;" v-if="!modifyDescription">
            {{ video.description }}
          </small>
          <small v-if="modifyDescription">
            <b-form
              style="margin: 10px 0px"
              @submit.prevent="updateDescription"
            >
              <b-row class="align-items-center h-100">
                <b-col cols="9">
                  <b-form-textarea
                    id="textarea"
                    v-model="description"
                    placeholder="Description text"
                    rows="1"
                    max-rows="3"
                    size="sm"
                  ></b-form-textarea>
                </b-col>
                <b-col cols="3" style="padding: 0px">
                  <b-button size="sm" variant="emptyBB" type="submit">
                    <font-awesome-icon
                      class="pointerEltSB"
                      style="color: #14bf98"
                      :icon="['fas', 'check']"
                    />
                  </b-button>
                  <b-button
                    size="sm"
                    variant="emptyBBx"
                    @click="cancelDescription"
                  >
                    <font-awesome-icon
                      class="pointerEltSB"
                      style="color: red"
                      :icon="['fas', 'times']"
                    />
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </small>

          <div style="margin: 1rem 3rem; border-bottom: 1px solid white"></div>
          <div
            style="margin-bottom: 15px"
            v-if="$auth.getMyUser().client_infos[0].watermark"
          >
            <small
              class="pointerEltSB"
              title="Click to update video watermark default text"
              @click="modifyWatermark = !modifyWatermark"
              :style="modifyWatermark ? { color: '#14BF98' } : {}"
            >
              <strong style="margin-right: 0.3rem"
                >{{ $ml.get("customwm") }}
              </strong>
              <font-awesome-layers>
                <font-awesome-icon :icon="['fas', 'file-alt']" />
                <font-awesome-icon
                  :icon="['fas', 'pencil-alt']"
                  transform="shrink-4 up-10 right-6 flip-v rotate-180"
                />
              </font-awesome-layers>
            </small>
            <small style="margin: 5px" v-if="!modifyWatermark">
              {{ video.watermarkText }}
            </small>
            <small v-if="modifyWatermark">
              <b-form
                style="margin: 10px 0px"
                @submit.prevent="updateWatermark"
              >
                <b-row class="align-items-center h-100">
                  <b-col cols="9">
                    <b-form-textarea
                      id="textarea2"
                      v-model="watermarkText"
                      placeholder="WATCHED BY"
                      rows="1"
                      max-rows="3"
                      size="sm"
                    ></b-form-textarea>
                  </b-col>
                  <b-col cols="3" style="padding: 0px">
                    <b-button size="sm" variant="emptyBB" type="submit">
                      <font-awesome-icon
                        class="pointerEltSB"
                        style="color: #14bf98"
                        :icon="['fas', 'check']"
                      />
                    </b-button>
                    <b-button
                      size="sm"
                      variant="emptyBBx"
                      @click="cancelWatermark"
                    >
                      <font-awesome-icon
                        class="pointerEltSB"
                        style="color: red"
                        :icon="['fas', 'times']"
                      />
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </small>
          </div>

          <small>
            <strong style="margin-right: 0.3rem"
              >{{ $ml.get("iframecode") }}
            </strong>
            <span style="line-height: 1.3; padding: 3px 0px">
              <font-awesome-icon :icon="['fas', 'file-export']" />
              {{ $ml.get("iframecodetxt") }}
            </span>
            <b-button
              variant="darkblue"
              style="font-size: 12px; padding: 2px 5px"
              @click="
                copyEmbeded();
                showAndHideModal('confirmClickExport');
              "
              title="Copy 'iFrame Code' to clipboard"
            >
              <font-awesome-icon icon="clone" />
              {{ $ml.get("copy") }}
            </b-button>
            <p style="margin: 5px">
              <code ref="codeToCopy" style="color: #2f90b0">{{ embeded }}</code>
            </p>
          </small>

          <small style="margin-top: 15px">
            <strong style="margin-right: 0.3rem"
              >{{ $ml.get("directl") }}
            </strong>
            <span style="line-height: 1.3; padding: 3px 0px; color: #484a46">
              <font-awesome-icon :icon="['fas', 'link']" />
              {{ $ml.get("directltxt") }}
            </span>
            <b-button
              variant="darkblue"
              size="sm"
              style="font-size: 12px; padding: 2px 5px"
              @click="
                copyDirectLink();
                showAndHideModal('confirmClickDirectLink');
              "
              title="Copy 'Direct Link' to clipboard"
            >
              <font-awesome-icon icon="clone" />
              {{ $ml.get("copy") }}
            </b-button>
            <p style="margin: 5px">
              <a
                style="color: #2a5d77"
                v-bind:href="directLink"
                title="Click to open"
              >
                <code ref="codeToCopy" style="color: #2f90b0">{{
                  directLink
                }}</code>
              </a>
            </p>
          </small>

          <small
            style="margin-top: 15px"
            v-for="link in exportLinks"
            v-bind:key="link.uuid"
          >
            <strong style="margin-right: 0.3rem"
              >{{ $ml.get("exportl") }} - {{ link.name }}:
            </strong>
            <span style="line-height: 1.3; padding: 3px 0px; color: #484a46">
              <font-awesome-layers>
                <font-awesome-icon
                  :icon="['fas', 'file-export']"
                  size="lg"
                  transform="shrink-8"
                />
                <font-awesome-icon
                  :icon="['far', 'circle']"
                  size="lg"
                /> </font-awesome-layers
              >&nbsp; {{ $ml.get("exportltxt") }}
            </span>
            <b-button
              variant="darkblue"
              size="sm"
              style="font-size: 12px; padding: 2px 5px"
              @click="
                copyLink(link);
                showAndHideModal('confirmClickExportLink');
              "
              title="Copy 'iFrame Code' of export link to clipboard"
            >
              <font-awesome-icon icon="clone" />
              Copy
            </b-button>
            <p style="margin: 5px">
              <a style="color: #2a5d77" title="Click to open">
                <code ref="codeToCopy" style="color: #2f90b0">{{
                  link._iframe
                }}</code>
              </a>
            </p>
          </small>

          <b-row style="margin-top: 15px" class="justify-content-center mb-4">
            <b-col cols="auto">
              <b-button
                variant="msstreamblue"
                size="sm"
                @click="$router.push('/export')"
              >
                {{ $ml.get("manageel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-col>

        <!-- Video Parameters panel on the right of the row -->
        <!--
        <b-col v-if="video.type === 'live' && video.encodingStatus === 'encoded' && video.keepLive === false" cols="12" md="6" class="mypanel">
          <h5
            style="
              text-align: center;
              color: #2a5d77;
              border-bottom: 1px solid #2a5d77;
              padding-bottom: 5px;
              margin-bottom: 15px;
            "
          >
            Video parameters
          </h5>
          <b-row>
            <b-alert
              variant="danger"
              show
              style="margin: 15px; text-align: center"
              class="align-items-center"
            >

              This live video has not been kept as a VoD at the end of the stream. Hence, no parameter is available. 
            </b-alert>
          </b-row>
        </b-col>
-->
        <b-col cols="12" md="6" class="mypanel">
          <h5
            style="
              text-align: center;
              color: #2a5d77;
              padding-bottom: 5px;
              margin-bottom: 15px;
              border-bottom: 1px solid #2a5d77;
            "
          >
            <b-img
              fluid
              :src="require(`@/assets/logo.svg`)"
              style="max-height: 20px"
            />
            &nbsp;
            {{ $ml.get("videoparam") }}
          </h5>

          <b-row
            v-if="
              $auth.getMyUser().client_infos[0].bunny && video.type === 'live'
            "
            class="align-items-center"
            style="margin: 5px 0px"
          >
            <b-form-checkbox
              v-model="video.bunnycdn"
              switch
              @change="bunnyCDNVideo()"
              :disabled="modifyBunnyCDN"
              size="sm"
            />
            <small>
              {{ video.bunnycdn ? "Large audience" : "Small audience" }}
            </small>
          </b-row>

          <b-row
            v-if="$auth.getMyUser().client_infos[0].bunny && modifyBunnyCDN"
            class="justify-content-center marginaltopsm"
            style="margin-bottom: -35px"
          >
            <b-spinner></b-spinner>
          </b-row>

          <div
            v-if="$auth.getMyUser().client_infos[0].bunny"
            style="margin: 1rem 3rem; border-bottom: 1px solid white"
          ></div>

          <b-row
            v-if="
              $auth.getMyUser().client_infos[0].cloudflare &&
              video.type === 'live'
            "
            class="align-items-center"
            style="margin: 5px 0px"
          >
            <b-form-checkbox
              v-model="video.cloudflare"
              switch
              @change="accelerateVideo()"
              :disabled="modifyAcceleration"
              size="sm"
            />
            <small>
              {{ video.cloudflare ? "Large Audience" : "Small Audience" }}
            </small>
          </b-row>

          <b-row
            v-if="
              $auth.getMyUser().client_infos[0].cloudflare && modifyAcceleration
            "
            class="justify-content-center marginaltopsm"
            style="margin-bottom: -35px"
          >
            <fade-loader
              color="#f98e35"
              style="
                position: relative;
                width: 45px;
                height: 60px;
                text-align: center;
              "
            ></fade-loader>
          </b-row>

          <div
            v-if="$auth.getMyUser().client_infos[0].cloudflare"
            style="margin: 1rem 3rem; border-bottom: 1px solid white"
          ></div>

          <b-row v-if="video.type === 'vod'" class="align-items-center justify-content-center">
            <b-col v-if="outro.img_base" cols="6">
              <p style="text-align: center;">{{$ml.get('outrocurrentimg')}}</p>
              <b-row>
                <b-col cols="12">
                  <b-img :src="outro.img_base" fluid>
                  </b-img>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="6">
              <b-row class="justify-content-center">
                <b-col cols="auto">
                  <b-button
                    variant="msstreamblue"
                    @click="
                    showModal('updateOutro')
                    "
                    size="sm"
                    style="margin-left: -15px"
                  >
                    <font-awesome-icon :icon="['fas', 'link']" />
                    {{ $ml.get("modifyoutro") }}
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <div
            v-if="video.type === 'vod'"
            style="margin: 1rem 3rem; border-bottom: 1px solid white"
          ></div>

          <div
            v-if="this.video.type !== 'live' || this.video.liveCamera !== true"
          >
            <small>
              <strong style="margin-right: 0.3rem"
                >{{ $ml.get("plandst") }}
              </strong>
              <font-awesome-layers>
                <font-awesome-icon icon="share" />
                <font-awesome-icon
                  icon="play"
                  transform="shrink-7 right-13 up-2"
                />
              </font-awesome-layers>
            </small>
            <p style="margin-top: 5px">
              <small>
                {{ $ml.get("plandsttxt") }}

                <strong>
                  <span v-if="video.startDate">{{ vstartDateShow }}</span>
                  <span v-else
                    >{{ $ml.get("fromthecre") }} ({{ createdDate }})</span
                  >
                </strong>
              </small>
            </p>

            <b-row class="align-items-center justify-content-center">
              <b-button
                v-if="liveDate && startDateShow !== vstartDateShow"
                variant="quanteeclg"
                @click="
                  liveDate = video.startDate;
                  startDateShow = vstartDateShow;
                "
                size="sm"
                style="margin: 0px 5px"
              >
                <font-awesome-icon
                  style="color: red"
                  :icon="['fas', 'times']"
                />
              </b-button>

              <date-picker
                id="example-datepicker1"
                :attributes="attributes"
                size="sm"
                @input="adjustDateS()"
                v-model="liveDate"
                mode="dateTime"
                :timezone="''"
                is24hr
                class="mr-3"
              >
                <template size="sm" v-slot="{ inputEvents }">
                  <b-button size="sm" variant="quanteeclg" v-on="inputEvents">
                    <font-awesome-icon
                      :icon="['fas', 'calendar-week']"
                    ></font-awesome-icon
                    >&nbsp;
                    <span v-if="liveDate">{{ startDateShow }}</span>
                    <span v-else>{{ $ml.get("selectdate") }} </span>
                  </b-button>
                </template>
              </date-picker>

              <b-button
                v-if="
                  liveDate &&
                  startDateShow !== vstartDateShow &&
                  video.startDate === ''
                "
                variant="msstreamblue"
                @click="setupVODAsLive()"
                size="sm"
                style="margin: 0px 5px"
              >
                <font-awesome-icon :icon="['fas', 'check']" />
                {{ $ml.get("setup") }}
              </b-button>

              <b-button
                v-else-if="liveDate && startDateShow !== vstartDateShow"
                variant="mswarning"
                @click="setupVODAsLive()"
                size="sm"
                style="margin: 0px 5px"
              >
                <font-awesome-icon :icon="['fas', 'check']" />
                {{ $ml.get("modify") }}
              </b-button>

              <b-button
                v-if="video.startDate"
                variant="quanteec"
                @click="deleteVODAsLive()"
                size="sm"
                style="margin: 0px 5px"
              >
                <font-awesome-layers>
                  <font-awesome-icon icon="share" />
                  <font-awesome-icon icon="slash" transform="left-2" />
                </font-awesome-layers>
                {{ $ml.get("clear") }}
              </b-button>

              <span
                v-if="liveDate && liveDate < cd2"
                style="color: red; font-size: 10px; margin-top: 5px"
              >
                <font-awesome-icon icon="exclamation-triangle" />
                {{ $ml.get("selectdateprior") }}
              </span>
              <span
                v-if="
                  liveDate &&
                  deleteDate &&
                  adjustDD(liveDate) > adjustDD(deleteDate)
                "
                style="color: red; font-size: 10px; margin-top: 5px"
              >
                <font-awesome-icon icon="exclamation-triangle" />
                {{ $ml.get("videodel") }}
              </span>
            </b-row>

            <!--
           <b-row class="align-items-center" style="margin: 15px 0px">
             <b-form-datepicker size="sm" id="example-datepicker" v-model="liveDate" class="mr-2" style="width:240px"></b-form-datepicker>
             <b-form-timepicker size="sm" v-model="liveHour" locale="fr" class="mr-3" style="width:160px" ></b-form-timepicker>
             <b-button variant="msstreamblue" @click="setupVODAsLive()" size="sm">Setup</b-button>
             <b-button v-if="video.startDate" variant="quanteec" @click="deleteVODAsLive()" size="sm">Clear</b-button>
           </b-row>
          -->

            <div
              style="margin: 1rem 3rem; border-bottom: 1px solid white"
            ></div>
          </div>

          <small>
            <strong style="margin-right: 0.3rem"
              >{{ $ml.get("plandd") }}
            </strong>
            <font-awesome-layers style="margin-right: 15px">
              <font-awesome-icon icon="share" />
              <font-awesome-icon
                style="color: red"
                icon="trash"
                transform="shrink-4 right-14 up-3"
              />
            </font-awesome-layers>
          </small>
          <p style="margin-top: 5px">
            <small>
              {{ $ml.get("videoplandd") }}
              <strong>
                <span v-if="video.deleteDate">{{ vdeleteDateShow }}</span>
                <span v-else>{{ $ml.get("nodates") }} </span>
              </strong>
            </small>
          </p>

          <b-row
            class="align-items-center justify-content-center"
            style="margin: 15px 0px"
          >
            <b-button
              v-if="deleteDate && deleteDateShow !== vdeleteDateShow"
              variant="quanteeclg"
              @click="
                deleteDate = video.deleteDate;
                deleteDateShow = vdeleteDateShow;
              "
              size="sm"
              style="margin: 0px 5px"
            >
              <font-awesome-icon style="color: red" :icon="['fas', 'times']" />
            </b-button>

            <date-picker
              id="example-datepicker2"
              :attributes="attributes"
              size="sm"
              @input="adjustDate()"
              v-model="deleteDate"
              mode="dateTime"
              :timezone="''"
              is24hr
              class="mr-3"
            >
              <template size="sm" v-slot="{ inputEvents }">
                <b-button size="sm" variant="quanteeclg" v-on="inputEvents">
                  <font-awesome-icon
                    :icon="['fas', 'calendar-week']"
                  ></font-awesome-icon
                  >&nbsp;
                  <span v-if="deleteDate">{{ deleteDateShow }}</span>
                  <span v-else>{{ $ml.get("selectdate") }}</span>
                </b-button>
              </template>
            </date-picker>

            <b-button
              v-if="
                deleteDate &&
                deleteDateShow !== vdeleteDateShow &&
                (video.deleteDate === undefined || video.deleteDate === '')
              "
              variant="msstreamblue"
              @click="deleteProgrammed()"
              size="sm"
              style="margin: 0px 5px"
            >
              <font-awesome-icon :icon="['fas', 'check']" />
              {{ $ml.get("setup") }}
            </b-button>
            <b-button
              v-else-if="deleteDate && deleteDateShow !== vdeleteDateShow"
              variant="mswarning"
              @click="deleteProgrammed()"
              size="sm"
              style="margin: 0px 5px"
            >
              <font-awesome-icon :icon="['fas', 'check']" />
              {{ $ml.get("modify") }}
            </b-button>

            <b-button
              v-if="video.deleteDate"
              variant="quanteec"
              @click="deleteDeleteProgrammed()"
              size="sm"
              style="margin: 0px 5px"
            >
              <font-awesome-layers>
                <font-awesome-icon icon="share" />
                <font-awesome-icon icon="slash" transform="left-2" />
              </font-awesome-layers>
              {{ $ml.get("clear") }}
            </b-button>

            <span
              v-if="deleteDate && deleteDate < cd2"
              style="color: red; font-size: 10px; margin-top: 5px"
            >
              <font-awesome-icon icon="exclamation-triangle" />
              {{ $ml.get("selectdatedel") }}
            </span>

            <span
              v-if="
                liveDate &&
                deleteDate &&
                adjustDD(liveDate) > adjustDD(deleteDate)
              "
              style="color: red; font-size: 10px; margin-top: 5px"
            >
              <font-awesome-icon icon="exclamation-triangle" />
              {{ $ml.get("videoselectdatedel") }}
            </span>
          </b-row>

          <div
            v-if="video.type === 'live'"
            style="margin: 1rem 3rem; border-bottom: 1px solid white"
          ></div>

          <b-row class="align-items-center" style="margin: 10px 0px">
            <b-form-checkbox
              size="sm"
              v-model="isChatLive"
              switch
              @input="updateChatLive()"
            />
            <small>
              &nbsp;
              {{
                isChatLive ? $ml.get("chatliveact") : $ml.get("chatlivedesact")
              }}
            </small>
          </b-row>

          <div style="margin: 1rem 3rem; border-bottom: 1px solid white"></div>

          <b-row class="align-items-center" style="margin: 10px 0px">
            <b-form-checkbox size="sm" v-model="isPassword" switch disabled />

            <font-awesome-icon
              v-if="isPassword === true"
              style="color: #2a5d77; margin: 0px 10px 0px 5px"
              :icon="['fas', 'lock']"
              size="sm"
            />

            <font-awesome-icon
              v-else
              style="color: #2a5d77; margin: 0px 10px 0px 5px"
              :icon="['fas', 'lock-open']"
              size="sm"
            />
            <small>
              &nbsp;
              {{
                isPassword ? $ml.get("passwdprot") : $ml.get("passwdnotprot")
              }}
            </small>
          </b-row>

          <b-row class="justify-content-around">
            <b-button
              variant="mswarning"
              size="sm"
              v-if="isPassword"
              @click="passField = true"
            >
              <b-icon icon="shield-lock-fill" />
              {{ $ml.get("modifypwd") }}
            </b-button>

            <b-button
              variant="quanteec"
              size="sm"
              v-if="isPassword"
              @click="
                emptyPass();
                updatePassword();
                passField = false;
              "
            >
              <b-icon icon="shield-slash-fill" />
              {{ $ml.get("removepwd") }}
            </b-button>

            <b-button
              variant="msstreamblue"
              size="sm"
              v-if="isPassword === false"
              @click="passField = true"
            >
              <b-icon icon="shield-fill-plus" />
              {{ $ml.get("addpwd") }}
            </b-button>
          </b-row>

          <b-row
            v-if="passField"
            class="justify-content-center align-items-center m-3"
          >
            <b-form-input
              style="max-width: 180px"
              placeholder="Enter password"
              v-model="password"
              size="sm"
            />

            <b-button
              variant="bordered"
              @click="
                updatePassword();
                passField = false;
              "
              size="sm"
            >
              <font-awesome-icon
                class="pointerEltSB"
                style="color: #14bf98"
                :icon="['fas', 'check']"
              />
            </b-button>

            <b-button variant="borderedx" @click="passField = false" size="sm">
              <font-awesome-icon
                class="pointerEltSB"
                style="color: red"
                :icon="['fas', 'times']"
              />
            </b-button>
          </b-row>

          <!--
          <div v-if="video.type === 'live' && video.encodingStatus !== 'encoded' " style="margin: 1rem 3rem; border-bottom: 1px solid white"></div>
          
          <b-row v-if="video.type === 'live' && video.encodingStatus !== 'encoded' " class="align-items-center" style="margin: 10px 0px">
            
            <b-form-checkbox size="sm" v-model="isKeepLive" switch @input="updateKeepLive()"/>
            <font-awesome-layers
              style="margin: 0px 10px 0px 5px"
              v-if="isKeepLive === true"
              size="sm"
            >
              <font-awesome-icon 
              style="color: #2a5d77" 
              :icon="['fas', 'video']"
              transform="shrink-5 right-6 up-6"
              />
              <font-awesome-icon style="color: #2a5d77" :icon="['fas', 'film']" />
              <font-awesome-icon size="sm" style="color: #14bf98" :icon="['fas', 'check-circle']" transform="shrink-4 down-4 right-13" />
            </font-awesome-layers>

            <font-awesome-layers
              style="margin: 0px 10px 0px 5px"
              v-if="isKeepLive === false"
              size="sm"
            >
              <font-awesome-icon 
              style="color: #2a5d77" 
              :icon="['fas', 'video']"
              transform="shrink-5 right-6 up-6"
              />
              <font-awesome-icon style="color: #2a5d77" :icon="['fas', 'film']" />
              <font-awesome-icon size="sm" style="color: red" :icon="['fas', 'minus-circle']" transform="shrink-4 down-4 right-13" />
            </font-awesome-layers>

            <small>
              &nbsp;
              {{
                isKeepLive
                  ? "Keep as VOD"
                  : "NOT kept as VOD"
              }}
              <font-awesome-icon id="popover1" icon="question-circle"></font-awesome-icon>
              <b-popover size="sm" target="popover1" triggers="hover" placement="top">
                <template #title ><small>Live to VOD</small></template>
                <small>
                  <b>Archives</b> are automatically created each time you stop the stream or when no input is received for 1min. There are no restrictions in re-launching the stream, after it is stopped.
                  <br />
                  <font-awesome-icon style="color:red" icon="exclamation-triangle" />
                  Changing this parameter while in <span style="color:#ba0000">encoding</span> mode restarts the encoding process. The stream will not be available for 30s minimum.
                  <br />This feature uses your storage.
                </small>
              </b-popover>
            </small>
          </b-row>

          <b-row v-if="isVideoLoaded && video.type === 'live' && archivesFromLiveLength > 0" class="m-2 mt-3 justify-content-center">
            <small><strong>
              Existing VOD archives
              <b-badge variant="info">{{archivesFromLiveLength}}</b-badge>
              :</strong>
            </small>
          </b-row>

          <b-row v-for="archive in video.archivesFromLive" v-bind:key="archive.uuid" class="justify-content-center align-items-center mb-2">
            <a :href="'/#/player/' + archive.uuid">
              <b-button variant="msstreamblue" size="sm" title="Click to open the archive page">
                <font-awesome-icon :icon="['fas', 'calendar-minus']" title="Creation date, time"/>
                {{new Date(archive.createdAt).toLocaleString()}}&nbsp;
                <font-awesome-icon :icon="['fas', 'clock']" title="Duration" />
                {{archive.duration_unit}}
              </b-button>
            </a>
            <b-button variant="quanteec" size="sm" style="margin-left:10px" title="Remove archive" @click="removeOther(archive.uuid)" >
                <font-awesome-icon icon="trash" />              
            </b-button>
          </b-row>

          <b-row v-if="isVideoLoaded && video.type === 'live' && isKeepLive" class="m-2 mt-3 justify-content-center">

            <b-form-checkbox
              v-model="isDownload"
              size="sm"
              switch
              @change="updateDownload()"
            />

            <font-awesome-layers
              style="margin: 0px 10px 0px 5px"
              v-if="isDownload === true"
            >
              <font-awesome-icon
                style="color: #2a5d77"
                size="sm"
                :icon="['fas', 'arrow-alt-circle-down']"
              />
              <font-awesome-icon
                style="color: #14bf98"
                size="sm"
                :icon="['fas', 'check-circle']"
                transform="shrink-3 up-5 right-9"
              />
            </font-awesome-layers>

            <font-awesome-layers style="margin: 0px 10px 0px 5px" v-else>
              <font-awesome-icon
                style="color: #2a5d77"
                size="sm"
                :icon="['fas', 'arrow-alt-circle-down']"
              />
              <font-awesome-icon
                style="color: red"
                size="sm"
                :icon="['fas', 'minus-circle']"
                transform="shrink-3 up-5 right-9"
              />
            </font-awesome-layers>
            <small>
              &nbsp;
              {{
                isDownload
                  ? "Download is allowed for all VOD archives"
                  : "Download is NOT allowed for all VOD archives"
              }}
            </small>

          </b-row>
          -->

          <div
            v-if="video.type === 'live' && video.encodingStatus !== 'encoded'"
            style="margin: 1rem 3rem; border-bottom: 1px solid white"
          ></div>

          <b-row
            v-if="video.type === 'live' && video.encodingStatus !== 'encoded'"
            class="align-items-center"
            style="margin: 10px 0px"
          >
            <b-form-checkbox
              size="sm"
              v-model="isSeekLive"
              switch
              @input="updateSeekLive()"
            />

            <font-awesome-layers
              style="margin: 0px 10px 0px 5px"
              v-if="isSeekLive === true"
            >
              <font-awesome-icon
                style="color: #2a5d77"
                size="sm"
                :icon="['fas', 'backward']"
              />
              <font-awesome-icon
                style="color: #14bf98"
                size="sm"
                :icon="['fas', 'check-circle']"
                transform="shrink-4 up-5 right-13"
              />
            </font-awesome-layers>

            <font-awesome-layers
              style="margin: 0px 10px 0px 5px"
              v-if="isSeekLive === false"
            >
              <font-awesome-icon
                style="color: #2a5d77"
                size="sm"
                :icon="['fas', 'backward']"
              />
              <font-awesome-icon
                style="color: red"
                size="sm"
                :icon="['fas', 'minus-circle']"
                transform="shrink-4 up-5 right-13"
              />
            </font-awesome-layers>
            <small>
              &nbsp;
              {{
                isSeekLive ? $ml.get("viewersauth") : $ml.get("viewersnotauth")
              }}
            </small>
          </b-row>

          <b-row
            class="align-items-center justify-content-center mb-3"
            v-if="
              video.type === 'live' &&
              video.keepLive === false &&
              video.seekLive === true &&
              video.encodingStatus !== 'encoded'
            "
          >
            <small>
              <strong style="margin-right: 0.3rem"
                >{{ $ml.get("nbrofstk") }}&nbsp;</strong
              >
            </small>
            <b-form-input
              size="sm"
              v-model="liveToKeepDuration"
              type="number"
              min="30"
              style="width: 160px"
              placeholder="Saved seconds"
              max="600"
            ></b-form-input>
            <b-button
              variant="msstreamblue"
              style="margin-left: 1rem"
              @click="setupSecondsToKeep()"
              size="sm"
              >Setup</b-button
            >
          </b-row>

          <div
            v-if="isVideoLoaded && video.type !== 'live'"
            style="margin: 1rem 3rem; border-bottom: 1px solid white"
          ></div>

          <b-row
            v-if="isVideoLoaded && video.type !== 'live'"
            class="align-items-center"
            style="margin: 5px 0px"
          >
            <b-form-checkbox
              v-model="isDownload"
              size="sm"
              switch
              @input="updateDownload()"
            />

            <font-awesome-layers
              style="margin: 0px 10px 0px 5px"
              v-if="isDownload === true"
            >
              <font-awesome-icon
                style="color: #2a5d77"
                size="sm"
                :icon="['fas', 'arrow-alt-circle-down']"
              />
              <font-awesome-icon
                style="color: #14bf98"
                size="sm"
                :icon="['fas', 'check-circle']"
                transform="shrink-3 up-5 right-9"
              />
            </font-awesome-layers>

            <font-awesome-layers style="margin: 0px 10px 0px 5px" v-else>
              <font-awesome-icon
                style="color: #2a5d77"
                size="sm"
                :icon="['fas', 'arrow-alt-circle-down']"
              />
              <font-awesome-icon
                style="color: red"
                size="sm"
                :icon="['fas', 'minus-circle']"
                transform="shrink-3 up-5 right-9"
              />
            </font-awesome-layers>
            <small>
              &nbsp;
              {{ isDownload ? $ml.get("videodwnl") : $ml.get("videonotdwnl") }}
            </small>
            <span
              v-if="
                video.type === 'live' &&
                video.encodingStatus !== 'encoded' &&
                video.encodingStatus !== 'stopped'
              "
              ><small>*</small></span
            >

            <div
              v-if="
                video.type === 'live' &&
                video.encodingStatus !== 'encoded' &&
                video.encodingStatus !== 'stopped'
              "
              style="margin-top: 5px; font-size: 10px"
            >
              *This parameter will only be available after the live, if the
              stream is planned to be stored as a VOD
            </div>
          </b-row>

          <div style="margin: 1rem 3rem; border-bottom: 1px solid white"></div>

          <b-row class="align-items-center" style="margin: 5px 0px">
            <b-form-checkbox
              v-model="isAutoplay"
              size="sm"
              switch
              @input="updateAutoplay()"
            />

            <font-awesome-layers
              style="margin: 0px 10px 0px 5px"
              v-if="isAutoplay === true"
            >
              <font-awesome-icon
                style="color: #2a5d77"
                size="sm"
                :icon="['fas', 'play']"
                transform="right-3"
              />
              <font-awesome-icon
                style="color: #14bf98"
                size="sm"
                :icon="['fas', 'check-circle']"
                transform="shrink-3 up-7 right-9"
              />
            </font-awesome-layers>

            <font-awesome-layers style="margin: 0px 10px 0px 5px" v-else>
              <font-awesome-icon
                style="color: #2a5d77"
                size="sm"
                :icon="['fas', 'play']"
                transform="right-3"
              />
              <font-awesome-icon
                style="color: red"
                size="sm"
                :icon="['fas', 'minus-circle']"
                transform="shrink-3 up-7 right-9"
              />
            </font-awesome-layers>
            <small>
              &nbsp;
              {{
                isAutoplay
                  ? $ml.get("videoautolaunch")
                  : $ml.get("videonotautolaunch")
              }}

              <!--<span v-if="video.keepLive === false" style="color:red">&nbsp;- Live not kept as a VOD</span>-->
            </small>
          </b-row>

          <div style="margin: 1rem 3rem; border-bottom: 1px solid white"></div>


          <b-row class="align-items-center" style="margin: 5px 0px">
            <b-form-checkbox
              v-model="isIntroModal"
              size="sm"
              switch
              @input="updateIntroModal()"
            />

            <font-awesome-layers
              style="margin: 0px 10px 0px 5px"
              v-if="isIntroModal === true"
            >
              <font-awesome-icon
                style="color: #2a5d77"
                size="sm"
                :icon="['fas', 'clipboard-list']"
                transform="right-3"
              />
              <font-awesome-icon
                style="color: #14bf98"
                size="sm"
                :icon="['fas', 'check-circle']"
                transform="shrink-3 up-7 right-9"
              />
            </font-awesome-layers>

            <font-awesome-layers style="margin: 0px 10px 0px 5px" v-else>
              <font-awesome-icon
                style="color: #2a5d77"
                size="sm"
                :icon="['fas', 'clipboard-list']"
                transform="right-3"
              />
              <font-awesome-icon
                style="color: red"
                size="sm"
                :icon="['fas', 'minus-circle']"
                transform="shrink-3 up-7 right-9"
              />
            </font-awesome-layers>
            <small>
              &nbsp;
              {{
                isIntroModal
                  ? $ml.get("videointromodal")
                  : $ml.get("videonotintromodal")
              }}

              <!--<span v-if="video.keepLive === false" style="color:red">&nbsp;- Live not kept as a VOD</span>-->
            </small>
          </b-row>

          <div style="margin: 1rem 3rem; border-bottom: 1px solid white"></div>

          <small>
            <strong style="margin-right: 0.3rem">Thumbnail: </strong>
            <font-awesome-icon icon="image" />

            <b-row class="align-items-center" style="margin: 15px 0px">
              <b-col cols="7">
                <b-img
                  style="max-height: 150px"
                  :src="thumbnailURL"
                  fluid
                  @error="imgUrlAlt"
                ></b-img>
              </b-col>

              <b-col cols="5">
                <b-row class="mb-2 ml-1">
                  <input
                    type="file"
                    accept="image/*"
                    @change="selectandUploadThumbnail($event)"
                    id="file-input"
                    class="inputfile"
                    size="sm"
                  />
                  <label
                    class="pointerOrange"
                    style="text-align: center; line-height: normal"
                    for="file-input"
                  >
                    <font-awesome-icon icon="image" />&nbsp;
                    <small>
                      <span
                        v-if="
                          video.customThumbnailPath !== null &&
                          video.customThumbnailPath !== undefined &&
                          video.customThumbnailPath !== ''
                        "
                      >
                        {{ $ml.get("modifyct") }}
                      </span>
                      <span v-else> {{ $ml.get("custimizet") }}</span>
                    </small>
                  </label>
                </b-row>
                <b-row
                  v-if="
                    video.customThumbnailPath !== null &&
                    video.customThumbnailPath !== undefined &&
                    video.customThumbnailPath !== ''
                  "
                  class="mb-2 ml-1"
                >
                  <b-button
                    variant="quanteec"
                    size="sm"
                    @click="removeThumbnail()"
                  >
                    <small>
                      <font-awesome-layers>
                        <font-awesome-icon icon="image" />
                        <font-awesome-icon
                          icon="slash"
                          transform="left-2"
                        /> </font-awesome-layers
                      >&nbsp;
                      {{ $ml.get("removect") }}
                    </small>
                  </b-button>
                </b-row>
              </b-col>
            </b-row>
          </small>

          <!--
          <div v-if="video.type === 'vod' && !video.inAndOutOrigin" style="margin: 1rem 3rem; border-bottom: 1px solid white"></div>

          <small v-if="video.type === 'vod' && !video.inAndOutOrigin">
            <strong style="margin-right: 0.3rem">
              In & out:&nbsp;
              <font-awesome-icon icon="cut" />
            </strong>
            Creating cut-versions of the video
            <font-awesome-icon id="popover2" icon="question-circle"></font-awesome-icon>
            <b-popover size="sm" target="popover2" triggers="hover" placement="top">
              <template #title><small>Cut-versions mode</small></template>
              <small>
                Create new VODs from the original with different timeframes in two different modes:
                <br>
                <b>'Accurate'</b> mode: the video will respect exactly the timeframe entered but its creation will last at minimum the duration of the video.
                <br> 
                <b>'Fast'</b> mode: the video will respect approximately the timeframe entered - it may vary up to a few seconds - but its creation will be almost instanteneous.
              </small>
            </b-popover>

          </small>
            
          <b-row v-if="video.type === 'vod' && !video.inAndOutOrigin" class="align-items-center" style="margin: 15px 0px">
            <small>
              Start:
              <vue-timepicker
                v-model="inAndOut.start"
                format="HH:mm:ss"
                @close="verifyEndInAndOut($event, 'start')"
                class="ml-2 mr-2"
                :disabled="video.inAndOutOrigin !== undefined"
              ></vue-timepicker>
            </small>
            <small class="ml-2">
              End: 
              <vue-timepicker
                v-model="inAndOut.end"
                format="HH:mm:ss"
                @close="verifyEndInAndOut($event, 'end')"
                class="ml-2 mr-3"
                :disabled="video.inAndOutOrigin !== undefined"
              ></vue-timepicker>
            </small>
            
            <b-row class="align-items-center m-2">
            
              <b-button size="sm" id="popover-target-1" variant="invisibleN" @click="isFastIO = false" :disabled="video.inAndOutOrigin !== undefined" >
                <span v-if="isFastIO === false" style="color:#14BF98"><b>Accurate</b></span>
                <span v-else>Accurate</span>
              </b-button>
              <b-popover size="sm" target="popover-target-1" triggers="hover" placement="top">
                <template #title ><small>Cut-versions mode</small></template>
                <small><b>'Accurate'</b> mode: the video will respect exactly the timeframe entered but its creation will last at minimum the duration of the video.
                <br> 
                <b>'Fast'</b> mode: the video will respect approximately the timeframe entered - it may vary up to a few seconds - but its creation will be almost instanteneous.
                </small>
              </b-popover>

              <b-form-checkbox
                v-model="isFastIO"
                switch
                size="sm"
                
                :disabled="video.inAndOutOrigin !== undefined"
              />

              <b-button size="sm" id="popover-target-2" variant="invisibleN" @click="isFastIO = true" :disabled="video.inAndOutOrigin !== undefined" >
                <span v-if="isFastIO === true" style="color:#14BF98"><b>Fast</b></span>
                <span v-else>Fast</span>
              </b-button>
              <b-popover size="sm" target="popover-target-2" triggers="hover" placement="top">
                <template #title><small>Cut-versions mode</small></template>
                <small><b>'Accurate'</b> mode: the video will respect exactly the timeframe entered but its creation will last at minimum the duration of the video.
                <br> 
                <b>'Fast'</b> mode: the video will respect approximately the timeframe entered - it may vary up to a few seconds - but its creation will be almost instanteneous.
                </small>
              </b-popover>

            </b-row>

            <b-button size="sm" style="margin-left:1rem" v-if="isFastIO === true" variant="msstreamblue" @click="putInAndOut(false)" :disabled="video.inAndOutOrigin !== undefined" >
              <b-icon icon="plus-circle" />
            </b-button>
            <b-button size="sm" style="margin-left:1rem" v-else variant="msstreamblue" @click="showModal('confirmSlowInAndOut')" :disabled="video.inAndOutOrigin !== undefined" >
              <b-icon icon="plus-circle" />
            </b-button>
          </b-row>
          <!--
          <b-row v-if="!video.inAndOutOrigin" class="justify-content-around">
            <b-button variant="msstreamblue" size="sm" @click="putInAndOut(false)">
              <b-icon icon="plus-circle" /> Fast and less precised
            </b-button>
            <b-button variant="msstreamblue" size="sm" @click="showModal('confirmSlowInAndOut');">
              <b-icon icon="plus-circle" /> Precised and slow
            </b-button>
          </b-row>
          -->
          <!--
          <b-row v-if="video.inAndOutOrigin" class="justify-content-around align-items-center marginaltopsm">
            <a :href="'/#/player/' + video.inAndOutOrigin">
            <b-button variant="msstreamblue" size="sm">
              <font-awesome-icon icon="eye" />
              Back to original video
            </b-button>
            </a>
          </b-row>
          -->
          <!--
          <div v-if="video.videoInAndOut && listInAndOut.length > 0" class="m-2" style="text-align:center">
            <p>
              <small><strong>
                Existing cut-versions
                <b-badge variant="success">{{listInAndOut.length}}</b-badge>
                :</strong>
              </small>
            </p>
            <b-row v-for="(inAndOut, index) in listInAndOut" :key="index" class="justify-content-center align-items-center mb-2">
              <a :href="'/#/player/' + inAndOut.uuid">
                <b-button variant="msstreamblue" size="sm" title="Click to open the related video page">
                  <font-awesome-icon icon="eye" />
                  Start: {{inAndOut.start}}s - End: {{inAndOut.end}}s&nbsp;
                  <span v-if="inAndOut.type === 'precise'">
                    Accurate
                  </span>
                  <span v-else> 
                    Fast
                  </span>
                </b-button>
              </a>
              <b-button variant="quanteec" size="sm" style="margin-left:10px" title="Remove cut-version" @click="removeOther(inAndOut.uuid)" >
                  <font-awesome-icon icon="trash" />              
              </b-button>
            </b-row>
          </div>

          <!--
          <div style="margin-top:5px"><small><small><sup>1</sup></small>'Accurate' mode: the video will respect exactly the timeframe entered but its creation will last at minimum the duration of the video.</small></div>
          <div style="margin-top:5px"><small><small><sup>2</sup></small>'Fast' mode: the video will respect approximately the timeframe entered - it may vary up to a few seconds - but its creation will be almost instanteneous.</small></div>
          <div v-if="video.type === 'live' && video.encodingStatus !== 'encoded' && video.encodingStatus !== 'stopped'" style="margin-top:5px"><small> *This parameter will only be applied after the live, if the stream is planned to be stored as a VOD.</small></div>
          -->

          <div style="margin: 1rem 3rem; border-bottom: 1px solid white"></div>

          <small style="margin-bottom: 5px">
            <strong style="margin-right: 0.3rem">
              {{ $ml.get("chapters") }}
              <!--
              <span v-if="video.type === 'live' && video.encodingStatus !== 'encoded' && video.encodingStatus !== 'stopped'"><small>*</small></span>
              -->
            </strong>
            <font-awesome-layers style="margin-right: 5px">
              <font-awesome-icon :icon="['fas', 'list-ol']" />
              <font-awesome-layers-text
                v-if="
                  video.chapters !== undefined && video.chapters.length !== 0
                "
                class="fa-inverse"
                transform="shrink-4 up-5 right-6"
                style="
                  color: #14bf98;
                  background-color: #f2f2f2;
                  font-weight: bold;
                "
                :title="video.chapters.length + ' chapter(s) present'"
                :value="video.chapters.length"
              />
              <font-awesome-layers-text
                v-else
                class="fa-inverse"
                transform="shrink-4 up-5 right-6"
                style="
                  color: #14bf98;
                  background-color: #f2f2f2;
                  font-weight: bold;
                "
                title="No chapters"
                value="0"
              />
            </font-awesome-layers>
            <span
              v-if="video.chapters !== undefined && video.chapters.length !== 0"
            >
              &nbsp;{{ video.chapters.length }} {{ $ml.get("chapter") }}
            </span>
            <span v-else> &nbsp;{{ $ml.get("nochapter") }} </span>
          </small>

          <b-row class="align-items-center justify-content-center">
            <b-button
              variant="mswarning"
              style="margin: 5px"
              size="sm"
              v-if="chapters !== undefined && chapters.length !== 0"
              @click="modifyChapters = !modifyChapters"
              :style="
                modifyChapters
                  ? { color: '#14BF98', backgroundColor: 'white' }
                  : {}
              "
              title="Edit to modify chapters manually"
            >
              <font-awesome-icon :icon="['fas', 'pencil-alt']" />
            </b-button>

            <input
              type="file"
              ref="fileInput"
              id="file-upload2"
              class="inputfile"
              style="margin: 5px !important"
              @input="addandPutChapterFile"
              @click="$refs.fileInput.value = null"
            />
            <label
              for="file-upload2"
              class="pointerBlue"
              title="Click to load/update Chapters file"
              style="text-align: center; margin: 5px !important"
              line-height="normal"
            >
              <font-awesome-icon :icon="['fas', 'upload']" />
              &nbsp; {{ $ml.get("uplchapter") }}
            </label>

            <b-button
              variant="msstreamblue"
              @click="
                initChapter();
                modifyChapters = true;
              "
              size="sm"
              style="margin: 5px"
              title="Add a chapter manually"
            >
              <b-icon icon="plus-circle" />
              {{ $ml.get("addchapman") }}
            </b-button>

            <b-button
              variant="quanteec"
              size="sm"
              v-if="video.chapters !== undefined && video.chapters.length !== 0"
              @click="deleteChapters"
              title="Delete chapters"
              style="margin: 5px"
            >
              <font-awesome-layers>
                <font-awesome-icon :icon="['fas', 'list-ol']" />
                <font-awesome-icon
                  :icon="['fas', 'times']"
                  transform="shrink-5 up-5 right-6"
                />
              </font-awesome-layers>
            </b-button>
          </b-row>

          <b-row class="align-items-center" style="margin: 0px"> </b-row>

          <small v-if="!modifyChapters">
            <b-row
              class="align-items-center justify-content-center"
              style="margin: 0.5rem 0rem"
              v-for="(chapter, index) in chapters_show"
              :key="index"
            >
              <p style="margin: 0px 5px">
                <strong>{{ chapter.text }}</strong>
              </p>
              <p style="margin: 0px 5px">{{ chapter.start }} --></p>
              <p style="margin: 0px 5px">{{ chapter.end }}</p>
            </b-row>
          </small>

          <small v-if="modifyChapters">
            <b-row
              class="align-items-center justify-content-center"
              style="margin: 0.5rem 0rem"
              v-for="(chapter, chapterindex) in chapters"
              v-bind:key="chapterindex"
            >
              <p style="margin: 0px 5px">
                <b-form-input
                  style="width: 8rem; height: 2rem; text-align: center"
                  v-model="chapters[chapterindex].text"
                  placeholder="Title"
                  type="text"
                  size="sm"
                >
                </b-form-input>
              </p>
              <p style="margin: 0px 5px">
                Start:
                <vue-timepicker
                  v-model="chapters[chapterindex].start"
                  format="HH:mm:ss"
                  @close="verifyChapterEnd($event, chapterindex, 'start')"
                ></vue-timepicker>
              </p>
              <p style="margin: 0px 5px">
                End:
                <vue-timepicker
                  v-model="chapters[chapterindex].end"
                  format="HH:mm:ss"
                  @close="verifyChapterEnd($event, chapterindex, 'end')"
                ></vue-timepicker>
              </p>
              <b-button
                variant="empty"
                size="sm"
                @click="removeChapter(chapterindex)"
              >
                <font-awesome-icon
                  style="color: red"
                  :icon="['fas', 'times']"
                />
              </b-button>
            </b-row>
            <p
              style="margin: 10px; text-align: center"
              v-if="chapters === undefined || chapters.length === 0"
            >
              {{ $ml.get("nochapter") }}
            </p>
          </small>

          <b-row class="align-items-center justify-content-center">
            <b-button
              v-if="modifyChapters"
              variant="emptyBB"
              size="sm"
              @click="
                updateChapters();
                showAndHideModal('confirmChapterChange');
              "
            >
              <font-awesome-icon
                style="color: #14bf98"
                class="pointerEltSB"
                :icon="['fas', 'check']"
              />
            </b-button>
            <b-button
              v-if="modifyChapters"
              variant="emptyBBx"
              @click="cancelChapters"
              size="sm"
            >
              <font-awesome-icon
                style="color: red"
                :icon="['fas', 'times']"
                class="pointerEltSB"
              />
            </b-button>
          </b-row>
          <div v-if="video.type === 'vod'" style="margin: 1rem 3rem; border-bottom: 1px solid white"></div>

          <b-row class="justify-content-center" v-if="video && video.type === 'vod'">
            <b-col cols="auto">
                <ReplaceComponent :video="video"></ReplaceComponent>
            </b-col>
          </b-row>

          <!--
          <div v-if="video.type === 'live' && video.encodingStatus !== 'encoded' && video.encodingStatus !== 'stopped'" style="margin-top:5px"><small> *This parameter will only be applied after the live, if the stream is planned to be stored as a VOD.</small></div>
          -->
        </b-col>
      </b-row>

      <!--
    <b-row align-h="around">
      <b-button variant="green" @click="$router.push('/')"> ◄ Go back to video list</b-button>
      <b-button v-if="video.canResume" variant="green" @click="$router.push('/capture/' + video.uuid)">Resume live</b-button>
      <b-button v-if="video.editor" variant="green" @click="openLink(video)">Open in editor</b-button>
       <b-button variant="quanteec"  @click="showModal('deleteModal')" v-if="this.$auth.getMyUser().roles.indexOf('manager') > -1 || this.$auth.getMyUser() === video.user">
          <font-awesome-icon :icon="['fas', 'trash-alt']"></font-awesome-icon> Remove
        </b-button>
    </b-row>


    <div class="marginal">
      <b-row class="mypanel">
        <b-col cols="12">
          <h4>INFOS <b-btn variant="orangesmall" title="Refresh" @click="refreshVideo">
              &#x21BA;
            </b-btn></h4>
        </b-col>
        <b-col cols="12" md="6">
          <h6>UUID:</h6>
          <p>{{video.uuid}}</p>
          <h6>TYPE:</h6>
          <p>
            {{video.type}}
          </p>
          <h6 @click="refreshDuration()" style="cursor: pointer;">DURATION:</h6>
          <p>{{fancyDurationFormat}}</p>
          <h6 v-if="video.type=='live'">LIVE URL:</h6>
          <p v-if="video.type=='live'">{{video.sourcePath}}</p>
        </b-col>
        <b-col cols="12" md="6">
          <div v-if="video.encodingStatus &&  (video.encodingStatus === 'encoding' || video.encodingStatus === 'segmented') && video.encodingPercent && video.encodingPercent < 100">
              <h6>Encoding percent:</h6>
              <b-progress :value="video.encodingPercent" :max="100" show-progress animated></b-progress>
          </div>
          <h6>
            ENCODING STATUS:
            <b-btn v-if="['error', 'encoded', 'stopped'].indexOf(video.encodingStatus) > -1" variant="greensmall" title="Restart encoding" @click="restartEncoding">
              <font-awesome-icon :icon="['fas', 'cogs']"></font-awesome-icon>
            </b-btn>
            <b-btn v-if="['encoding', 'waiting_for_encoding', 'restart','segmented'].indexOf(video.encodingStatus) > -1" variant="redsmall" title="Stop encoding" @click="stopEncoding">
              <font-awesome-icon :icon="['fas', 'stop']"></font-awesome-icon>
            </b-btn>
            <b-btn v-if="['to_stop', 'to_encode'].indexOf(video.encodingStatus) > -1" variant="orangesmall" title="Refresh" @click="refreshVideo">
              &#x21BA;
            </b-btn>
            <span v-if="['error', 'encoded', 'stopped'].indexOf(video.encodingStatus) > -1" class="text-green"> Erase current video and restart encoding</span>
            <span v-if="['encoding', 'waiting_for_encoding', 'restart','segmented'].indexOf(video.encodingStatus) > -1" class="text-red"> Stop encoding</span>
            <span v-if="['to_stop', 'to_encode'].indexOf(video.encodingStatus) > -1" class="text-orange"> Refresh status</span>
          </h6>
          <p>
            {{video.encodingStatus}}
          </p>
          <h6>DATE OF CREATION:</h6>
          <p>{{createdAt}}</p>

          <div style="cursor: pointer;">
            <b-form-checkbox
                v-model="isDownload"
                switch
                @input="updateDownload()"
              
            > 
                {{(isDownload) ? 'The video can be downloaded' : 'The video can NOT be downloaded'}}
            </b-form-checkbox>
          </div>


<h6>PROBLEM STATUS: <strong>{{totalErrors}}</strong></h6>
                        <p class="ml-5">Nb of other errors: {{video.otherError || 0}}</p>
                        <p class="ml-5">Nb of ffmpeg errors: {{video.ffmpegError || 0}} </p>
                        <p class="ml-5">Nb of timeout errors: {{video.timeoutError || 0}}</p>
          <p class="ml-5">Nb of audio errors: {{video.audioError || 0}}</p>
        </b-col>
      </b-row>
    </div>

    <div class="marginal">
      <b-row class="mypanel">
        <b-col cols="12">
          <h4>TAGS & DESCRIPTION</h4>
        </b-col>
        <b-col cols="12" md="6">
          <h6>Tags </h6>

          <div style="margin-top: 7px;margin-bottom: 7px;">
            <tags-input element-id="tags" 
              v-model="tags" @tags-updated="updateTags"></tags-input>
          </div>
          
        </b-col>
        <b-col cols="12" md="6">
         <h6>Description <font-awesome-icon :icon="['fas', 'pencil-alt']" style="cursor: pointer" @click="modifyDescription = !modifyDescription"></font-awesome-icon></h6>
            <div style="margin-top: 7px;margin-bottom: 7px;">
              <div v-if="!modifyDescription">
                  {{description}}
              </div>
              <div v-if="modifyDescription">

                <b-form @submit.prevent="updateDescription">
                  <b-form-textarea
                    id="textarea"
                    v-model="description"
                    placeholder="Write description"
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea>
                  <b-row class="justify-content-center" style="margin-top: 7px;">
                    <b-col cols="auto">
                      <b-button variant="mswarning" type=submit>Submit</b-button>
                    </b-col>
                  </b-row>
                </b-form>

              </div>
            </div>
        </b-col>
      </b-row>
    </div>

    <div class="marginal" v-if="video.type === 'vod' || (video.type === 'live' && video.keepLive === true)">
      <b-row class="mypanel">
        <b-col cols="12">
          <b-row align-v="center">
            <b-col cols="auto">
              <h4>Chapters </h4>
            </b-col>
            <b-col cols="auto">
              <font-awesome-icon :icon="['fas', 'pencil-alt']" style="cursor: pointer; " @click="modifyChapters = !modifyChapters"></font-awesome-icon>
            </b-col>
          </b-row>
          <div v-if="!modifyChapters">
            <b-row>
              <b-col v-for="chapter in chapters" v-bind:key="chapter.text" lg="3" md="6" cols="12">
                <p>{{chapter.text}}</p>
                <p>{{chapter.start}} --><!-- {{chapter.end}} s</p>
              </b-col>
            </b-row>
          </div>

          <div v-if="modifyChapters">
            <b-row>
              <b-col>
                <input id="file-upload" @input="addChapterFile" type="file"/>
              </b-col>
              <b-col>
                <b-button @click="putChapterFile">Send chapter file</b-button>
              </b-col>
            </b-row>
            <b-row style="margin-top: 7px;">
              <b-col style="border: solid 1px;" v-for="(chapter, chapterindex) in chapters" v-bind:key="chapter" lg="3" md="6" cols="12">
                <b-row align-v="center">
                  <b-col cols="9">
                    <b-form-input v-model="chapters[chapterindex].text" placeholder="Name of the chapter" type="text"></b-form-input>
                    Start: <vue-timepicker v-model="chapters[chapterindex].start" format="HH:mm:ss"></vue-timepicker> 
                    End: <vue-timepicker v-model="chapters[chapterindex].end" format="HH:mm:ss"></vue-timepicker>
                  </b-col>
                  <b-col cols="3">
                    <b-button variant="redsmall" @click="removeChapter(chapterindex)"><font-awesome-icon :icon="['fas', 'trash-alt']"></font-awesome-icon></b-button>
                  </b-col>
                </b-row>

              </b-col>
            </b-row>
            <b-row class="justify-content-center marginal">
              <b-col cols="auto">
                <b-button variant="mswarning" @click="initChapter">+ add a chapter</b-button>
              </b-col>
              <b-col cols="auto">
                <b-button variant="green" @click="updateChapters">Submit changes</b-button>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-row class="mypanel">
      <b-row>
        <b-col cols="12">
          <h4>WATCH WITH QUANTEEC</h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-md-12 col-sm-12">
          <b-row>
            <b-col style="margin-bottom: 10px">
              <h6>
                DIRECT LINK
                <b-btn
                  title="Copy link to clipboard"
                  variant="msstreambluesmall"
                  @click="copyDirectLink();showAndHideModal('confirmClickDirectLink')"
                >
                  <font-awesome-icon :icon="['fas', 'clone']"></font-awesome-icon>
                </b-btn>
                <br />
              </h6>
              
              <p style="color: grey">
                This code is a direct link opening a new window with a responsive player for this video.
                <br />
              </p>

              <code ref="codeToCopy" style="color:#ba0000">{{directLink}}</code>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="mypanel">
              <h6>
                EXPORT
                <b-btn
                  variant="msstreambluesmall"
                  title="Copy iframe to clipboard"
                  @click="copyEmbeded();showAndHideModal('confirmClickExport')"
                >
                  <font-awesome-icon :icon="['fas', 'clone']"></font-awesome-icon>
                </b-btn>
                <br />
              </h6>
              <p style="color: grey">
                Copy this code and put it in your html page to export a responsive player for this video
                <br />
              </p>
              <code ref="codeToCopy" style="color:#ba0000">{{embeded}}</code>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-row>
-->

      <!-- CLOUDFLARE 
      <b-row v-if="isVideoLoaded && video.type === 'live' && archivesFromLiveLength> 0">
        <b-col cols="12" class="mypanel">
          <h5
            style="
              text-align: center;
              color: #2a5d77;
              padding-bottom: 5px;
              margin-bottom: 15px;
              border-bottom: 1px solid #2a5d77;
            "
          >
            <b-img fluid :src="require(`@/assets/logo.svg`)" style="max-height:20px" />
            &nbsp;
            Archives from my Live on Quanteec
          </h5>
          <b-row class="justify-content-center">
            <b-col md="4" lg="3" cols="6" v-for="archive in video.archivesFromLive" v-bind:key="archive.uuid">
              <b-row title="Archive">
                <b-col cols="12">
                   <b-button variant="msstreamblue" @click="$router.push('/player/' + archive.uuid)">
                   <b-row class="justify-content-center">
                     <b-col cols="auto">
                      <font-awesome-icon :icon="['fas', 'calendar-minus']" />
                      {{new Date(archive.createdAt).toLocaleString()}}
                     </b-col>
                   </b-row>
                   <b-row class="justify-content-center">
                     <b-col cols="auto">
                      <font-awesome-icon :icon="['fas', 'clock']" /> {{archive.duration_unit}}
                     </b-col>
                   </b-row>
                  </b-button>
                </b-col>
              </b-row>
              
            </b-col>
          </b-row>
        </b-col>
      </b-row>
-->

      <!-- CLOUDFLARE -->
      <b-row
        v-if="
          $auth.getMyUser().client_infos[0].cloudflare &&
          isVideoLoaded &&
          video.type === 'live' &&
          acceleratedVoD.length > 0
        "
      >
        <b-col cols="12" class="mypanel">
          <h5
            style="
              text-align: center;
              color: #2a5d77;
              padding-bottom: 5px;
              margin-bottom: 15px;
              border-bottom: 1px solid #2a5d77;
            "
          >
            <b-img
              fluid
              :src="require(`@/assets/logo.svg`)"
              style="max-height: 20px"
            />
            &nbsp;
            {{ $ml.get("vodacc") }}
          </h5>
          <b-row class="justify-content-center">
            <b-col
              md="4"
              lg="3"
              cols="6"
              v-for="(vod, vodIdx) of acceleratedVoD"
              v-bind:key="vodIdx"
            >
              <b-row title="Name of the video">
                <b-col cols="12">
                  <p
                    style="
                      margin-bottom: 10px;
                      padding-bottom: 5px;
                      color: #2a5d77;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      white-space: nowrap;
                      text-align: center;
                    "
                  >
                    <strong> {{ vod.name }}</strong>
                  </p>
                </b-col>
              </b-row>
              <b-row class="justify-content-center">
                <div class="previewContainer" style="z-index: 1">
                  <b-img
                    class="previewImg"
                    style="object-fit: contain"
                    :src="vod.thumbnail"
                    @error="imgUrlAlt"
                    fluid
                  ></b-img>
                </div>
              </b-row>
              <b-row
                class="justify-content-center marginaltopsm"
                v-if="!video.cloudflareVod || !video.cloudflareVod[vod.uid]"
              >
                <b-col cols="auto">
                  <b-button
                    variant="msstreamblue"
                    @click="postDownloadMpd(vod)"
                  >
                    <font-awesome-icon
                      class="pointerEltSB"
                      :icon="['fas', 'check']"
                    />
                    {{ $ml.get("dnwlQP") }}
                  </b-button>
                </b-col>
              </b-row>
              <b-row
                class="justify-content-center marginaltopsm"
                v-if="video.cloudflareVod && video.cloudflareVod[vod.uid]"
              >
                <b-col cols="auto">
                  <b-button
                    variant="green"
                    @click="
                      $router.push('/player/' + video.cloudflareVod[vod.uid])
                    "
                  >
                    <font-awesome-icon
                      class="pointerEltSB"
                      :icon="['fas', 'check']"
                    />
                    Watch video
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row v-if="isVideoLoaded && video.error === false">
        <b-col cols="12" class="mypanel">
          <h5
            style="
              text-align: center;
              color: #2a5d77;
              padding-bottom: 5px;
              margin-bottom: 15px;
              border-bottom: 1px solid #2a5d77;
            "
          >
            <b-img
              fluid
              :src="require(`@/assets/logo.svg`)"
              style="max-height: 20px"
            />
            &nbsp;
            {{ $ml.get("videoshar") }}
          </h5>
          <!--          
          <b-row v-if="video.type === 'live' && video.encodingStatus === 'encoded' && video.keepLive === false" class="justify-content-center">
            <b-alert
              variant="danger"
              show
              style="margin: 15px; text-align: center"
              class="align-items-center"
            >
              This live video has not been kept as a VoD at the end of the stream. Hence, video sharing is not possible. 
            </b-alert>
          </b-row>
-->
          <b-row
            style="margin-top: 15px"
            class="justify-content-center align-items-center"
          >
            <div style="max-height: 100px">
              <ShareNetwork
                network="twitter"
                :url="directLink"
                title=""
                style="background-color: #1da1f2"
              >
                <font-awesome-icon
                  class="fah"
                  :icon="['fab', 'twitter']"
                ></font-awesome-icon>
                <span><small>Twitter</small></span>
              </ShareNetwork>
            </div>

            <div style="max-height: 100px">
              <ShareNetwork
                network="facebook"
                :url="directLink"
                title=""
                style="background-color: #1877f2"
              >
                <font-awesome-icon
                  class="fah"
                  :icon="['fab', 'facebook']"
                ></font-awesome-icon>
                <span><small>Facebook</small></span>
              </ShareNetwork>
            </div>

            <div style="max-height: 100px">
              <ShareNetwork
                network="linkedin"
                :url="directLink"
                title=""
                style="background-color: #007bb5"
              >
                <font-awesome-icon
                  class="fah"
                  :icon="['fab', 'linkedin']"
                ></font-awesome-icon>
                <span><small>LinkedIn</small></span>
              </ShareNetwork>
            </div>
            <!--
            <div style="max-height: 100px">
              <ShareNetwork
                network="pinterest"
                :url="directLink"
                title=""
                style="background-color: #bd081c"
              >
                <font-awesome-icon
                  class="fah"
                  :icon="['fab', 'pinterest']"
                ></font-awesome-icon>
                <span><small>Share on Pinterest</small></span>
              </ShareNetwork>
            </div>
            -->
            <div style="max-height: 100px">
              <ShareNetwork
                network="tumblr"
                :url="directLink"
                title=""
                style="background-color: #35465c"
              >
                <font-awesome-icon
                  class="fah"
                  :icon="['fab', 'tumblr']"
                  transform="shrink-6"
                ></font-awesome-icon>
                <span><small>Tumblr</small></span>
              </ShareNetwork>
            </div>
            <div style="max-height: 100px">
              <ShareNetwork
                network="wordpress"
                :url="directLink"
                title=""
                style="background-color: #21759b"
              >
                <font-awesome-icon
                  class="fah"
                  :icon="['fab', 'wordpress']"
                ></font-awesome-icon>
                <span><small>Wordpress</small></span>
              </ShareNetwork>
            </div>
          </b-row>
        </b-col>
      </b-row>

      <b-row v-if="isVideoLoaded">
        <b-col cols="12" class="mypanel">
          <h5
            style="
              text-align: center;
              color: #2a5d77;
              padding-bottom: 5px;
              margin-bottom: 15px;
              border-bottom: 1px solid #2a5d77;
            "
          >
            <b-img
              fluid
              :src="require(`@/assets/logo.svg`)"
              style="max-height: 20px"
            />
            &nbsp;
            {{ $ml.get("videoanalytics") }}
          </h5>
          <CompleteAnalytics :video="video"></CompleteAnalytics>
        </b-col>
      </b-row>

      <div style="padding-bottom: 40px"></div>
    </b-container>
    <!--
    <b-modal ref="invalidDateModal" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Error</h3>
      </div>
      <p>Invalid Date</p>
      <b-row>
        <b-col>
          <b-btn
            variant="mswarning"
            block
            @click="hideModal2('invalidDateModal')"
            >Retry</b-btn
          >
        </b-col>
      </b-row>
    </b-modal>

    <b-modal ref="deleteModal" hide-footer hide-header>
      <div class="d-block text-center">
        <h3 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="color: red; margin-right:5px" :icon="['fas', 'trash']" />
          Video deletion
        </h3>
      </div>
      <p style="line-height:normal">
        Please confirm the deletion of video: <strong><span style="color: #2F90B0">{{videoToDelete.title}}</span></strong>. 
        <br>Make sure this video is not linked to one (or more) Project(s).<br> The video cannot be recovered.
      </p>


      <b-row>
        <b-col>
          <b-btn
            variant="quanteec"
            block
            @click="
              removeVideo();
              hideModal('deleteModal');
            "
            ><font-awesome-icon
              :icon="['fas', 'trash-alt']"
            ></font-awesome-icon>
            Remove</b-btn
          >
        </b-col>
        <b-col>
          <b-btn variant="green" block @click="hideModal('deleteModal')"
            >Cancel</b-btn
          >
        </b-col>
      </b-row>

    </b-modal>
    -->
    <b-modal ref="sourcePathChanged" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-icon
            style="margin-right: 5px"
            :icon="['fas', 'file-export']"
          />
          Live source
        </h4>
      </div>
      <p>{{ $ml.get("sourcePathModified") }}</p>
      <b-row class="justify-content-center">
        <b-col cols="auto">
          <b-button
            variant="msstreamblue"
            @click="hideModal('sourcePathChanged')"
            >Ok</b-button
          >
        </b-col>
      </b-row>
    </b-modal>

    <b-modal ref="confirmClickExport" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-icon
            style="margin-right: 5px"
            :icon="['fas', 'file-export']"
          />
          Video iFrame Code
        </h4>
      </div>
      <p style="line-height: normal">
        iFrame code of video:
        <span style="color: #2f90b0">{{ video.title }}</span> is copied to
        Clipboard.
      </p>
    </b-modal>

    <b-modal ref="confirmClickManifest" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-icon
            style="margin-right: 5px"
            :icon="['fas', 'file-export']"
          />
          Video Manifest Code
        </h4>
      </div>
      <p style="line-height: normal">
        Manifest link of video:
        <span style="color: #2f90b0">{{ video.title }}</span> is copied to
        Clipboard.
      </p>
    </b-modal>

    <b-modal ref="confirmClickExportLink" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-layers style="margin-right: 15px">
            <font-awesome-icon
              :icon="['fas', 'file-export']"
              size="lg"
              transform="shrink-8"
            />
            <font-awesome-icon :icon="['far', 'circle']" size="lg" />
          </font-awesome-layers>
          Video iFrame Code of Export Link
        </h4>
      </div>
      <p style="line-height: normal">
        iFrame code of Export Link for video:
        <span style="color: #2f90b0">{{ video.title }}</span> is copied to
        Clipboard.
      </p>
    </b-modal>

    <b-modal ref="confirmClickDirectLink" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-icon
            style="margin-right: 5px"
            :icon="['fas', 'link']"
          />
          Video direct link
        </h4>
      </div>
      <p style="line-height: normal">
        Direct link of video:
        <span style="color: #2f90b0">{{ video.title }}</span> is copied to
        Clipboard.
      </p>
    </b-modal>

    <b-modal ref="modifyExternalStreams" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-icon
            style="margin-right: 5px"
            :icon="['fas', 'link']"
          />
          Live external streams
        </h4>
        <b-form @submit.prevent="onExternalStreams">
          <b-form-group
            label="Simulcast to external platforms*:"
            style="margin-bottom: 0px"
          >
            <b-row
              class="justify-content-around align-items-center"
              style="margin-bottom: 10px"
            >
              <b-col class="liveBrand">
                <font-awesome-icon
                  id="quanteecYoutube"
                  class="quanteecyoutube"
                  :class="{
                    quanteecyoutubevalide: externalStreams.youtube.length > 0,
                  }"
                  :icon="['fab', 'youtube']"
                />
                <b-badge
                  v-if="externalStreams.youtube.length > 0"
                  style="font-size: 12px; background-color: #ff0000"
                  >{{ externalStreams.youtube.length }}</b-badge
                >
              </b-col>
              <b-col class="liveBrand">
                <font-awesome-icon
                  id="quanteecFacebook"
                  class="quanteecfacebook"
                  :class="{
                    quanteecfacebookvalide: externalStreams.facebook.length > 0,
                  }"
                  :icon="['fab', 'facebook']"
                />
                <b-badge
                  v-if="externalStreams.facebook.length > 0"
                  style="font-size: 12px; background-color: #4267b2"
                  >{{ externalStreams.facebook.length }}</b-badge
                >
              </b-col>
              <b-col class="liveBrand">
                <font-awesome-icon
                  id="quanteecTwitch"
                  class="quanteectwitch"
                  :class="{
                    quanteectwitchvalide: externalStreams.twitch.length > 0,
                  }"
                  :icon="['fab', 'twitch']"
                />
                <b-badge
                  v-if="externalStreams.twitch.length > 0"
                  style="font-size: 12px; background-color: #9146ff"
                  >{{ externalStreams.twitch.length }}</b-badge
                >
              </b-col>
              <b-col class="liveBrand">
                <font-awesome-icon
                  id="quanteecOther"
                  class="quanteecother"
                  :class="{
                    quanteecothervalide: externalStreams.other.length > 0,
                  }"
                  :icon="['fas', 'video']"
                />
                <b-badge
                  v-if="externalStreams.other.length > 0"
                  style="font-size: 12px; background-color: #9146ff"
                  >{{ externalStreams.other.length }}</b-badge
                >
              </b-col>

              <b-popover
                ref="popoverYt"
                target="quanteecYoutube"
                triggers="click"
                placement="top"
              >
                <template #title>
                  <b-row class="justify-content-center align-items-center m-2">
                    Stream to YouTube&nbsp;
                    <font-awesome-icon
                      :class="{
                        quanteecyoutubevalide:
                          externalStreams.youtube.length > 0,
                      }"
                      :icon="['fab', 'youtube']"
                    />
                  </b-row>
                </template>

                <b-row
                  class="align-items-center m-1"
                  v-for="(stream, streamid) in externalStreams.youtube"
                  v-bind:key="streamid"
                >
                  <b-col class="m-0 p-0" cols="11">
                    <b-form-input
                      size="sm"
                      type="text"
                      v-model="stream.key"
                      :placeholder="'Enter YouTube key ' + (streamid + 1)"
                    >
                    </b-form-input>
                  </b-col>
                  <b-col class="m-0 p-0" cols="1">
                    <b-button
                      variant="borderedx"
                      v-if="externalStreams.youtube.length > 0"
                      size="sm"
                      @click="externalStreams.youtube.splice(streamid, 1)"
                    >
                      <font-awesome-icon
                        size="sm"
                        style="color: red"
                        icon="times"
                      />
                    </b-button>
                  </b-col>
                </b-row>

                <b-row class="justify-content-center mt-3 mb-3">
                  <b-col cols="auto">
                    <b-button
                      variant="msstreamblue"
                      size="sm"
                      @click="$refs['popoverYt'].$emit('close')"
                    >
                      Ok
                    </b-button>
                  </b-col>
                  <b-col cols="auto">
                    <b-button
                      variant="mswarning"
                      size="sm"
                      @click="externalStreams.youtube.push({ key: '' })"
                    >
                      <b-icon icon="plus-circle" />
                      Add a stream key
                    </b-button>
                  </b-col>
                </b-row>
              </b-popover>

              <b-popover
                ref="popoverFa"
                target="quanteecFacebook"
                triggers="click"
                placement="top"
              >
                <template #title>
                  <b-row class="justify-content-center align-items-center m-2">
                    Stream to Facebook&nbsp;
                    <font-awesome-icon
                      :class="{
                        quanteecfacebookvalide:
                          externalStreams.facebook.length > 0,
                      }"
                      :icon="['fab', 'facebook']"
                    />
                  </b-row>
                </template>

                <b-row
                  class="align-items-center m-1"
                  v-for="(stream, streamid) in externalStreams.facebook"
                  v-bind:key="streamid"
                >
                  <b-col class="m-0 p-0" cols="11">
                    <b-form-input
                      size="sm"
                      type="text"
                      v-model="stream.key"
                      :placeholder="'Enter Facebook key ' + (streamid + 1)"
                    >
                    </b-form-input>
                  </b-col>
                  <b-col class="m-0 p-0" cols="1">
                    <b-button
                      variant="borderedx"
                      v-if="externalStreams.facebook.length > 0"
                      size="sm"
                      @click="externalStreams.facebook.splice(streamid, 1)"
                    >
                      <font-awesome-icon
                        size="sm"
                        style="color: red"
                        icon="times"
                      />
                    </b-button>
                  </b-col>
                </b-row>

                <b-row class="justify-content-center mt-3 mb-3">
                  <b-col cols="auto">
                    <b-button
                      variant="msstreamblue"
                      size="sm"
                      @click="$refs['popoverFa'].$emit('close')"
                    >
                      Ok
                    </b-button>
                  </b-col>
                  <b-col cols="auto">
                    <b-button
                      variant="mswarning"
                      size="sm"
                      @click="externalStreams.facebook.push({ key: '' })"
                    >
                      <b-icon icon="plus-circle" />
                      Add a stream key
                    </b-button>
                  </b-col>
                </b-row>
              </b-popover>

              <b-popover
                ref="popoverTw"
                target="quanteecTwitch"
                triggers="click"
                placement="top"
              >
                <template #title>
                  <b-row class="justify-content-center align-items-center m-2">
                    Stream to Twitch&nbsp;
                    <font-awesome-icon
                      :class="{
                        quanteectwitchvalide: externalStreams.twitch.length > 0,
                      }"
                      :icon="['fab', 'twitch']"
                    />
                  </b-row>
                </template>

                <b-row
                  class="align-items-center m-1"
                  v-for="(stream, streamid) in externalStreams.twitch"
                  v-bind:key="streamid"
                >
                  <b-col class="m-0 p-0" cols="11">
                    <b-form-input
                      size="sm"
                      type="text"
                      v-model="stream.key"
                      :placeholder="'Enter Twitch key ' + (streamid + 1)"
                    >
                    </b-form-input>
                  </b-col>
                  <b-col class="m-0 p-0" cols="1">
                    <b-button
                      variant="borderedx"
                      v-if="externalStreams.twitch.length > 0"
                      size="sm"
                      @click="externalStreams.twitch.splice(streamid, 1)"
                    >
                      <font-awesome-icon
                        size="sm"
                        style="color: red"
                        icon="times"
                      />
                    </b-button>
                  </b-col>
                </b-row>

                <b-row class="justify-content-center mt-3 mb-3">
                  <b-col cols="auto">
                    <b-button
                      variant="msstreamblue"
                      size="sm"
                      @click="$refs['popoverTw'].$emit('close')"
                    >
                      Ok
                    </b-button>
                  </b-col>
                  <b-col cols="auto">
                    <b-button
                      variant="mswarning"
                      size="sm"
                      @click="externalStreams.twitch.push({ key: '' })"
                    >
                      <b-icon icon="plus-circle" />
                      Add a stream key
                    </b-button>
                  </b-col>
                </b-row>
              </b-popover>

              <b-popover
                ref="popoverOt"
                target="quanteecOther"
                triggers="click"
                placement="top"
              >
                <template #title>
                  <b-row class="justify-content-center align-items-center m-2">
                    Stream to any RTMP server&nbsp;
                    <font-awesome-icon
                      :class="{
                        quanteecothervalide: externalStreams.other.length > 0,
                      }"
                      :icon="['fas', 'video']"
                    />
                  </b-row>
                </template>

                <b-row
                  class="align-items-center m-1"
                  v-for="(stream, streamid) in externalStreams.other"
                  v-bind:key="streamid"
                >
                  <b-col class="m-0 p-0" cols="11">
                    <b-row>
                      <b-col cols="12">
                        <b-form-input
                          size="sm"
                          type="text"
                          v-model="stream.url"
                          :placeholder="'Enter RTMP url ' + (streamid + 1)"
                        >
                        </b-form-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12">
                        <b-form-input
                          size="sm"
                          type="text"
                          v-model="stream.key"
                          :placeholder="'Enter RTMP key ' + (streamid + 1)"
                        >
                        </b-form-input>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col class="m-0 p-0" cols="1">
                    <b-button
                      variant="borderedx"
                      v-if="externalStreams.other.length > 0"
                      size="sm"
                      @click="externalStreams.other.splice(streamid, 1)"
                    >
                      <font-awesome-icon
                        size="sm"
                        style="color: red"
                        icon="times"
                      />
                    </b-button>
                  </b-col>
                </b-row>

                <b-row class="justify-content-center mt-3 mb-3">
                  <b-col cols="auto">
                    <b-button
                      variant="msstreamblue"
                      size="sm"
                      @click="$refs['popoverOt'].$emit('close')"
                    >
                      Ok
                    </b-button>
                  </b-col>
                  <b-col cols="auto">
                    <b-button
                      variant="mswarning"
                      size="sm"
                      @click="externalStreams.other.push({ url: '', key: '' })"
                    >
                      <b-icon icon="plus-circle" />
                      Add a stream key
                    </b-button>
                  </b-col>
                </b-row>
              </b-popover>
            </b-row>
            <p style="font-size: 11px">
              *Contact QUANTEEC at: support@quanteec.com to simulcast to other
              platforms
            </p>
          </b-form-group>
          <b-row class="justify-content-around">
            <b-col cols="auto">
              <b-button type="submit" variant="msstreamblue">Submit</b-button>
            </b-col>
            <b-col cols="auto">
              <b-button
                variant="mswarning"
                @click="hideModal('modifyExternalStreams')"
                >Cancel</b-button
              >
            </b-col>
          </b-row>
        </b-form>
      </div>
    </b-modal>

    <b-modal
      ref="confirmOneRestartEncoding"
      hide-footer
      hide-header
      @hidden="resetModal"
      @cancel="resetModal"
    >
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-icon style="margin-right: 5px" :icon="['fas', 'cog']" />
          Video processing restart
        </h4>
      </div>
      <p style="line-height: normal">
        Please confirm the re-launch of the encoding process of
        <strong
          ><span style="color: #2f90b0">{{ video.title }}</span></strong
        >.
      </p>
      <b-form-checkbox
        size="sm"
        style="margin-bottom: 7px"
        v-model="restartEncodingQuality"
        switch
        >Modify encoding parameters</b-form-checkbox
      >
      <div v-if="restartEncodingQuality && video.liveType === 'camera'">
        <b-form-group style="text-align: center" label="Targeted audience:">
          <b-row class="justify-content-around">
            <b-col lg="4" md="4" sm="6" cols="10">
              <b-row
                class="justify-content-center align-items-center commonChoice3"
                @click="video.directStream = 'no'"
                v-bind:class="{
                  selectedChoice2: video.directStream === 'no',
                  unselectedChoice2: video.directStream !== 'no',
                }"
              >
                <small style="line-height: normal">
                  No-delay only (5 viewers max.)
                </small>
              </b-row>
            </b-col>
            <b-col lg="4" md="4" sm="6" cols="10">
              <b-row
                class="justify-content-center align-items-center commonChoice3"
                @click="video.directStream = 'middle'"
                v-bind:class="{
                  selectedChoice2: video.directStream === 'middle',
                  unselectedChoice2: video.directStream !== 'middle',
                }"
              >
                <small style="line-height: normal">
                  No-delay for 5 first viewers + low-delay for the others
                </small>
              </b-row>
            </b-col>
            <b-col lg="4" md="4" sm="6" cols="10">
              <b-row
                class="justify-content-center align-items-center commonChoice3"
                @click="video.directStream = 'yes'"
                v-bind:class="{
                  selectedChoice2: video.directStream === 'yes',
                  unselectedChoice2: video.directStream !== 'yes',
                }"
              >
                <small style="line-height: normal">
                  Low-delay only (large audience)
                </small>
              </b-row>
            </b-col>
          </b-row>
        </b-form-group>
      </div>
      <b-card
        v-if="restartEncodingQuality"
        border-variant="msstream"
        no-body
        style="margin-top: 0px; margin-bottom: 20px"
      >
        <b-card-header
          header-bg-variant="msstream"
          header-text-variant="white"
          class="text-center"
        >
          <h5 style="margin: 0px">Qualities encoding method</h5>
        </b-card-header>
        <div>
          <b-form-group label="" v-slot="{ ariaDescribedby }">
            <b-form-radio-group
              v-model="qualitiesSelection"
              style="padding: 20px 0px 0px 0px"
            >
              <b-row class="ml-5 align-items-center">
                <b-form-radio
                  v-model="qualitiesSelection"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="default"
                >
                  <b-img
                    fluid
                    :src="require(`@/assets/logo.svg`)"
                    style="max-height: 20px"
                  />&nbsp;
                  <strong style="color: #2a5d77">QUANTEEC</strong> algorithm
                  <small>(default/recommended)</small>
                </b-form-radio>
              </b-row>

              <b-form-checkbox
                size="sm"
                style="text-align: center"
                v-if="qualitiesSelection === 'default' && video.type === 'vod'"
                v-model="firstPass"
              >
                <span id="popover1">Passthrough-first </span>
                <b-popover
                  size="sm"
                  target="popover1"
                  triggers="hover"
                  placement="top"
                >
                  <template #title><small>Passthrough-first</small></template>
                  <small>
                    Make the video immediately available to viewers in
                    passthrough while the encoding is being performed (which
                    will last - at minimum - the duration of the video).
                    <br />Once finalised, the encoded versions will
                    automatically replace the passthrough one.
                  </small>
                </b-popover>
              </b-form-checkbox>

              <b-row class="ml-5 align-items-center mt-3">
                <b-form-radio
                  v-model="qualitiesSelection"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="qualities"
                >
                  Custom qualities
                  <small v-if="qualitiesSelection === 'qualities'"
                    >(configure below)</small
                  >
                </b-form-radio>
              </b-row>

              <b-form-checkbox
                size="sm"
                style="text-align: center"
                v-if="
                  qualitiesSelection === 'qualities' && video.type === 'vod'
                "
                v-model="firstPass"
              >
                <span id="popover2">Passthrough-first </span>
                <b-popover
                  size="sm"
                  target="popover2"
                  triggers="hover"
                  placement="top"
                >
                  <template #title><small>Passthrough-first</small></template>
                  <small>
                    Make the video immediately available to viewers in
                    passthrough while the encoding is being performed (which
                    will last - at minimum - the duration of the video).
                    <br />Once finalised, the encoded versions will
                    automatically replace the passthrough one.
                  </small>
                </b-popover>
              </b-form-checkbox>

              <b-row class="ml-5 align-items-center mt-3">
                <b-form-radio
                  v-model="qualitiesSelection"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="passthrough"
                >
                  Passthrough
                  <small>(same as original, no additional quality)</small>
                </b-form-radio>
              </b-row>
            </b-form-radio-group>
          </b-form-group>
        </div>

        <div v-if="qualitiesSelection === 'qualities'">
          <div
            style="border-top: 1px solid #2a5d77; margin: 10px 30px 20px 30px"
          ></div>
          <b-row class="justify-content-center align-items-center mb-2">
            <h6>Add a quality and adjust your parameters*</h6>
          </b-row>

          <b-table
            centered
            responsive
            striped
            bordered
            :items="qualitiesModal"
            :fields="qualitiesTable"
          >
            <template v-slot:cell(bitrate)="row">
              <b-form-input
                size="sm"
                style="max-width: 120px"
                v-model="row.item.bitrate"
              />
            </template>

            <template v-slot:cell(resolution)="row">
              <b-form-select
                size="sm"
                v-model="row.item.resolution"
                :options="resolutions"
              ></b-form-select>
            </template>

            <template v-slot:cell(actions)="row">
              <b-button
                size="sm"
                variant="quanteec"
                @click="removeQuality(row.index)"
              >
                <font-awesome-icon icon="trash" />
              </b-button>
            </template>
          </b-table>

          <b-row class="justify-content-center align-items-center mb-3">
            <b-button size="sm" variant="msstreamblue" @click="addQuality()">
              <b-icon icon="plus-circle" />
              Add a quality to encode
            </b-button>
          </b-row>
          <div style="padding: 5px">
            <small
              >*For very specific encoding parameters, please contact QUANTEEC
              at: support@quanteec.com</small
            >
          </div>
        </div>
      </b-card>

      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="msstreamblue"
          @click="
            restartEncoding();
            hideModal('confirmOneRestartEncoding');
          "
        >
          <font-awesome-icon style="margin-right: 5px" :icon="['fas', 'cog']" />
          Re-launch process
        </b-btn>
        <b-btn
          class="col-md-5 col-5"
          variant="quanteeclg"
          @click="
            resetModal();
            hideModal('confirmOneRestartEncoding');
          "
        >
          <font-awesome-icon
            style="margin-right: 5px; color: red"
            :icon="['fas', 'times']"
          />
          Cancel
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="confirmOneStopEncoding" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-icon
            style="margin-right: 5px"
            :icon="['fas', 'stop-circle']"
          />
          Encoding process stop
        </h4>
      </div>
      <p style="line-height: normal">
        Please confirm the stop of the re-encoding process of
        <strong
          ><span style="color: #2f90b0">{{ video.title }}</span></strong
        >.
      </p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="quanteec"
          @click="
            stopEncoding();
            hideModal('confirmOneStopEncoding');
          "
        >
          <font-awesome-icon
            style="margin-right: 5px"
            :icon="['fas', 'stop-circle']"
          />
          Stop process
        </b-btn>
        <b-btn
          class="col-md-5 col-5"
          variant="quanteeclg"
          @click="hideModal('confirmOneStopEncoding')"
        >
          <font-awesome-icon
            style="margin-right: 5px; color: red"
            :icon="['fas', 'times']"
          />
          Cancel
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="confirmChapterChange" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-icon
            style="margin-right: 5px"
            :icon="['fas', 'list-ol']"
          />
          Video chapters modification
        </h4>
      </div>
      <p style="line-height: normal" v-if="errorChapterDate === true">
        <span style="color: red">Error(s)</span> in chapters configuration.
        Please correct the values.
      </p>
      <p style="line-height: normal; color: #2a5d77; text-align: center" v-else>
        Chapters have been <span style="color: #14bf98"> updated</span>.
      </p>
    </b-modal>

    <b-modal ref="confirmSlowInAndOut" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-icon style="margin-right: 5px" :icon="['fas', 'cut']" />
          Creating cut-versions:
          <span style="color: #2f90b0">accurate</span> mode
        </h4>
      </div>
      <p style="line-height: normal">
        Creating cut-versions of
        <span style="color: #2f90b0">{{ video.title }}</span> in
        <span style="color: #2f90b0">accurate</span> mode will exactly respect
        the timeframe entered but will last at minimum the duration of the
        video.
      </p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="msstreamblue"
          @click="
            putInAndOut(true);
            hideModal('confirmSlowInAndOut');
          "
        >
          <font-awesome-icon
            style="margin-right: 5px"
            :icon="['fas', 'check']"
          />
          Create cut-version
        </b-btn>
        <b-btn
          class="col-md-5 col-5"
          variant="quanteeclg"
          @click="hideModal('confirmSlowInAndOut')"
        >
          <font-awesome-icon
            style="margin-right: 5px; color: red"
            :icon="['fas', 'times']"
          />
          Cancel
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="errorInAndOut" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-icon
            style="margin-right: 5px; color: red"
            :icon="['fas', 'cut']"
          />
          Creating cut-versions: <span style="color: red">error</span>
        </h4>
      </div>
      <p style="line-height: normal">
        Error during the creation of cut-version of
        <span style="color: #2f90b0">{{ video.title }}</span
        >.
      </p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="quanteeclg"
          block
          @click="hideModal('errorInAndOut')"
          >Close</b-btn
        >
      </b-row>
    </b-modal>

    <b-modal ref="errorInAndOutStream" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-icon
            style="margin-right: 5px; color: red"
            :icon="['fas', 'cut']"
          />
          Creating cut-versions: <span style="color: red">error</span>
        </h4>
      </div>
      <p>The video currently being encoded or live streamed.</p>
      <p style="line-height: normal">
        Error during the creation of cut-version of
        <span style="color: #2f90b0">{{ video.title }}</span
        >: the video is currently being encoded or live streamed. <br />Retry
        later.
      </p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="quanteeclg"
          block
          @click="hideModal('errorInAndOutStream')"
          >Close</b-btn
        >
      </b-row>
    </b-modal>

    <b-modal ref="duplicateInAndOut" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-icon style="margin-right: 5px" :icon="['fas', 'cut']" />
          Duplicated cut version
        </h4>
      </div>
      <p style="line-height: normal">
        A cut-version with these parameters already exists.
      </p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="quanteeclg"
          block
          @click="hideModal('duplicateInAndOut')"
          >Close</b-btn
        >
      </b-row>
    </b-modal>

    <b-modal ref="successInAndOut" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-icon style="margin-right: 5px" :icon="['fas', 'cut']" />
          Creating cut-versions
        </h4>
      </div>
      <p style="line-height: normal">
        The cut-version of
        <span style="color: #2f90b0">{{ video.title }}</span> is being
        processed.
      </p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="quanteeclg"
          block
          @click="hideModal('successInAndOut')"
          >Close</b-btn
        >
      </b-row>
    </b-modal>

    <b-modal ref="keepLiveDurationModal" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-icon
            style="margin-right: 5px"
            :icon="['fas', 'backward']"
          />
          Keep live duration
        </h4>
      </div>
      <p style="line-height: normal">
        The <span style="color: #2f90b0">number of seconds to save</span> has
        been changed. This parameter will be taken into account when you
        re-launch your Live.
      </p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="quanteeclg"
          block
          @click="hideModal('keepLiveDurationModal')"
          >Close</b-btn
        >
      </b-row>
    </b-modal>

    <b-modal ref="errorVod2Live" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-layers style="margin-right: 15px">
            <font-awesome-icon style="color: red" icon="share" />
            <font-awesome-icon
              style="color: red"
              icon="play"
              transform="shrink-7 right-13 up-2"
            />
          </font-awesome-layers>
          Plan delayed start: <span style="color: red">error</span>
        </h4>
      </div>
      <p style="line-height: normal">
        Error setting up a delayed start of the video.
      </p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="quanteeclg"
          block
          @click="hideModal('errorVod2Live')"
          >Close</b-btn
        >
      </b-row>
    </b-modal>

    <b-modal ref="errorDeleteVod2Live" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-layers style="margin-right: 15px">
            <font-awesome-icon style="color: red" icon="share" />
            <font-awesome-icon
              style="color: red"
              icon="play"
              transform="shrink-7 right-13 up-2"
            />
          </font-awesome-layers>
          Plan delayed start: <span style="color: red">error</span>
        </h4>
      </div>
      <p style="line-height: normal">
        Error removing the delayed start of the video.
      </p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="quanteeclg"
          block
          @click="hideModal('errorDeleteVod2Live')"
          >Close</b-btn
        >
      </b-row>
    </b-modal>

    <b-modal ref="successVod2Live" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-layers style="margin-right: 15px">
            <font-awesome-icon icon="share" />
            <font-awesome-icon icon="play" transform="shrink-7 right-13 up-2" />
          </font-awesome-layers>
          Plan delayed start
        </h4>
      </div>
      <p style="line-height: normal">
        Stream has been sucessfully scheduled to start at a delayed time.
      </p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="quanteeclg"
          block
          @click="hideModal('successVod2Live')"
          >Close</b-btn
        >
      </b-row>
    </b-modal>

    <b-modal ref="successDeleteVod2Live" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-layers style="margin-right: 15px">
            <font-awesome-icon icon="share" />
            <font-awesome-icon icon="play" transform="shrink-7 right-13 up-2" />
          </font-awesome-layers>
          Plan delayed start
        </h4>
      </div>
      <p style="line-height: normal">
        Delayed start has been successfully removed.
      </p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="quanteeclg"
          block
          @click="hideModal('successDeleteVod2Live')"
          >Close</b-btn
        >
      </b-row>
    </b-modal>

    <b-modal ref="successDeleteProgrammed" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-layers style="margin-right: 15px">
            <font-awesome-icon icon="share" />
            <font-awesome-icon icon="play" transform="shrink-7 right-13 up-2" />
          </font-awesome-layers>
          Delete
        </h4>
      </div>
      <p style="line-height: normal">
        The video will be deleted at the specified time.
      </p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="quanteeclg"
          block
          @click="hideModal('successDeleteProgrammed')"
          >Close</b-btn
        >
      </b-row>
    </b-modal>

    <b-modal ref="errorDeleteProgrammed" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-layers style="margin-right: 15px">
            <font-awesome-icon style="color: red" icon="share" />
            <font-awesome-icon
              style="color: red"
              icon="play"
              transform="shrink-7 right-13 up-2"
            />
          </font-awesome-layers>
          Delete: <span style="color: red">error</span>
        </h4>
      </div>
      <p style="line-height: normal">Error trying to plan a video deletion.</p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="quanteeclg"
          block
          @click="hideModal('errorDeleteProgrammed')"
          >Close</b-btn
        >
      </b-row>
    </b-modal>

    <b-modal ref="successDeleteDeleteProgrammed" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-layers style="margin-right: 15px">
            <font-awesome-icon icon="share" />
            <font-awesome-icon icon="play" transform="shrink-7 right-13 up-2" />
          </font-awesome-layers>
          Delete
        </h4>
      </div>
      <p style="line-height: normal">Planned delete removed.</p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="quanteeclg"
          block
          @click="hideModal('successDeleteDeleteProgrammed')"
          >Close</b-btn
        >
      </b-row>
    </b-modal>

    <b-modal ref="errorDeleteDeleteProgrammed" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-layers style="margin-right: 15px">
            <font-awesome-icon style="color: red" icon="share" />
            <font-awesome-icon
              style="color: red"
              icon="play"
              transform="shrink-7 right-13 up-2"
            />
          </font-awesome-layers>
          Delete: <span style="color: red">error</span>
        </h4>
      </div>
      <p style="line-height: normal">
        Error trying to remove a planned deletion.
      </p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="quanteeclg"
          block
          @click="hideModal('errorDeleteDeleteProgrammed')"
          >Close</b-btn
        >
      </b-row>
    </b-modal>

    <b-modal ref="successDeleteOtherInOut" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-icon style="color: red" icon="trash" />&nbsp;
          <span v-if="video.type === 'live'">Delete VOD archive file</span>
          <span v-else>Delete Cut-version file</span>
        </h4>
      </div>
      <p style="line-height: normal">
        <span v-if="video.type === 'live'"
          >The selected VOD archive file has been deleted.</span
        >
        <span v-else>The selected Cut-version file has been deleted.</span>
      </p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="quanteeclg"
          block
          @click="hideModal('successDeleteOtherInOut')"
          >Close</b-btn
        >
      </b-row>
    </b-modal>

    <b-modal ref="errorDeleteOtherInOut" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-layers style="margin-right: 15px">
            <font-awesome-icon style="color: red" icon="share" />
            <font-awesome-icon
              style="color: red"
              icon="play"
              transform="shrink-7 right-13 up-2"
            />
          </font-awesome-layers>
          Delete video cut: <span style="color: red">error</span>
        </h4>
      </div>
      <p style="line-height: normal">
        Error trying to remove the other video. Please retry later.
      </p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="quanteeclg"
          block
          @click="hideModal('errorDeleteOtherInOut')"
          >Close</b-btn
        >
      </b-row>
    </b-modal>

    <b-modal ref="errorLoadVideo" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-icon
            style="margin-right: 5px; color: red"
            :icon="['fas', 'cut']"
          />
          <span style="color: red">Error</span>
        </h4>
      </div>
      <p style="line-height: normal">Video not found.</p>
      <p style="line-height: normal">
        The video does not exist or may have been deleted.
      </p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="msstreamblue"
          block
          @click="
            $router.push('/videos');
            hideModal('errorLoadVideo');
          "
        >
          <font-awesome-icon :icon="['fas', 'caret-left']"></font-awesome-icon>
          Close</b-btn
        >
      </b-row>
    </b-modal>

    <b-modal ref="updateOutro" hide-footer hide-header @show="typeOfOutro = 0;currentOutro = null;getOutros();getPictures();">
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-icon
            style="margin-right: 5px;"
            :icon="['fas', 'link']"
          />
          <span>{{$ml.get('outro')}}</span>
        </h4>
      </div>
      <div v-if="typeOfOutro === 0">
        <b-row class="justify-content-around align-items-center">
          <b-col cols="auto" class="marginaltopsm">
            <b-button variant="msstreamblue" @click="typeOfOutro = 1">
              {{$ml.get('adddefaultoutro')}}
            </b-button>
          </b-col>

          <b-col cols="auto" class="marginaltopsm">
            <b-button variant="green" @click="typeOfOutro = 2">
              {{$ml.get('addnewoutro')}}
            </b-button>
          </b-col>

        </b-row>
      </div>

      <div v-if="typeOfOutro === 1">
        <b-form-select v-model="currentOutro" :options="outroOptions"></b-form-select>
        <div v-if="currentOutro" class="marginaltopsm">
          <p><strong>{{$ml.get('outrotitle')}}:</strong> {{currentOutro.title}}</p>
          <p><strong>{{$ml.get('outrodescription')}}:</strong> {{currentOutro.description}}</p>
          <p><strong>{{$ml.get('outrourl')}}:</strong> {{currentOutro.url}}</p>
          <p><strong>{{$ml.get('outrotext')}}:</strong> {{currentOutro.text}}</p>
          <p><strong>{{$ml.get('outrourl2')}}:</strong> {{currentOutro.url2}}</p>
          <p><strong>{{$ml.get('outrotext2')}}:</strong> {{currentOutro.text2}}</p>
          <div class="picture-item">
            <b-img :src="currentOutro.img_base" fluid class="picture-item-img"></b-img>
          </div>
        </div>
        <b-row class="justify-content-around marginaltopsm">
            <b-btn
              class="col-md-5 col-5"
              variant="msstreamblue"
              type="submit"
              @click="updateDefaultOutroVideo"
            >
              {{$ml.get('Submit')}}</b-btn
            >
            <b-btn
              class="col-md-5 col-5"
              variant="quanteeclg"
              @click="
                hideModal('updateOutro');
              "
            >
              {{$ml.get('cancel')}}</b-btn
            >
        </b-row>
      </div>

      <b-form v-if="outro && typeOfOutro === 2" @submit.prevent="updateOutroVideo">
          <b-form-group
            :label="$ml.get('outrotitle') + ':'"
            label-for="outroTitle"
          >
            <b-form-input
              id="outroTitle"
              type="text"
              v-model="outro.title"
              required
              :placeholder="$ml.get('outrotitle')"
            >
            </b-form-input>
          </b-form-group>
          <b-form-group
            :label="$ml.get('outrodescription') + ':'"
            label-for="outroDescription"
          >
            <b-form-input
              id="outroDescription"
              type="text"
              v-model="outro.description"
              required
              :placeholder="$ml.get('outrodescription')"
            >
            </b-form-input>
          </b-form-group>
          <b-form-group
            :label="$ml.get('outrourl') + ':'"
            label-for="outroLinkButton"
          >
            <b-form-input
              id="outroLinkButton"
              type="text"
              v-model="outro.url"
              required
              :placeholder="$ml.get('outrourl')"
            >
            </b-form-input>
          </b-form-group>
          <b-form-group
            :label="$ml.get('outrotext') + ':'"
            label-for="outroLinkText"
          >
            <b-form-input
              id="outroLinkText"
              type="text"
              v-model="outro.text"
              required
              :placeholder="$ml.get('outrotext')"
            >
            </b-form-input>
          </b-form-group>
          <b-form-group
            :label="$ml.get('outrourl2') + ':'"
            label-for="outroUrl2"
          >
            <b-form-input
              id="outroUrl2"
              type="text"
              v-model="outro.url2"
              
              :placeholder="$ml.get('outrourl2')"
            >
            </b-form-input>
          </b-form-group>
          <b-form-group
            :label="$ml.get('outrotext2') + ':'"
            label-for="outroLinkText2"
          >
            <b-form-input
              id="outroLinkText2"
              type="text"
              v-model="outro.text2"
              
              :placeholder="$ml.get('outrotext2')"
            >
            </b-form-input>
          </b-form-group>

          <!-- New Immage -->
          <b-row class="justify-content-center">
            <input
              type="file"
              accept="image/*"
              @change="outro.img_base = '';selectPicture($event)"
              id="file-input5"
              class="inputfile"
              size="sm"
              
            />
            <label
              class="pointerOrange"
              style="text-align: center; line-height: normal"
              for="file-input5"
            >
              <font-awesome-icon icon="image" />&nbsp;
              <small>
                <span>{{$ml.get('backgroundoutro')}}</span>
                <span v-if="customPicture !== null"> - {{customPicture.name}}</span>
              </small>
            </label>
          </b-row>

          <!-- Image selection -->
          <div class="picture-grid picture-grid-size marginaltop">
            <div
              class="picture-item bg-msstream"
              v-for="picture in pictures"
              v-bind:key="picture.uuid"
            >
              <b-img
                :src="picture.url"
                fluid
                :title="picture.name"
                class="picture-item-img"
                :class="{ 'picture-selected': (picture.url === outro.img_base) }"
                @click="customPicture = null; outro.img_base = picture.url"
              ></b-img>
            </div>
          </div>

          <b-row class="justify-content-around marginaltopsm">
            <b-btn
              class="col-md-5 col-5"
              variant="msstreamblue"
              type="submit"
            >
              {{$ml.get('Submit')}}</b-btn
            >
            <b-btn
              class="col-md-5 col-5"
              variant="quanteeclg"
              @click="
                hideModal('updateOutro');
              "
            >
              {{$ml.get('cancel')}}</b-btn
            >
        </b-row>
      </b-form>
    </b-modal>


    <b-modal ref="errorOutro" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-icon
            style="margin-right: 5px; color: red"
            :icon="['fas', 'link']"
          />
          <span style="color: red">Error</span>
        </h4>
      </div>
      <p style="line-height: normal">Can not change outro</p>
      
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="msstreamblue"
          block
          @click="
            hideModal('errorOutro');
          "
        >
          <font-awesome-icon :icon="['fas', 'caret-left']"></font-awesome-icon>
          Close</b-btn
        >
      </b-row>
    </b-modal>

    <!-- Thumbnail generated -->
     <b-modal ref="successGenerateThumbnail" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <b-icon icon="card-img"/>
          <span>{{$ml.get('Success')}}</span>
        </h4>
      </div>
      <p style="line-height: normal">{{$ml.get('successcreatethumbnail')}}</p>
      <b-img :src="thumbnailURL" fluid class="marginalbot"></b-img>
      
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="msstreamblue"
          block
          @click="
            hideModal('successGenerateThumbnail');
          "
        >
          <font-awesome-icon :icon="['fas', 'caret-left']"></font-awesome-icon>
          {{$ml.get('close')}}</b-btn
        >
      </b-row>
    </b-modal>
    <b-modal ref="errorGenerateThumbnail" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <b-icon icon="card-img"/>
          <span style="color: red">{{$ml.get('Error')}}</span>
        </h4>
      </div>
      <p style="line-height: normal">{{$ml.get('errorcreatethumbnail')}}</p>
      
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="msstreamblue"
          block
          @click="
            hideModal('errorGenerateThumbnail');
          "
        >
          <font-awesome-icon :icon="['fas', 'caret-left']"></font-awesome-icon>
          {{$ml.get('close')}}</b-btn
        >
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { EventBus } from "@/event-bus.js";

// TODO: Quand on clic sur un paramètre (type,uuid,....) retourner a la page d'accueil avec la recherche de ce paramètre
// TODO: Key Type
// TODO : Duration
// TODO : Problème Status
// @ is an alias to /src
function isInViewport(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

let moment = require("moment");
import FadeLoader from "vue-spinner/src/FadeLoader.vue";
import CompleteAnalytics from "@/components/analytics/CompleteAnalytics";
import { EMBED_URL } from "@/services/base-url";
import { ANALYTICS_URL } from "@/services/base-url";
import VideoService from "@/services/video.service";
import AnalyticsService from "@/services/analytics.service";
import IframeService from "@/services/iframe.service";
import ProjectService from "@/services/project.service";
import OutroService from '@/services/outro.service';
import PictureService from '@/services/picture.service.js';
var outroService = new OutroService();
var pictureService = new PictureService();
var videoService = new VideoService();
var embed_url = EMBED_URL;
var analyticsService = new AnalyticsService();
var iframeService = new IframeService();
var projectService = new ProjectService();
import { v4 as uuidv4 } from "uuid";
import TwitterButton from "vue-share-buttons/src/components/TwitterButton";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import VideoChat from "@/components/VideoChat";
import ReplaceComponent from "@/components/ReplaceComponent";
export default {
  name: "PlayerPage",
  data: function () {
    return {
      pictures: [],
      outro: [],
      outroOptions: [],
      currentOutro: null,
      typeOfOutro: 0,
      autoStartExternal: false,
      attributes: [
        {
          key: "today",
          dot: "teal",
          dates: new Date(),
        },
      ],
      //Loading
      isLoadingStartExternalStreams: false,
      isLoadingStopExternalStreams: false,
      isLoadingModifyExternalStreams: false,
      isLoadingGenerateThumbnail: false,
      sourcePathHasBeenModified: false,

      // Information
      userView:
        this.$auth.getMyUser().roles.indexOf("admin") > -1
          ? this.$auth.getMyView() || this.$auth.getMyUser().username
          : this.$auth.getMyUser().username,
      clientView:
        this.$auth.getMyUser().roles.indexOf("admin") > -1
          ? this.$auth.getMyClientView() || this.$auth.getMyUser().client
          : this.$auth.getMyUser().client,
      isUpdateSource: false,
      isUpdateLiveToKeep: false,
      showArchives: false,
      showCut: false,
      uuid: "",
      id: "",
      embeded: "",
      directLink: "",
      createdAt: "",
      authorizationkeyLowerCase: "",
      tags: [],
      description: "",
      modifyTags: false,
      modifyTitle: false,
      modifyDescription: false,
      modifyChapters: "",
      modifySourcePath: false,
      modifiedSourcePath: "",
      title: "",
      chapters: [],
      extension: "",
      isDownload: false,
      isIntroModal: false,
      isAutoplay: false,
      isPassword: false,
      isChatLive: false,
      password: "",
      passField: false,
      fileChapters: null,
      createdDate: "",
      lastModifyAt: "",
      errorChapterDate: false,
      thumbnailURL: "",
      customThumbnail: null,
      customPicture: null,
      thumbnailMode: "automatic",
      isSeekLive: false,
      isKeepLive: false,
      facebookKey: "",
      listInAndOut: [],
      modifyAcceleration: false,
      modifyBunnyCDN: false,
      acceleratedVoD: [],
      isFastIO: true,
      forceCheckEncoding: true,
      restartEncodingQuality: false,
      qualitiesSelection: "default",
      firstPass: false,
      externalStreams: { youtube: [], facebook: [], twitch: [], other: [] },
      defaultExternalStreams: {
        youtube: [],
        facebook: [],
        twitch: [],
        other: [],
      },
      qualitiesModal: [],
      qualitiesTable: [
        {
          key: "bitrate",
          label: "Bitrate (kbps)",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "resolution",
          label: "Resolution",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "actions",
          label: "Action(s)",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
      resolutions: [
        {
          value: {
            width: 256,
            height: 144,
          },
          text: "YouTube 144p: 256x144",
        },
        {
          value: {
            width: 384,
            height: 576,
          },
          text: "SECAM: 384x576",
        },
        {
          value: {
            width: 450,
            height: 576,
          },
          text: "PAL: 450x576",
        },
        {
          value: {
            width: 323,
            height: 486,
          },
          text: "NTSC: 323x486",
        },
        {
          value: {
            width: 352,
            height: 288,
          },
          text: "MPEG-1 PAL: 352x288",
        },
        {
          value: {
            width: 352,
            height: 243,
          },
          text: "MPEG-1 NTSC: 352x243",
        },
        {
          value: {
            width: 720,
            height: 576,
          },
          text: "MPEG-2 PAL: 720x576",
        },
        {
          value: {
            width: 480,
            height: 576,
          },
          text: "MPEG-2 PAL: 720x480",
        },
        {
          value: {
            width: 1280,
            height: 720,
          },
          text: "HD: 1280x720",
        },
        {
          value: {
            width: 1920,
            height: 1080,
          },
          text: "Full HD: 1920x1080",
        },
        {
          value: {
            width: 3840,
            height: 2160,
          },
          text: "UHD (4K): 3840x2160",
        },
        {
          value: {
            width: 7680,
            height: 4320,
          },
          text: "UHD (8K): 7680x4320",
        },
      ],

      //Analytics
      percent_rebuf: 0, //percentage
      percent_offload: 0, //percentage
      nbViews: 0, //unit
      TotalDelivered: 0, //MB
      bitrate: 0, //MB/s
      hoursView: 0, //Hours
      minutesView: 0, //Minutes
      averageTime: 0, //Minutes

      //Video
      video: {},
      videoLoaded: false,
      iframeinit: false,
      iframesrc: "",
      iframeAnalytics: "",
      isVideoLoaded: false,
      exportLinks: [],
      liveDate: "",
      startDateShow: "",
      vstartDateShow: "",
      showSourcePath: false,
      //liveHour: "",
      currentDate: new Date(),
      cd2: "",
      deleteDate: "",
      deleteDateShow: "",
      vdeleteDateShow: "",
      //deleteHour: "",
      liveToKeepDuration: 30,

      //Outro
      outro:null,

      //Manage time selection analytics
      error: false,
      dateFrom: null,
      dateTo: null,
      timeFrom: null,
      timeTo: null,

      chapters_show: [],
      intervalRefresh: null,
      lastVideoVisible: true,
      inAndOut: {
        start: "00:00:00",
        end: "00:00:00",
      },
      watermarkText: "Watched by",
      modifyWatermark: false,

      projects: [],
      tableProjects: [
        {
          key: "name",
          label: "Project Name",
          sortable: true,
          tdClass: "rowPointer",
        },
      ],
      liveStats: {
        connected: false,
        bw_audio: 0,
        bw_video: 0,
        _time: "0s",
        time: 0,
        meta: [],
      },
    };
  },
  components: {
    CompleteAnalytics,
    TwitterButton,
    FadeLoader,
    DatePicker,
    VideoChat,
    ReplaceComponent
  },
  mounted() {
    let self = this;
    this.uuid = this.$route.params["uuid"];
    //this.id = this.$route.params["id"];
    this.embeded = "";
    this.iframesrc = embed_url + "/embeded.html?uuid=" + this.uuid;
    this.iframeinit = false;

    this.getVideoFromUuid();
    this.getProjectFromVideo();
    this.cd2 = new Date(this.currentDate.getTime() + 1 * 60 * 1000);

    this.intervalRefresh = setTimeout(this.checkEncoding, 10000);

    function dataURItoBlob(dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString;
      if (dataURI.split(',')[0].indexOf('base64') >= 0)
          byteString = atob(dataURI.split(',')[1]);
      else
          byteString = unescape(dataURI.split(',')[1]);

      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ia], {type:mimeString});
  }

  this.iframeCallbackFunction = function(event) {
                 /* Etape 6 : Par sécurité, vérifier que le message provient bien de l'iframe avec pour origin */
                /*if (window.location.href.indexOf(event.origin) === -1) {
                    return;
                }*/
                /* Etape 7 : Récupérer le timestamp de la vidéo dans event.data. Si la vidéo n'est pas démarrée, le timestamp reçu sera à 0. */
              

                /* Etape 8 : Manipulez le timestamp reçu à votre convenance. Dans cet exemple, on envoi une requête pour créer une thumbnail */
                if (event.data !== undefined && typeof event.data === "number") {
                  self.generateThumbnailByTime(event.data);
                }
                if (event.data && event.data.type === "getCurrentTime") {
                  self.generateThumbnailByTime(event.data.data);
                }
                if (event.data && event.data.type === "getCurrentImage") {
                  let image = event.data.data;
                  self.customThumbnail = dataURItoBlob(image);
                  self.uploadThumbnail();
                }
            }

    window.addEventListener('message', this.iframeCallbackFunction, false);

    /*document.addEventListener('scroll', function () {
      let myPlayer = document.getElementById('video-player');
      let myPlayerContainer = document.getElementById('video-player-container');
      let isVideoVisible = isInViewport(myPlayerContainer);
      if (isVideoVisible !== this.lastVideoVisible) {
        this.lastVideoVisible = isVideoVisible;
        if (isVideoVisible) {
          try {
            myPlayer.classList.remove('resp-iframe-unfocused') ;
          } catch(err) {}
          try {
            myPlayer.classList.add('resp-iframe') ;
          } catch(err) {}
          
        } else {
          try {
            myPlayer.classList.remove('resp-iframe') ;
          } catch(err) {}
          try {
            myPlayer.classList.add('resp-iframe-unfocused') ;
          } catch(err) {}
        }
      }

    }, {
        passive: true
    });*/
  },
  beforeDestroy() {
    try {
      clearTimeout(this.intervalRefresh);
    } catch (e) {}
    window.removeEventListener('message', this.iframeCallbackFunction, false);
  },
  computed: {
    archivesFromLiveLength() {
      return this.video.archivesFromLive
        ? Object.keys(this.video.archivesFromLive).length
        : 0;
    },
    focus() {
      return this.$store.state.focus;
    },
    totalErrors() {
      let total = 0;

      total +=
        this.video && this.video.otherError !== undefined
          ? this.video.otherError
          : 0;
      total +=
        this.video && this.video.ffmpegError !== undefined
          ? this.video.ffmpegError
          : 0;
      total +=
        this.video && this.video.timeoutError !== undefined
          ? this.video.timeoutError
          : 0;
      total +=
        this.video && this.video.audioError !== undefined
          ? this.video.audioError
          : 0;
      return total;
    },
    fancyDurationFormatChap(number) {
      // Hours, minutes and seconds
      var hrs = ~~(number / 3600);
      var mins = ~~((number % 3600) / 60);
      var secs = ~~number % 60;

      // Output like "1:01" or "4:03:59" or "123:03:59"
      var ret = "";

      if (hrs > 0) {
        ret += "" + hrs + "h " + (mins < 10 ? "0" : "");
      }

      ret += "" + mins + "min " + (secs < 10 ? "0" : "");
      ret += "" + secs + "s";
      return ret;
    },
    fancyDurationFormat() {
      if (this.video && this.video.duration) {
        let time = this.video.duration;
        // Hours, minutes and seconds
        var hrs = ~~(time / 3600);
        var mins = ~~((time % 3600) / 60);
        var secs = ~~time % 60;

        // Output like "1:01" or "4:03:59" or "123:03:59"
        var ret = "";

        if (hrs > 0) {
          ret += "" + hrs + "h " + (mins < 10 ? "0" : "");
        }

        ret += "" + mins + "min " + (secs < 10 ? "0" : "");
        ret += "" + secs + "s";
        return ret;
      } else {
        return "0 min";
      }
    },
  },
  methods: {
    getPictures() {
      pictureService
        .getPictures(
          {
            client: this.clientView,
            pagesize: 1000,
            sort: JSON.stringify({ createdAt: -1 }),
          },
          this.$auth.token()
        )
        .then((response) => {
          this.pictures = response._embedded;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getOutros() {
      outroService
        .getOutros(
          {
            client: this.clientView,
            pagesize: 1000,
            sort: JSON.stringify({ title: 1 }),
          },
          this.$auth.token()
        )
        .then((response) => {
          this.outros = response._embedded;
          this.outroOptions = this.outros.map(x => {
            return {
              text: x.title,
              value: x
            }
          })
        })
        .catch((err) => {
          console.log(err);
        });
    },
    generateThumbnailByTime(time) {
      this.isLoadingGenerateThumbnail = true;
      videoService.generateThumbnailByTime(this.$auth.token(), this.video.uuid, time)
      .then((video) => {
        this.isLoadingGenerateThumbnail = false;
        this.video.customThumbnailPath = video.customThumbnailPath;
        this.video.manifest = video.manifest; 
        this.thumbnailURL = video.manifest.thumbnail + "?key=" + new Date().getTime();
        this.showModal('successGenerateThumbnail')
      }).catch(err => {
        this.isLoadingGenerateThumbnail = false;
        this.showModal('errorGenerateThumbnail')
        console.log(err);
      })
    },
    getCurrentTime() {
      this.$refs["mainIframe"].contentWindow.postMessage("getCurrentImage", "*");
    },
    removeOther(uuid) {
      videoService
        .deleteVideoById(uuid, this.$auth.token())
        .then(() => {
          this.getVideoFromUuid();
          this.showModal("successDeleteOtherInOut");
        })
        .catch((err) => {
          this.showModal("errorDeleteOtherInOut");
        });
    },
    adjustDD(date) {
      return moment(date).format("DD/MM/YY @HH:mm");
    },
    adjustDateS() {
      this.startDateShow = moment(this.liveDate).format("DD/MM/YY @HH:mm");
      this.vstartDateShow = this.video.startDate
        ? moment(this.video.startDate).format("DD/MM/YY @HH:mm")
        : "";
    },
    adjustDate() {
      this.deleteDateShow = moment(this.deleteDate).format("DD/MM/YY @HH:mm");
      this.vdeleteDateShow = this.video.deleteDate
        ? moment(this.video.deleteDate).format("DD/MM/YY @HH:mm")
        : "";
    },
    deleteProgrammed() {
      /*
      var stringDate = this.deleteDate + " " + this.deleteHour;
      var deleteDate = new Date(stringDate);
    */

      videoService
        .deleteProgrammed(this.deleteDate, this.video.uuid, this.$auth.token())
        .then((task) => {
          this.getVideoFromUuid();
          this.showModal("successDeleteProgrammed");
        })
        .catch((err) => {
          this.showModal("errorDeleteProgrammed");
        });
    },
    deleteDeleteProgrammed() {
      videoService
        .deleteProgrammed("", this.video.uuid, this.$auth.token())
        .then((task) => {
          this.getVideoFromUuid();
          this.deleteDate = "";
          this.showModal("successDeleteDeleteProgrammed");
        })
        .catch((err) => {
          this.showModal("errorDeleteDeleteProgrammed");
        });
    },
    setupVODAsLive() {
      var stringDate = this.liveDate;
      var startDate = new Date(stringDate);
      var dataToSend = { startDate: startDate };

      videoService
        .putVodToLive(dataToSend, this.video.uuid, this.$auth.token())
        .then((task) => {
          if (task.error && task.over) {
            this.showModal("errorVod2Live");
          } else {
            this.getVideoFromUuid();
            //this.showModal('successVod2Live');
          }
        })
        .catch((err) => {
          this.showModal("errorVod2Live");
        });
    },
    deleteVODAsLive() {
      videoService
        .deleteVodToLive(this.video.uuid, this.$auth.token())
        .then((task) => {
          this.liveDate = "";
          //          this.liveHour = "";
          this.getVideoFromUuid();
          this.showModal("successDeleteVod2Live");
        })
        .catch((err) => {
          this.showModal("errorDeleteVod2Live");
        });
    },
    putInAndOut(transcode) {
      var newInAndOut = {};
      var start = this.inAndOut.start.split(":");
      newInAndOut.start = +start[0] * 60 * 60 + +start[1] * 60 + +start[2];

      var end = this.inAndOut.end.split(":");
      newInAndOut.end = +end[0] * 60 * 60 + +end[1] * 60 + +end[2];

      newInAndOut.transcode = transcode === true;

      // Verifications

      let isDuplicate = this.listInAndOut.findIndex((x) => {
        return (
          x.start === newInAndOut.start &&
          x.end === newInAndOut.end &&
          ((newInAndOut.transcode && x.type === "precise") ||
            (!newInAndOut.transcode && x.type === "fast"))
        );
      });
      console.log("before test", this.listInAndOut, newInAndOut, transcode);
      console.log("Duplicate:", this.listInAndOut[isDuplicate]);
      if (isDuplicate !== -1) {
        this.showModal("duplicateInAndOut");
        return;
      }

      videoService
        .putInAndOut(
          { inAndOut: newInAndOut },
          this.video.uuid,
          this.$auth.token()
        )
        .then(() => {
          videoService
            .postInAndOutTask(newInAndOut, this.video.uuid, this.$auth.token())
            .then((task) => {
              if (task.error && task.over) {
                if (
                  task.error.indexOf(
                    "At least one manifest of the video is not a VoD"
                  ) > -1
                ) {
                  this.showModal("errorInAndOutStream");
                } else {
                  this.showModal("errorInAndOut");
                }
              } else {
                this.getVideoFromUuid();
                this.showModal("successInAndOut");
              }
            })
            .catch((err) => {
              console.log("Erreur dans la création de la tâche", err);
              this.showModal("errorInAndOut");
            });
        })
        .catch((err) => {
          this.showModal("errorInAndOut");
          console.log("Erreur enregistrement in_out bdd", err);
        });
    },

    setupSecondsToKeep() {
      if (this.liveToKeepDuration < 30) this.liveToKeepDuration = 30;
      else if (this.liveToKeepDuration > 600) this.liveToKeepDuration = 600;

      videoService
        .putVideoById(
          { liveToKeepDuration: this.liveToKeepDuration },
          this.video.uuid,
          this.$auth.token()
        )
        .then(() => {
          this.showModal("keepLiveDurationModal");
        })
        .catch((err) => {});
    },

    verifyEndInAndOut(event, startOrEnd) {
      event = this.inAndOut[startOrEnd];
      console.log(event);
      if (
        event.indexOf("HH") === -1 &&
        event.indexOf("mm") === -1 &&
        event.indexOf("ss") === -1
      ) {
        let table = event.split(":");
        let inAndOutDuration = +table[0] * 60 * 60 + +table[1] * 60 + +table[2];
        let duration = this.video.duration;
        if (duration && duration > 0 && inAndOutDuration > duration) {
          let dateEnd = new Date(null);
          dateEnd.setSeconds(duration);
          let newInputValue = dateEnd.toISOString().substr(11, 8);
          this.inAndOut[startOrEnd] = newInputValue;
        }
      }
    },
    selectImage(event) {
      this.customThumbnail = event.target.files[0];
    },
    selectPicture(event) {
      console.log(event.target.files[0])
      this.customPicture = event.target.files[0];
    },
    createProject() {
      let body = {
        name: this.title + "_" + uuidv4(),
        description: "",
        collabs: [],
        teams: [],
      };

      projectService
        .createProjectSelect(this.$auth.token(), body, this.uuid)
        .then((project) => {
          this.$router.push(`/vireed/${project.uuid}/1`);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    uploadThumbnail() {
      if (this.customThumbnail)
      this.isLoadingGenerateThumbnail = true;
        videoService
          .uploadThumbnail(this.$auth.token(), this.uuid, this.customThumbnail)
          .then(() => {
            this.isLoadingGenerateThumbnail = false;
            this.thumbnailURL = URL.createObjectURL(this.customThumbnail);
            this.video.customThumbnailPath = this.thumbnailURL;
            this.showModal('successGenerateThumbnail')
          }).catch(err => {
            this.isLoadingGenerateThumbnail = false;
            this.showModal('errorGenerateThumbnail')
          })
    },
    selectandUploadThumbnail(event) {
      this.selectImage(event);
      this.uploadThumbnail();
    },
    removeThumbnail() {
      videoService
        .removeThumbnail(this.$auth.token(), this.uuid)
        .then(() => {
          videoService
            .getVideoById(this.uuid, this.$auth.token())
            .then((video) => {
              this.thumbnailURL = video.manifest.thumbnail;
              this.video.customThumbnailPath = "";
            })
            .catch(() => {
              console.log(error);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getProjectFromVideo() {
      projectService
        .getVersionFromVideo(this.$auth.token(), this.uuid)
        .then((projects) => {
          this.projects = projects;
        });
    },
    openLink(video) {
      window.open(video.editor, "_blank");
    },
    computeExtension(title) {
      try {
        var tableTitle = title.split(".");
        var ext = tableTitle.pop();
        if (
          ["mp4", "mov", "webm", "ogg", "avi", "flv", "mkv", "mpg"].indexOf(
            ext
          ) > -1
        ) {
          this.extension = ext;
        } else {
          this.extension = undefined;
        }
      } catch (e) {
        this.extension = undefined;
      }
    },
    showModal(ref) {
      this.$refs[ref].show();
    },
    hideModal(ref) {
      this.$refs[ref].hide();
    },
    restartEncoding() {
      let myEncoding =
        this.qualitiesSelection === "default" ||
        this.qualitiesSelection === "qualities"
          ? "encoding"
          : "passthrough";
      let myInputQualities = "QuanteecOptimization";
      if (
        this.qualitiesSelection === "default" ||
        this.qualitiesSelection === "passthrough"
      ) {
        myInputQualities = "QuanteecOptimization";
      } else if (this.qualitiesSelection === "qualities") {
        myInputQualities = this.qualitiesModal;
      }
      let myFirstPass = false;
      if (this.video.type === "vod" && this.firstPass) {
        myFirstPass = this.firstPass;
      }

      videoService
        .putVideoById(
          {
            firstPass: myFirstPass,
            encoding: myEncoding,
            inputQualities: myInputQualities,
            directStream: this.video.directStream,
          },
          this.uuid,
          this.$auth.token()
        )
        .then(() => {
          if (this.video.type === "live" && this.video.liveCamera === true) {
            this.openLiveWebcam();
          } else {
            videoService
              .putEncodingToVideoById(this.uuid, this.$auth.token())
              .then(() => {
                this.getVideoFromUuid();
              })
              .catch((err) => {
                console.log(err);
              });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    stopEncoding() {
      videoService
        .deleteEncodingToVideoById(this.uuid, this.$auth.token())
        .then(() => {
          this.getVideoFromUuid();
        })
        .catch((err) => {});
    },
    refreshVideo(callback) {
      videoService
        .getVideoById(this.uuid, this.$auth.token())
        .then((video) => {
          this.video = video;
          if (
            this.video.type === "live" &&
            this.video.liveType === "quanteecRTMP"
          ) {
            this.getLiveStats();
          }
          if (this.video.type === "live") {
            this.getExternalStats();
          }
          if (callback) {
            callback();
          }
        })
        .catch((err) => {
          if (callback) {
            callback();
          }
        });
    },
    refreshDuration() {
      let self = this;
      videoService
        .getVideoDuration(this.uuid, this.$auth.token())
        .then(() => {
          self.getVideoFromUuid();
        })
        .catch((err) => {});
    },
    checkEncoding() {
      try {
        clearTimeout(this.intervalRefresh);
      } catch (err) {}
      if (
        [
          "to_encode",
          "to_stop",
          "waiting_for_encoding",
          "encoding",
          "segmented",
          "restart",
        ].indexOf(this.video.encodingStatus) > -1 ||
        this.forceCheckEncoding
      ) {
        let callback = () => {
          this.intervalRefresh = setTimeout(this.checkEncoding, 10000);
        };
        this.refreshVideo(callback);
      } else {
        this.intervalRefresh = setTimeout(this.checkEncoding, 10000);
      }
      try {
        if (
          this.video.deleteDate &&
          new Date(this.video.deleteDate).getTime() - new Date().getTime() < 0
        ) {
          this.showModal("errorLoadVideo");
        }
      } catch (err) {}
    },
    goToAlert: function () {
      this.$router.push("/alert/" + this.uuid);
    },
    initChapter() {
      var newChapter = {
        text: "Chapter " + (this.chapters.length + 1),
        start:
          this.chapters.length > 0 &&
          this.chapters[this.chapters.length - 1].end
            ? this.chapters[this.chapters.length - 1].end
            : "00:00:00",
        end: "00:00:00",
      };

      var duration = this.video.duration || 0;
      var dateEnd = new Date(null);
      dateEnd.setSeconds(duration);
      newChapter.end = dateEnd.toISOString().substr(11, 8);

      this.chapters.push(newChapter);
    },

    getLiveStats() {
      videoService
        .getLiveStats(this.video.uuid, this.$auth.token())
        .then((stats) => {
          this.liveStats = stats;
        })
        .catch((err) => {});
    },

    getExternalStats() {
      videoService
        .getExternalStreamsStats(this.video.uuid, this.$auth.token())
        .then((stats) => {
          if (
            this.externalStreams &&
            this.externalStreams.youtube &&
            this.externalStreams.youtube.length > 0
          ) {
            this.externalStreams.youtube.forEach((elem) => {
              if (stats.youtube) {
                let myStats = stats.youtube.find((x) => x.key === elem.key);
                if (myStats && myStats.status && myStats.status.current) {
                  elem.status = myStats.status.current.state;
                }
              }
            });
            this.externalStreams.youtube =
              this.externalStreams.youtube.splice(0);
          }
          if (
            this.externalStreams &&
            this.externalStreams.facebook &&
            this.externalStreams.facebook.length > 0
          ) {
            this.externalStreams.facebook.forEach((elem) => {
              if (stats.facebook) {
                let myStats = stats.facebook.find((x) => x.key === elem.key);
                if (myStats && myStats.status && myStats.status.current) {
                  elem.status = myStats.status.current.state;
                }
              }
            });
            this.externalStreams.facebook =
              this.externalStreams.facebook.splice(0);
          }
          if (
            this.externalStreams &&
            this.externalStreams.twitch &&
            this.externalStreams.twitch.length > 0
          ) {
            this.externalStreams.twitch.forEach((elem) => {
              if (stats.twitch) {
                let myStats = stats.twitch.find((x) => x.key === elem.key);
                if (myStats && myStats.status && myStats.status.current) {
                  elem.status = myStats.status.current.state;
                }
              }
            });
            this.externalStreams.twitch = this.externalStreams.twitch.splice(0);
          }
          if (
            this.externalStreams &&
            this.externalStreams.other &&
            this.externalStreams.other.length > 0
          ) {
            this.externalStreams.other.forEach((elem) => {
              if (stats.other) {
                let myStats = stats.other.find((x) => x.key === elem.key);
                if (myStats && myStats.status && myStats.status.current) {
                  elem.status = myStats.status.current.state;
                }
              }
            });

            this.externalStreams.other = this.externalStreams.other.splice(0);
          }
        })
        .catch((err) => {
          //console.log(err);
        });
    },

    //Start the video and init the page
    getVideoFromUuid: function () {
      videoService
        .getVideoById(this.uuid, this.$auth.token())
        .then((video) => {
          console.log(video);

          if (
            video &&
            video.externalStreams &&
            !video.externalStreams.youtube
          ) {
            video.externalStreams.youtube = [];
          }
          if (
            video &&
            video.externalStreams &&
            !video.externalStreams.facebook
          ) {
            video.externalStreams.facebook = [];
          }
          if (video && video.externalStreams && !video.externalStreams.twitch) {
            video.externalStreams.twitch = [];
          }
          if (video && video.externalStreams && !video.externalStreams.other) {
            video.externalStreams.other = [];
          }
          this.video = video;
          this.externalStreams = this.video.externalStreams || {
            youtube: [],
            twitch: [],
            facebook: [],
            other: [],
          };

          this.outro = this.video.outro || {
          "description": "",
          "title": "",
          "url": "",
          "text": "",
          "text2": "",
          "url2": ""
        }


          
          /*this.externalStreams.youtube = this.externalStreams.youtube ||  [];
          this.externalStreams.facebook = this.externalStreams.facebook ||  [];
          this.externalStreams.twitch = this.externalStreams.twitch ||  [];
          this.externalStreams.other = this.externalStreams.other || [];*/
          console.log("External", this.externalStreams);

          if (video.autoStartExternalStreams) {
            this.autoStartExternal = true;
          } else {
            this.autoStartExternal = false;
          }

          // Add show keys
          this.externalStreams.youtube.forEach((x) => (x._showKey = false));
          this.externalStreams.facebook.forEach((x) => (x._showKey = false));
          this.externalStreams.twitch.forEach((x) => (x._showKey = false));
          this.externalStreams.other.forEach((x) => (x._showKey = false));

          try {
            if (this.video.videoInAndOut) {
              this.listInAndOut = [];
              for (let inAndOut in this.video.videoInAndOut) {
                this.listInAndOut.push(this.video.videoInAndOut[inAndOut]);
              }
            }
          } catch (err) {
            console.log(err);
          }

          if( video.tags && typeof video.tags === "string" )
          {
            this.tags =  video.tags.split('|:|');
          } else 
          {
            this.tags = video.tags;
          }
          console.log(this.tags)
          this.watermarkText = video.watermarkText || "";
          this.description = video.description;
          this.title = video.title;
          this.thumbnailURL = video.manifest.thumbnail;
          console.log(this.thumbnailURL);
          this.computeExtension(video.title);
          this.chapters = video.chapters || [];
          this.chapters_show = video.chapters || [];
          if (video.type === "live") {
            this.isDownload = video.downloadLive || false;
          } else {
            this.isDownload = video.download || false;
          }
          this.isIntroModal = video.introModal || false;
          this.isAutoplay = video.autoplay || false;
          this.isPassword = video.isPassword || false;
          this.isChatLive = video.isChatLive || false;
          this.chapters = this.chapters.map((elem) => {
            var newElem = JSON.parse(JSON.stringify(elem));
            var dateStart = new Date(null);
            dateStart.setSeconds(newElem.start);
            newElem.start = dateStart.toISOString().substr(11, 8);
            var dateEnd = new Date(null);
            dateEnd.setSeconds(newElem.end);
            newElem.end = dateEnd.toISOString().substr(11, 8);

            return newElem;
          });

          if (video.inAndOut) {
            var dateStart = new Date(null);
            dateStart.setSeconds(video.inAndOut.start);
            video.inAndOut.start = dateStart.toISOString().substr(11, 8);
            var dateEnd = new Date(null);
            dateEnd.setSeconds(video.inAndOut.end);
            video.inAndOut.end = dateEnd.toISOString().substr(11, 8);
            this.inAndOut = video.inAndOut;
          } else {
            var dateEnd = new Date(null);
            dateEnd.setSeconds(video.duration);
            this.inAndOut.end = dateEnd.toISOString().substr(11, 8);
          }

          if (video.startDate) {
            console.log(video.startDate);
            var newStartDate = new Date(video.startDate);
            this.liveDate = newStartDate.toISOString();
            this.adjustDateS();
            //            this.liveDate = newStartDate.toISOString().split("T")[0];
            //            this.liveHour = newStartDate.toLocaleTimeString("fr-FR");
          }

          if (video.deleteDate) {
            console.log(video.deleteDate);
            var newDeleteDate = new Date(video.deleteDate);
            //            this.deleteDate = newDeleteDate;
            this.deleteDate = newDeleteDate.toISOString();
            this.adjustDate();
            //            this.deleteHour = newDeleteDate.toLocaleTimeString("fr-FR");
          }

          if (!video.seekLive) {
            this.isSeekLive = false;
          } else {
            this.isSeekLive = video.seekLive;
          }
          if (!video.keepLive) {
            this.isKeepLive = false;
          } else {
            this.isKeepLive = video.keepLive;
          }

          if (video.type === "live" && video.keepLive != true) {
            this.liveToKeepDuration = video.liveToKeepDuration;
          }

          this.chapters_show = this.chapters_show.map((elem) => {
            var newElem = JSON.parse(JSON.stringify(elem));
            var dateStart = new Date(null);
            dateStart.setSeconds(newElem.start);
            newElem.start = dateStart.toISOString().substr(11, 8);
            var dateEnd = new Date(null);
            dateEnd.setSeconds(newElem.end);
            newElem.end = dateEnd.toISOString().substr(11, 8);

            return newElem;
          });

          this.iframeAnalytics =
            `https://platforms3.joada.net/analytics${this.clientView}/d/analytics/analytics?orgId=1&refresh=10s&var-video_id=` +
            video.uuid.substring(0, 8);
          this.iframesrc +=
            `&type=${video.type}&displaymsg=user&analyticsID=` +
            this.clientView +
            "&wm=" +
            this.userView;

          this.directLink =
            EMBED_URL +
            "/embeded.html?uuid=" +
            this.uuid +
            "&type=" +
            video.type +
            "&analyticsID=" +
            this.clientView;

          if (video.inputInfos.indexOf("audio=false") > -1) {
            this.iframesrc += `&audio=0`;
            this.directLink += `&audio=0`;
          }
          if (this.clientView === "zebra") {
            this.iframesrc += `&intro=1`;
          }
          this.embeded =
            '<div style="position:relative;padding-top:56.25%;"><iframe style="position:absolute;top:0;width:100%;height:100%" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" frameBorder="0" scrolling="no" src="' +
            EMBED_URL +
            "/embeded.html?uuid=" +
            this.uuid +
            "&type=" +
            video.type +
            "&analyticsID=" +
            this.clientView;

          this.embeded += '"></iframe></div>';

          this.isVideoLoaded = true;
          this.iframeinit = true;
          this.getExportLinks();

          this.createdAt = this.video.createdAt.split("T")[0];
          this.createdDate = moment(this.video.createdAt).format(
            "DD/MM/YY @HH:mm"
          );
          this.lastModifyAt = moment(this.video.lastModifyAt).format(
            "DD/MM/YY @HH:mm"
          );
          this.authorizationkeyLowerCase =
            this.video.authorizationKey.toLowerCase();

          this.getAcceleratedVod();
          this.resetModal();
          if (
            this.video.type === "live" &&
            this.video.liveType === "quanteecRTMP"
          ) {
            this.getLiveStats();
          }
          if (this.video.type === "live") {
            this.getExternalStats();
          }
        })
        .catch((err) => {
          console.log("Can not find video", this.uuid, err);
          if (err && err.response && err.response.status === 404) {
            this.showModal("errorLoadVideo");
          }
        });
    },

    copyEmbeded() {
      this.$copyText(this.embeded);
    },
    copyMPD() {
      this.$copyText(this.video.manifest.mpd);
    },
    copyM3U8() {
      this.$copyText(this.video.manifest.m3u8);
    },
    copyDirectLink() {
      this.$copyText(this.directLink);
    },
    copyLink(link) {
      this.$copyText(link._iframe);
    },
    copyData(data, value) {
      this.$copyText(data);
    },
    removeVideo() {
      videoService
        .deleteVideoById(this.video.uuid, this.$auth.token())
        .then(() => {
          this.$router.push("/");
        })
        .catch((error) => {
          console.error(error);
        });
    },
    updateDownload() {
      videoService
        .putVideoDownload(this.isDownload, this.video.uuid, this.$auth.token())
        .then(() => {
          this.getVideoFromUuid();
        })
        .catch((err) => {
          this.getVideoFromUuid();
        });
    },
    updateWatermark() {
      videoService
        .putVideoById(
          { watermarkText: this.watermarkText },
          this.video.uuid,
          this.$auth.token()
        )
        .then(() => {
          this.modifyWatermark = false;
          this.getVideoFromUuid();
        })
        .catch((err) => {
          this.getVideoFromUuid();
        });
    },
    updateAutoplay() {
      videoService
        .putVideoById(
          { autoplay: this.isAutoplay },
          this.video.uuid,
          this.$auth.token()
        )
        .then(() => {
          this.getVideoFromUuid();
        })
        .catch((err) => {
          this.getVideoFromUuid();
        });
    },
    updateIntroModal() {
      videoService
        .putVideoById(
          { introModal: this.isIntroModal },
          this.video.uuid,
          this.$auth.token()
        )
        .then(() => {
          this.getVideoFromUuid();
        })
        .catch((err) => {
          this.getVideoFromUuid();
        });
    },
    updateSeekLive() {
      videoService
        .putVideoById(
          { seekLive: this.isSeekLive },
          this.video.uuid,
          this.$auth.token()
        )
        .then(() => {
          this.getVideoFromUuid();
        })
        .catch((err) => {
          this.getVideoFromUuid();
        });
    },
    updateKeepLive() {
      videoService
        .putVideoById(
          { keepLive: this.isKeepLive },
          this.video.uuid,
          this.$auth.token()
        )
        .then(() => {
          this.getVideoFromUuid();
        })
        .catch((err) => {
          this.getVideoFromUuid();
        });
    },

    updateFastIO() {
      this.isFastIO = !this.isFastIO;
    },

    emptyPass() {
      this.password = "";
    },
    updatePassword() {
      if (this.password === "") this.isPassword = false;
      else this.isPassword = true;

      videoService
        .putVideoById(
          { isPassword: this.isPassword, password: this.password },
          this.video.uuid,
          this.$auth.token()
        )
        .then(() => {
          if (this.password)
            this.$bvToast.toast("Password updated to access the stream", {
              title: "Password",
            });
          else
            this.$bvToast.toast("Password removed to access the stream", {
              title: "Password",
            });

          this.password = "";
          this.getVideoFromUuid();
        })
        .catch((err) => {});
    },
    updateChatLive() {
      videoService
        .putVideoById(
          { isChatLive: this.isChatLive, password: this.password },
          this.video.uuid,
          this.$auth.token()
        )
        .then(() => {
          if (this.password)
            this.$bvToast.toast(
              "The live chat will be activated for this video",
              { title: "Live Chat" }
            );
          else
            this.$bvToast.toast(
              "The live chat will be deactivated for this video",
              { title: "Password" }
            );

          this.password = "";
          this.getVideoFromUuid();
        })
        .catch((err) => {});
    },
    updateTags() {
      var tags = this.tags
      videoService
        .putVideoById({ tags: tags }, this.video.uuid, this.$auth.token())
        .then(() => {})
        .catch((err) => {});
    },
    updateDescription() {
      videoService
        .putVideoById(
          { description: this.description },
          this.video.uuid,
          this.$auth.token()
        )
        .then(() => {
          this.modifyDescription = false;
          this.video.description = this.description;
        })
        .catch((err) => {});
    },
    updateSourcePath() {
      videoService
        .putVideoById(
          { sourcePath: this.modifiedSourcePath },
          this.video.uuid,
          this.$auth.token()
        )
        .then(() => {
          this.modifySourcePath = false;
          this.video.sourcePath = this.sourcePath;
          this.sourcePathHasBeenModified = true;
          this.showModal("sourcePathChanged");
        })
        .catch((err) => {});
    },
    cancelDescription() {
      this.description = this.video.description;
      this.modifyDescription = false;
    },
    cancelWatermark() {
      this.watermarkText = this.video.watermarkText;
      this.modifyWatermark = false;
    },
    cancelSourcePath() {
      this.sourcePath = this.video.sourcePath;
      this.isUpdateSource = false;
    },
    updateLiveToKeepDuration() {
      videoService
        .putVideoById(
          { liveToKeepDuration: this.liveToKeepDuration },
          this.video.uuid,
          this.$auth.token()
        )
        .then(() => {
          this.isUpdateLiveToKeep = false;
          this.video.liveToKeepDuration = this.liveToKeepDuration;
        })
        .catch((err) => {});
    },
    cancelLiveToKeepDuration() {
      this.sourcePath = this.video.liveToKeepDuration;
      this.isUpdateLiveToKeep = false;
    },

    addandPutChapterFile(event) {
      this.addChapterFile(event);
      this.putChapterFile();
      this.chapters = this.chapters.splice(0);
    },
    addChapterFile(event) {
      try {
        this.fileChapters = event.target.files[0];
      } catch (err) {}
    },
    putChapterFile() {
      if (this.fileChapters !== null) {
        var form = new FormData();
        form.append("video", this.fileChapters, this.fileChapters.filename);
        videoService
          .putChaptersFile(this.video.uuid, form, this.$auth.token())
          .then((video) => {
            this.chapters = video.chapters || [];
            this.chapters = this.chapters.map((elem) => {
              var newElem = JSON.parse(JSON.stringify(elem));
              var dateStart = new Date(null);
              dateStart.setSeconds(newElem.start);
              newElem.start = dateStart.toISOString().substr(11, 8);
              var dateEnd = new Date(null);
              dateEnd.setSeconds(newElem.end);
              newElem.end = dateEnd.toISOString().substr(11, 8);
              this.getVideoFromUuid();
              this.chapters = this.chapters.splice(0);

              return newElem;
            });
          })
          .catch((err) => {
            console.log(err);
            if (err.response && err.response.status === 400) {
              this.errorChapterDate = true;
              console.log(error.response.status);
            }
          });
      }
    },

    updateChapters() {
      var myChapters = this.chapters.map((elem) => {
        var newElem = JSON.parse(JSON.stringify(elem));
        var start = newElem.start.split(":");
        newElem.start = +start[0] * 60 * 60 + +start[1] * 60 + +start[2];
        var end = newElem.end.split(":");
        newElem.end = +end[0] * 60 * 60 + +end[1] * 60 + +end[2];
        return newElem;
      });

      videoService
        .putChapters(
          { chapters: myChapters },
          this.video.uuid,
          this.$auth.token()
        )
        .then(() => {
          this.modifyChapters = false;
          this.getVideoFromUuid();
          this.chapters = this.chapters.splice(0);
          this.errorChapterDate = false;
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status === 400) {
            this.errorChapterDate = true;
            console.log(err.response.status);
          }
        });
    },
    removeChapter(index) {
      this.chapters.splice(index, 1);
    },
    deleteChapters() {
      videoService
        .putChapters({ chapters: [] }, this.video.uuid, this.$auth.token())
        .then(() => {
          this.chapters = [];
          this.getVideoFromUuid();
          this.chapters = this.chapters.splice(0);
        })
        .catch((err) => {});
    },
    cancelChapters() {
      if (this.video.chapters != undefined) {
        this.chapters = this.video.chapters;
        this.chapters = this.chapters.splice(0);
      } else {
        this.chapters = [];
        this.chapters = this.chapters.splice(0);
      }
      this.modifyChapters = false;
      this.getVideoFromUuid();
    },
    getExportLinks() {
      if (this.video && this.video.uuid) {
        iframeService
          .getIframes(this.$auth.token(), {
            filter: JSON.stringify({ video: this.video.uuid }),
            sort: JSON.stringify({ createdAt: -1 }),
          })
          .then((exportlinks) => {
            let self = this;
            this.exportLinks = exportlinks._embedded;

            this.exportLinks.forEach((elem) => {
              elem._direct = self.createExportUrlForID(elem.uuid);
              elem._iframe = self.createExportCompleteForID(elem.uuid);
            });
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    createExportUrlForID(iframeID) {
      return (
        EMBED_URL +
        "/embeded.html?uuid=" +
        iframeID +
        "&analyticsID=" +
        this.clientView +
        "&exp=1"
      );
    },
    createExportCompleteForID(iframeID) {
      let result =
        '<iframe id="video-player" style="width:100%;height:100%" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" frameBorder="0" scrolling="no" src="';
      let iframeSource = this.createExportUrlForID(iframeID);

      result += iframeSource;
      result += '"></iframe>';
      return result;
    },

    updateTitle() {
      videoService
        .putVideoById(
          { title: this.title },
          this.video.uuid,
          this.$auth.token()
        )
        .then(() => {
          this.modifyTitle = false;
        })
        .catch((err) => {});
    },
    cancelTitle() {
      this.title = this.video.title;
      this.modifyTitle = false;
    },

    showAndHideModal(ref) {
      let self = this;
      self.showModal(ref);
      setTimeout(function () {
        self.hideModal(ref);
      }, 3000);
    },
    //Get analytics data about the video
    getAnalytics(date) {
      analyticsService
        .getAnalytics(this.$auth.token(), this.video.authorizationKey, date)
        .then((response) => {
          let agg = response.data.aggregations;
          this.nbViews = agg.nbVues.value;
          this.TotalDelivered = Math.round(
            agg.Tot_Mb_Peer.value + agg.Tot_Mb_Server.value / 1000
          );
          let sec_server = agg.sum_sec_server.value;
          let sec_rebuf = agg.sum_sec_rebuff.value;
          let sec_peer = agg.sum_sec_peer.value;
          let bitrate = this.TotalDelivered / (sec_server + sec_peer);
          let percent_sec_rebuf =
            (100 * sec_rebuf) / (sec_rebuf + sec_server + sec_peer);
          let percent_offload =
            (100 * agg.Tot_Mb_Peer.value) /
            (agg.Tot_Mb_Peer.value + agg.Tot_Mb_Server.value);
          if (isNaN(percent_sec_rebuf)) {
            this.percent_rebuf = 0;
          } else {
            this.percent_rebuf = Math.round(percent_sec_rebuf);
          }
          if (isNaN(percent_offload)) {
            this.percent_offload = 0;
          } else {
            this.percent_offload = Math.round(percent_offload);
          }
          if (isNaN(bitrate)) {
            this.bitrate = 0;
          } else {
            this.bitrate = Math.round(bitrate * 100) / 100;
          }
          let timeview = (sec_server + sec_peer) / 3600;
          this.hoursView = Math.floor(timeview);
          var decimal = timeview - Math.floor(timeview);
          this.minutesView = Math.floor(decimal * 60);
          this.averageTime = Math.floor((timeview * 60) / this.nbViews);
        });
    },
    verifyChapterEnd(event, index, startOrEnd) {
      event = this.chapters[index][startOrEnd];
      console.log(event);
      if (
        event.indexOf("HH") === -1 &&
        event.indexOf("mm") === -1 &&
        event.indexOf("ss") === -1
      ) {
        let table = event.split(":");
        let chapDuration = +table[0] * 60 * 60 + +table[1] * 60 + +table[2];
        let duration = this.video.duration;
        if (duration && duration > 0 && chapDuration > duration) {
          let dateEnd = new Date(null);
          dateEnd.setSeconds(duration);
          let newInputValue = dateEnd.toISOString().substr(11, 8);
          this.chapters[index][startOrEnd] = newInputValue;
        }
      }
    },
    goToProject(projectId, projectVersion) {
      this.$router.push("/vireed/" + projectId + "/" + projectVersion);
    },
    accelerateVideo() {
      this.modifyAcceleration = true;
      if (this.video.cloudflare) {
        videoService
          .putVideoAccelerate(this.video.uuid, this.$auth.token())
          .then(() => {
            this.modifyAcceleration = false;
            this.getVideoFromUuid();
          })
          .catch((err) => {
            this.modifyAcceleration = false;
            this.getVideoFromUuid();
          });
      } else {
        videoService
          .deleteVideoAccelerate(this.video.uuid, this.$auth.token())
          .then(() => {
            this.modifyAcceleration = false;
            this.getVideoFromUuid();
          })
          .catch((err) => {
            this.modifyAcceleration = false;
            this.getVideoFromUuid();
          });
      }
    },
    bunnyCDNVideo() {
      this.modifyBunnyCDN = true;
      if (this.video.bunnycdn) {
        videoService
          .putVideoById({ bunnycdn: true }, this.video.uuid, this.$auth.token())
          .then(() => {
            this.modifyBunnyCDN = false;
            this.getVideoFromUuid();
          })
          .catch((err) => {
            this.modifyBunnyCDN = false;
            this.getVideoFromUuid();
          });
      } else {
        videoService
          .putVideoById(
            { bunnycdn: false },
            this.video.uuid,
            this.$auth.token()
          )
          .then(() => {
            this.modifyBunnyCDN = false;
            this.getVideoFromUuid();
          })
          .catch((err) => {
            this.modifyBunnyCDN = false;
            this.getVideoFromUuid();
          });
      }
    },
    startExternalStreams() {
      this.isLoadingStartExternalStreams = true;
      videoService
        .putExternalStreamsStart(this.video.uuid, this.$auth.token())
        .then(() => {
          console.log("Stream started");
          this.isLoadingStartExternalStreams = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoadingStartExternalStreams = false;
        });
    },
    stopExternalStreams() {
      this.isLoadingStopExternalStreams = true;
      videoService
        .putExternalStreamsStop(this.video.uuid, this.$auth.token())
        .then(() => {
          console.log("Stream stopped");
          this.isLoadingStopExternalStreams = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoadingStopExternalStreams = false;
        });
    },
    onExternalStreams() {
      this.isLoadingModifyExternalStreams = true;
      videoService
        .putExternalStreams(
          this.video.uuid,
          this.externalStreams,
          this.$auth.token()
        )
        .then(() => {
          console.log("success");
          this.isLoadingModifyExternalStreams = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoadingModifyExternalStreams = false;
        });
      this.hideModal("modifyExternalStreams");
    },
    onAutoStart() {
      videoService
        .putVideoById(
          { autoStartExternalStreams: this.autoStartExternal },
          this.video.uuid,
          this.$auth.token()
        )
        .then(() => {})
        .catch((err) => {
          console.log(err);
        });
    },
    imgUrlAlt(event, video) {
      video = video || this.video;
      if (video.type === "live") {
        event.target.src = `/thumbnaillive.jpg`;
      } else if (video.encodingStatus === "encoding") {
        event.target.src = `/thumbnail2.jpg`;
      } else {
        event.target.src = `/thumbnail.jpg`;
      }
    },
    getAcceleratedVod() {
      videoService
        .getVideoCloudflares(this.video.uuid, this.$auth.token())
        .then((streams) => {
          this.acceleratedVoD = streams.filter((x) => x.readyToStream);
        })
        .catch((err) => {
          console.log(err);
          this.acceleratedVoD = [];
        });
    },
    postDownloadMpd(vod) {
      videoService
        .postDownloadMpd(this.video.uuid, vod, this.$auth.token())
        .then((streams) => {
          this.getVideoFromUuid();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openLiveWebcam() {
      let uuid = this.video.uuid;
      EventBus.$emit("windowLive", { specificVideoID: uuid });
      this.forceCheckEncoding = true;
    },
    addQuality() {
      var newQuality = {
        bitrate: 5000,
        resolution: {
          height: 1080,
          width: 1920,
        },
        FPS: 30,
      };
      this.qualitiesModal.push(newQuality);
    },
    removeQuality(idx) {
      this.qualitiesModal.splice(idx, 1);
    },
    resetModal() {
      this.qualitiesModal =
        this.video.encoding !== "passthrough" &&
        this.video.inputQualities !== "QuanteecOptimization"
          ? this.video.inputQualities
          : [];
      this.qualitiesSelection =
        this.video.encoding === "passthrough"
          ? "passthrough"
          : this.video.inputQualities === "QuanteecOptimization"
          ? "default"
          : "qualities";
      this.firstPass =
        this.video.type === "live" ? false : this.video.firstPass;
    },
    openOutroUpdate() {
      
      this.video._outro = this.video.outro || {
        "description": "",
        "title": "",
        "url": "",
        "text": "",
        "text2": "",
        "url2": ""
      }

      console.log(this.video._outro)

    },
    updateDefaultOutroVideo() {
      let formdata = new FormData();
      let outro = this.currentOutro;
      formdata.append('title', outro.title);
      formdata.append('description', outro.description);
      formdata.append('url', outro.url);
      formdata.append('text', outro.text);
      formdata.append('url2', outro.url2);
      formdata.append('text2', outro.text2);
      formdata.append('img_base', outro.img_base);

      videoService.postOutro(this.video.uuid, formdata, this.$auth.token()).then(video => {
        this.video.outro = video.outro;
        this.outro = video.outro;
        this.hideModal('updateOutro');
        this.getVideoFromUuid();
      }).catch(err => {
        this.hideModal('updateOutro');
        this.showModal('errorOutro');
      })
    },
    updateOutroVideo() {
      let formdata = new FormData();
      let outro = this.outro;
      let customPicture = this.customPicture;
      formdata.append('title', outro.title);
      formdata.append('description', outro.description);
      formdata.append('url', outro.url);
      formdata.append('text', outro.text);
      formdata.append('url2', outro.url2);
      formdata.append('text2', outro.text2);
      if (customPicture && customPicture.name) {
        formdata.append('pictures', customPicture, customPicture.name);
      } else if (outro.img_base) {
        formdata.append('img_base', outro.img_base)
      }

      videoService.postOutro(this.video.uuid, formdata, this.$auth.token()).then(video => {
        this.video.outro = video.outro;
        this.outro = video.outro;
        this.hideModal('updateOutro');
        this.getVideoFromUuid();
      }).catch(err => {
        this.hideModal('updateOutro');
        this.showModal('errorOutro');
      })

    }
  },
};
</script>

<style scoped lang="scss">
h6 {
  margin-bottom: 0.05rem;
  font-size: 1.2rem;
}

.resp-container {
  width: 100%;
  padding-top: 56.25%;
  border: 1px solid;
  border-color: lightgrey;
  border-radius: 5px;
  position: relative;
  background-color: black;
}
.resp-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

.resp-iframe-unfocused {
  position: fixed;
  z-index: 10;
  top: auto;
  left: auto;
  bottom: 0;
  right: 0;
  width: 33vw;
  height: calc(33vw * 9 / 16);
}

.author {
  font-style: italic;
  color: grey;
  font-size: 1.3em;
}

.titleSec {
  text-align: center;
  font-weight: bold;
  color: #2a5d77;
  padding-bottom: 10px;
  margin-bottom: 15px;
  border-bottom: 1px solid #2a5d77;
}

.badge:empty {
  display: inline-block;
}

.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.rowPointer {
  cursor: pointer;
}

a[class^="share-network-"] {
  flex: none;
  color: #ffffff;
  background-color: #333;
  border-radius: 3px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  cursor: pointer;
  margin: 0 10px 10px 0;
  max-width: 180px;
  height: 35px;
}
a[class^="share-network-"] .fah {
  background-color: rgba(0, 0, 0, 0.2);
  flex: 0 1 auto;
  padding: 6px;
  height: 100px;
  width: 30px;
}
a[class^="share-network-"] span {
  padding: 0 10px;
  flex: 1 1 0%;
  font-weight: 500;
}

sup {
  top: -0.5em;
  position: relative;
  font-size: 85%;
  line-height: 0;
  vertical-align: baseline;
}

small {
  font-size: 14px !important;
}

.quanteecyoutubevalide {
  color: #ff0000;
}

.quanteecfacebookvalide {
  color: #4267b2;
}

.quanteectwitchvalide {
  color: #9146ff;
}

.quanteecothervalide {
  color: rgb(20, 191, 152);
}

.quanteecyoutube {
  cursor: pointer;
  transition: 0.15s all ease-in-out;
  &:hover {
    color: #ff0000;
  }
}

.quanteecfacebook {
  cursor: pointer;
  transition: 0.15s all ease-in-out;
  &:hover {
    color: #4267b2;
  }
}

.quanteectwitch {
  cursor: pointer;
  transition: 0.15s all ease-in-out;
  &:hover {
    color: #9146ff;
  }
}

.quanteecother {
  cursor: pointer;
  transition: 0.15s all ease-in-out;
  &:hover {
    color: rgb(20, 191, 152);
  }
}

.unselectedChoice2 {
  border: 3px solid;
  border-radius: 10px;
  border-color: rgba(grey, 1);
  box-shadow: rgba(#0f182f, 0.117647) 1px 2px 7px,
    rgba(#0f182f, 0.117647) 1px 2px 7px;
}

.selectedChoice2 {
  border: 3px solid;
  border-radius: 10px;
  //border-color: rgba(#19b952, 1);
  border-color: rgba(#14bf98, 1);
  box-shadow: rgba(#0f182f, 0.3) 1px 2px 7px, rgba(#0f182f, 0.3) 1px 2px 7px;
}

.commonChoice2 {
  text-align: center;
  min-height: 120px;
  font-weight: 400;
  font-size: 1.1rem;
  color: #2a5d77;
  cursor: pointer;
  margin: 10px;
  padding: 5px;
}

.commonChoice3 {
  text-align: center;
  min-height: 70px;
  font-weight: 400;
  font-size: 1.1rem;
  color: #2a5d77;
  cursor: pointer;
  margin: 2px;
  padding: 2px;
}

.unselectedChoice {
  border: 4px solid;
  border-radius: 10px;
  border-color: rgba(grey, 1);
  box-shadow: rgba(#0f182f, 0.117647) 1px 2px 7px,
    rgba(#0f182f, 0.117647) 1px 2px 7px;
}

.selectedChoice {
  border: 4px solid;
  border-radius: 10px;
  //border-color: rgba(#19b952, 1);
  border-color: rgba(#ba0000, 1);
  box-shadow: rgba(#0f182f, 0.3) 1px 2px 7px, rgba(#0f182f, 0.3) 1px 2px 7px;
}

.commonChoice {
  text-align: center;
  min-height: 60px;
  font-weight: 500;
  font-size: 2rem;
  color: black;
  cursor: pointer;
}

.liveBrand {
  text-align: center;
  font-size: 3em;
}



.picture-grid {
    display: grid;
    grid-gap: 10px;
    align-items: center;
    justify-content: center;
}

.picture-item {
     grid-column: span 1;
     position: relative;
     padding-top: 56.25%;
     width:100%;
     transition: .15s all ease-in-out;
     &:hover {
        transform: scale(1.03)
    }
    cursor: pointer;
}

.picture-item-img {
    position:absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    object-fit: contain;width: 100%;
    height: 100%;
}

.picture-grid-size {
    grid-template-columns: repeat(3, 1fr);
}

@media all and (min-width: 768px) {
    .picture-grid-size {
        grid-template-columns: repeat(6, 1fr);
    }
}

.picture-selected {
  border: 2px dashed red;
}
</style>